import { store } from '../Store/Store'

export function getNaceCodeText(naceCode: string): string | undefined {
  const language = store.getState().interface.activeLanguage
  return (
    NaceCodes.find((nc) => nc.code === naceCode) as Record<string, string>
  )?.[language]
}

export function getNaceSelectOptions(): Array<{
  value: string
  label: string
}> {
  const language = store.getState().interface.activeLanguage
  return NaceCodes.map((nc) => ({
    value: nc.code,
    label: `${nc.code}: ${(nc as Record<string, string>)[language]}`,
  }))
}

export const NaceCodes: Array<{
  code: string
  nl: string
  fr: string
  en: string
  de?: string
}> = [
  {
    code: '0111',
    nl: 'Teelt van andere granen dan rijst, en van peulgewassen en oliehoudende zaden',
    fr: 'Culture de céréales, à l’exception du riz, et de légumineuses et de graines oléagineuses',
    en: 'Growing of cereals, other than rice, leguminous crops and oil seeds',
    de: 'Anbau von anderem Getreide als Reis sowie von Hülsenfrüchten und Ölsaaten',
  },
  {
    code: '0112',
    nl: 'Teelt van rijst',
    fr: 'Culture du riz',
    en: 'Growing of rice',
    de: 'Anbau von Reis',
  },
  {
    code: '0113',
    nl: 'Teelt van groenten, meloenen en wortel- en knolgewassen',
    fr: 'Culture de légumes, de melons, de racines et de tubercules',
    en: 'Growing of vegetables and melons, roots and tubers',
    de: 'Anbau von Gemüse und Melonen sowie Wurzeln und Knollen',
  },
  {
    code: '0114',
    nl: 'Teelt van suikerriet',
    fr: 'Culture de la canne à sucre',
    en: 'Growing of sugar cane',
    de: 'Anbau von Zuckerrohr',
  },
  {
    code: '0115',
    nl: 'Teelt van tabak',
    fr: 'Culture du tabac',
    en: 'Growing of tobacco',
    de: 'Anbau von Tabak',
  },
  {
    code: '0116',
    nl: 'Teelt van vezelgewassen',
    fr: 'Culture de plantes à fibres',
    en: 'Growing of fibre crops',
    de: 'Anbau von Faserpflanzen',
  },
  {
    code: '0119',
    nl: 'Teelt van andere eenjarige gewassen',
    fr: 'Autres cultures non permanentes',
    en: 'Growing of other non-perennial crops',
    de: 'Anbau von sonstigen ein- und zweijährigen Pflanzen',
  },
  {
    code: '01191',
    nl: 'Teelt van bloemen',
    fr: 'Culture de fleurs',
    en: 'Growing of flowers',
    de: 'Blumenbau',
  },
  {
    code: '01199',
    nl: 'Teelt van andere eenjarige gewassen, n.e.g.',
    fr: 'Autres cultures non permanentes n.c.a.',
    en: 'Growing of other non-perennial crops n.e.c.',
    de: 'Sonstiger Anbau einjähriger Pflanzen a.n.g.',
  },
  {
    code: '0121',
    nl: 'Teelt van druiven',
    fr: 'Culture de la vigne',
    en: 'Growing of grapes',
    de: 'Anbau von Wein- und Tafeltrauben',
  },
  {
    code: '0122',
    nl: 'Teelt van tropisch en subtropisch fruit',
    fr: 'Culture de fruits tropicaux et subtropicaux',
    en: 'Growing of tropical and subtropical fruits',
    de: 'Anbau von tropischen und subtropischen Früchten',
  },
  {
    code: '0123',
    nl: 'Teelt van citrusvruchten',
    fr: 'Culture d’agrumes',
    en: 'Growing of citrus fruits',
    de: 'Anbau von Zitrusfrüchten',
  },
  {
    code: '0124',
    nl: 'Teelt van pit- en steenvruchten',
    fr: 'Culture de fruits à pépins et à noyau',
    en: 'Growing of pome fruits and stone fruits',
    de: 'Anbau von Kern- und Steinobst',
  },
  {
    code: '0125',
    nl: 'Teelt van andere boomvruchten, kleinfruit en noten',
    fr: 'Culture d’autres fruits d’arbres ou d’arbustes et de fruits à coque',
    en: 'Growing of other tree and bush fruits and nuts',
    de: 'Anbau von sonstigem Obst und Nüssen',
  },
  {
    code: '0126',
    nl: 'Teelt van oliehoudende vruchten',
    fr: 'Culture de fruits oléagineux',
    en: 'Growing of oleaginous fruits',
    de: 'Anbau von ölhaltigen Früchten',
  },
  {
    code: '0127',
    nl: 'Teelt van gewassen bestemd voor de vervaardiging van dranken',
    fr: 'Culture de plantes à boissons',
    en: 'Growing of beverage crops',
    de: 'Anbau von Pflanzen zur Herstellung von Getränken',
  },
  {
    code: '0128',
    nl: 'Teelt van specerijgewassen en van aromatische en medicinale gewassen',
    fr: 'Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques',
    en: 'Growing of spices, aromatic, drug and pharmaceutical crops',
    de: 'Anbau von Gewürzpflanzen, Pflanzen für aromatische, narkotische und pharmazeutische Zwecke',
  },
  {
    code: '0129',
    nl: 'Teelt van andere meerjarige gewassen',
    fr: 'Autres cultures permanentes',
    en: 'Growing of other perennial crops',
    de: 'Anbau sonstiger mehrjähriger Pflanzen',
  },
  {
    code: '0130',
    nl: 'Plantenvermeerdering',
    fr: 'Reproduction de plantes',
    en: 'Plant propagation',
    de: 'Betrieb von Baumschulen sowie Anbau von Pflanzen zu Vermehrungszwecken',
  },
  {
    code: '01301',
    nl: 'Boomkwekerijen, m.u.v. bosboomkwekerijen',
    fr: 'Exploitation de pépinières, sauf pépinières forestières',
    en: 'Operation of tree nurseries, except forest nurseries',
    de: 'Baumschulen mit Ausnahme von Forstbaumschulen',
  },
  {
    code: '01309',
    nl: 'Overige plantenvermeerdering',
    fr: 'Autre reproduction de plantes',
    en: 'Other plant propagation',
    de: 'Sonstige Pflanzenvermehrung',
  },
  {
    code: '0141',
    nl: 'Fokken en houden van melkvee',
    fr: 'Élevage de vaches laitières',
    en: 'Raising of dairy cattle',
    de: 'Haltung von Milchkühen',
  },
  {
    code: '0142',
    nl: 'Fokken en houden van andere runderen en buffels',
    fr: 'Élevage d’autres bovins et de buffles',
    en: 'Raising of other cattle and buffaloes',
    de: 'Haltung von sonstigen Rindern',
  },
  {
    code: '0143',
    nl: 'Fokken en houden van paarden en andere paardachtigen',
    fr: 'Élevage de chevaux et d’autres équidés',
    en: 'Raising of horses and other equines',
    de: 'Haltung von Pferden und Eseln',
  },
  {
    code: '0144',
    nl: 'Fokken en houden van kamelen en andere kameelachtigen',
    fr: 'Élevage de chameaux et d’autres camélidés',
    en: 'Raising of camels and camelids',
    de: 'Haltung von Kamelen',
  },
  {
    code: '0145',
    nl: 'Fokken en houden van schapen en geiten',
    fr: 'Élevage d’ovins et de caprins',
    en: 'Raising of sheep and goats',
    de: 'Haltung von Schafen und Ziegen',
  },
  {
    code: '0146',
    nl: 'Fokken en houden van varkens',
    fr: 'Élevage de porcins',
    en: 'Raising of swine and pigs',
    de: 'Haltung von Schweinen',
  },
  {
    code: '01461',
    nl: 'Fokvarkenshouderijen',
    fr: 'Élevage de porcs reproducteurs',
    en: 'Raising of breeding pigs',
    de: 'Zucht von Zuchtschweinen',
  },
  {
    code: '01462',
    nl: 'Varkensvetmesterijen',
    fr: "Élevage de porcs à l'engrais",
    en: 'Raising of fattening pigs',
    de: 'Mastschweinezucht',
  },
  {
    code: '0147',
    nl: 'Fokken en houden van pluimvee',
    fr: 'Élevage de volailles',
    en: 'Raising of poultry',
    de: 'Haltung von Geflügel',
  },
  {
    code: '01471',
    nl: 'Kippenkwekerijen',
    fr: 'Elevage de poules',
    en: 'Raising of hens',
    de: 'Hühnerzucht',
  },
  {
    code: '01472',
    nl: 'Productie van eieren van pluimvee',
    fr: 'Production d’œufs de volailles',
    en: 'Production of poultry eggs',
    de: 'Produktion von Geflügeleiern',
  },
  {
    code: '01479',
    nl: 'Pluimveehouderijen, m.u.v. kippenkwekerijen',
    fr: "Élevage d'autres volailles, sauf poules",
    en: 'Raising of other poultry, excluding hens',
    de: 'Geflügelzucht, mit Ausnahme von Hühnern',
  },
  {
    code: '0148',
    nl: 'Fokken en houden van andere dieren',
    fr: 'Élevage d’autres animaux',
    en: 'Raising of other animals',
    de: 'Sonstige Tierhaltung',
  },
  {
    code: '0150',
    nl: 'Gemengd landbouwbedrijf',
    fr: 'Culture et élevage associés',
    en: 'Mixed farming',
    de: 'Gemischte Landwirtschaft',
  },
  {
    code: '0161',
    nl: 'Ondersteunende activiteiten in verband met de teelt van gewassen',
    fr: 'Activités de soutien aux cultures',
    en: 'Support activities for crop production',
    de: 'Erbringung von landwirtschaftlichen Dienstleistungen für den Pflanzenbau',
  },
  {
    code: '0162',
    nl: 'Ondersteunende activiteiten in verband met de veeteelt',
    fr: 'Activités de soutien à la production animale',
    en: 'Support activities for animal production',
    de: 'Erbringung von landwirtschaftlichen Dienstleistungen für die Tierhaltung',
  },
  {
    code: '0163',
    nl: 'Behandeling van gewassen na de oogst en van zaden voor vermeerdering',
    fr: 'Traitement primaire des récoltes et traitement des semences',
    en: 'Post-harvest crop activities and seed processing for propagation',
    de: 'Nach der Ernte anfallende Tätigkeiten in der pflanzlichen Erzeugung und Saatgutaufbereitung',
  },
  {
    code: '0170',
    nl: 'Jacht, zetten van vallen en diensten in verband met deze activiteiten',
    fr: 'Chasse, piégeage et activités de service connexes',
    en: 'Hunting, trapping and related service activities',
    de: 'Jagd, Fallenstellerei und damit verbundene Tätigkeiten',
  },
  {
    code: '0210',
    nl: 'Bosbouw en bosbouwactiviteiten',
    fr: 'Sylviculture et autres activités forestières',
    en: 'Silviculture and other forestry activities',
    de: 'Forstwirtschaft',
  },
  {
    code: '0220',
    nl: 'Exploitatie van bossen',
    fr: 'Exploitation forestière',
    en: 'Logging',
    de: 'Holzeinschlag',
  },
  {
    code: '0230',
    nl: 'Verzamelen van in het wild groeiende producten met uitzondering van hout',
    fr: 'Récolte de produits forestiers non ligneux poussant à l’état sauvage',
    en: 'Gathering of wild growing non-wood products',
    de: 'Sammeln von wildwachsenden Produkten, ohne Holz',
  },
  {
    code: '0240',
    nl: 'Ondersteunende diensten in verband met de bosbouw',
    fr: 'Activités de soutien à l’exploitation forestière',
    en: 'Support services to forestry',
    de: 'Erbringung von Dienstleistungen für Forstwirtschaft und Holzeinschlag',
  },
  {
    code: '0311',
    nl: 'Zeevisserij',
    fr: 'Pêche en mer',
    en: 'Marine fishing',
    de: 'Meeresfischerei',
  },
  {
    code: '0312',
    nl: 'Binnenvisserij',
    fr: 'Pêche en eau douce',
    en: 'Freshwater fishing',
    de: 'Süßwasserfischerei',
  },
  {
    code: '0321',
    nl: 'Mariene aquacultuur',
    fr: 'Aquaculture en mer',
    en: 'Marine aquaculture',
    de: 'Meeresaquakultur',
  },
  {
    code: '0322',
    nl: 'Aquacultuur in zoet water',
    fr: 'Aquaculture en eau douce',
    en: 'Freshwater aquaculture',
    de: 'Süßwasseraquakultur',
  },
  {
    code: '0330',
    nl: 'Ondersteunende activiteiten voor visserij en aquacultuur',
    fr: 'Activités de soutien à la pêche et l’aquaculture',
    en: 'Support activities for fishing and aquaculture',
    de: 'Erbringung von Dienstleistungen für Fischerei und Aquakultur',
  },
  {
    code: '0510',
    nl: 'Winning van steenkool',
    fr: 'Extraction de houille',
    en: 'Mining of hard coal',
    de: 'Steinkohlenbergbau',
  },
  {
    code: '0520',
    nl: 'Winning van bruinkool',
    fr: 'Extraction de lignite',
    en: 'Mining of lignite',
    de: 'Braunkohlenbergbau',
  },
  {
    code: '0610',
    nl: 'Winning van aardolie',
    fr: 'Extraction de pétrole brut',
    en: 'Extraction of crude petroleum',
    de: 'Gewinnung von Erdöl',
  },
  {
    code: '0620',
    nl: 'Winning van aardgas',
    fr: 'Extraction de gaz naturel',
    en: 'Extraction of natural gas',
    de: 'Gewinnung von Erdgas',
  },
  {
    code: '0710',
    nl: 'Winning van ijzererts',
    fr: 'Extraction de minerais de fer',
    en: 'Mining of iron ores',
    de: 'Eisenerzbergbau',
  },
  {
    code: '0721',
    nl: 'Winning van uranium- en thoriumerts',
    fr: 'Extraction de minerais d’uranium et de thorium',
    en: 'Mining of uranium and thorium ores',
    de: 'Bergbau auf Uran- und Thoriumerze',
  },
  {
    code: '0729',
    nl: 'Winning van andere non-ferrometaalertsen',
    fr: 'Extraction d’autres minerais de métaux non ferreux',
    en: 'Mining of other non-ferrous metal ores',
    de: 'Sonstiger NE-Metallerzbergbau',
  },
  {
    code: '0811',
    nl: 'Winning van siersteen, kalksteen, gips, leisteen en andere steen',
    fr: 'Extraction de pierres ornementales, de calcaire industriel, de gypse, d’ardoise et d’autres pierres',
    en: 'Quarrying of ornamental stone, limestone, gypsum, slate and other stone',
    de: 'Gewinnung von Naturwerksteinen, Kalk- und Gipsstein, Schiefer und sonstigem Gestein',
  },
  {
    code: '08111',
    nl: 'Winning van sier- en bouwsteen',
    fr: 'Extraction de pierres ornementales et de construction',
    en: 'Quarrying of ornamental and building stone',
    de: 'Gewinnung von Naturwerksteinen und Bausteinen',
  },
  {
    code: '08112',
    nl: 'Winning van kalksteen, gips, leisteen en andere steen',
    fr: "Extraction de pierres calcaires, de gypse et d'ardoise et d’autres pierres",
    en: 'Quarrying of limestone, gypsum, slate and other stone',
    de: 'Gewinnung von Kalk- und Gipsstein, Schiefer und sonstigem Gestein',
  },
  {
    code: '0812',
    nl: 'Winning van grind, zand, klei en kaolien',
    fr: 'Exploitation de gravières et sablières, extraction d’argiles et de kaolin',
    en: 'Operation of gravel and sand pits and mining of clay and kaolin',
    de: 'Gewinnung von Kies und Sand, Ton und Kaolin',
  },
  {
    code: '08121',
    nl: 'Winning van grind',
    fr: 'Extraction de gravières',
    en: 'Extraction of gravel',
    de: 'Gewinnung von Kies',
  },
  {
    code: '08122',
    nl: 'Winning van zand',
    fr: 'Extraction de sablières',
    en: 'Extraction of sand',
    de: 'Gewinnung von Sand',
  },
  {
    code: '08123',
    nl: 'Winning van klei en kaolien',
    fr: "Extraction d'argiles et de kaolin",
    en: 'Extraction of clay and kaolin',
    de: 'Abbau von Lehm, feuerfestem Lehm und Kaolin',
  },
  {
    code: '0891',
    nl: 'Winning van mineralen voor de chemische en de kunstmestindustrie',
    fr: 'Extraction de minéraux chimiques et d’engrais minéraux',
    en: 'Mining of chemical and fertiliser minerals',
    de: 'Bergbau auf chemische und Düngemittelminerale',
  },
  {
    code: '0892',
    nl: 'Winning van turf',
    fr: 'Extraction de tourbe',
    en: 'Extraction of peat',
    de: 'Torfgewinnung',
  },
  {
    code: '0893',
    nl: 'Zoutwinning',
    fr: 'Production de sel',
    en: 'Extraction of salt',
    de: 'Gewinnung von Salz',
  },
  {
    code: '0899',
    nl: 'Overige winning van delfstoffen, n.e.g.',
    fr: 'Autres activités extractives n.c.a.',
    en: 'Other mining and quarrying n.e.c.',
    de: 'Gewinnung von Steinen und Erden a. n. g.',
  },
  {
    code: '0910',
    nl: 'Ondersteunende activiteiten in verband met de aardolie- en aardgaswinning',
    fr: 'Activités de soutien à l’extraction d’hydrocarbures',
    en: 'Support activities for petroleum and natural gas extraction',
    de: 'Erbringung von Dienstleistungen für die Gewinnung von Erdöl und Erdgas',
  },
  {
    code: '0990',
    nl: 'Ondersteunende activiteiten in verband met de overige winning van delfstoffen',
    fr: 'Activités de soutien aux autres industries extractives',
    en: 'Support activities for other mining and quarrying',
    de: 'Erbringung von Dienstleistungen für den sonstigen Bergbau und die Gewinnung von Steinen und Erden',
  },
  {
    code: '1011',
    nl: 'Verwerking en conservering van vlees, met uitzondering van vlees van gevogelte',
    fr: 'Transformation et conservation de la viande, à l’exception de la viande de volaille',
    en: 'Processing and preserving of meat, except of poultry meat',
    de: 'Schlachten, ohne Schlachten von Geflügel',
  },
  {
    code: '10111',
    nl: 'Activiteiten van slachthuizen',
    fr: 'Activités des abattoirs',
    en: 'Activities of slaughterhouses',
    de: 'Tätigkeiten von Schlachthäusern',
  },
  {
    code: '10112',
    nl: 'Activiteiten van uitsnijderijen',
    fr: 'Activités des ateliers de découpe de viande',
    en: 'Activities of meat cutting plants',
    de: 'Tätigkeiten von Zerlegungsbetrieben',
  },
  {
    code: '10113',
    nl: 'Verwerking van afgeleide producten van vlees',
    fr: 'Transformation des produits dérivés de la viande',
    en: 'Processing of meat products',
    de: 'Verarbeitung von Nebenprodukten aus Fleisch',
  },
  {
    code: '10119',
    nl: 'Overige verwerking en conservering van vlees, met uitzondering van vlees van gevogelte',
    fr: 'Autre transformation et conservation de la viande, à l’exception de la viande de volaille',
    en: 'Other processing and preserving of meat, except poultry meat',
    de: 'Sonstige Schlachten, ohne Schlachten von Geflügel',
  },
  {
    code: '1012',
    nl: 'Verwerking en conservering van vlees van gevogelte',
    fr: 'Transformation et conservation de la viande de volaille',
    en: 'Processing and preserving of poultry meat',
    de: 'Schlachten von Geflügel',
  },
  {
    code: '1013',
    nl: 'Vervaardiging van producten van vlees of van vlees van gevogelte',
    fr: 'Préparation de produits à base de viande et viande de volaille',
    en: 'Production of meat and poultry meat products',
    de: 'Fleischverarbeitung',
  },
  {
    code: '1020',
    nl: 'Verwerking en conservering van vis en van schaal- en weekdieren',
    fr: 'Transformation et conservation de poisson, de crustacés et de mollusques',
    en: 'Processing and preserving of fish, crustaceans and molluscs',
    de: 'Fischverarbeitung',
  },
  {
    code: '1031',
    nl: 'Verwerking en conservering van aardappelen',
    fr: 'Transformation et conservation de pommes de terre',
    en: 'Processing and preserving of potatoes',
    de: 'Kartoffelverarbeitung',
  },
  {
    code: '10311',
    nl: 'Verwerking en conservering van aardappelen, exclusief productie van diepgevroren aardappelbereidingen',
    fr: 'Transformation et conservation de pommes de terre, sauf fabrication de préparations surgelées à base de pommes de terre',
    en: 'Processing and preserving of potatoes, except manufacture of prepared frozen potatoes',
    de: 'Verarbeitung und Konservierung von Kartoffeln, mit Ausnahme von tiefgefrorenen Kartoffelerzeugnissen',
  },
  {
    code: '10312',
    nl: 'Productie van diepgevroren aardappelbereidingen',
    fr: 'Fabrication de préparations surgelées à base de pommes de terre',
    en: 'Manufacture of prepared frozen potatoes',
    de: 'Produktion von tiefgefrorenen Kartoffelerzeugnissen',
  },
  {
    code: '1032',
    nl: 'Vervaardiging van groente- en fruitsappen',
    fr: 'Préparation de jus de fruits et légumes',
    en: 'Manufacture of fruit and vegetable juice',
    de: 'Herstellung von Frucht- und Gemüsesäften',
  },
  {
    code: '1039',
    nl: 'Overige verwerking en conservering van groenten en fruit',
    fr: 'Autre transformation et conservation de fruits et légumes',
    en: 'Other processing and preserving of fruit and vegetables',
    de: 'Sonstige Verarbeitung von Obst und Gemüse',
  },
  {
    code: '10391',
    nl: 'Verwerking en conservering van groenten, exclusief productie van diepgevroren groenten',
    fr: 'Transformation et conservation de légumes, sauf fabrication de légumes surgelés',
    en: 'Processing and preserving of vegetables, except manufacture of frozen vegetables',
    de: 'Verarbeitung und Konservierung von Gemüse, mit Ausnahme der Herstellung von tiefgefrorenem Gemüse',
  },
  {
    code: '10392',
    nl: 'Verwerking en conservering van fruit, exclusief productie van diepgevroren fruit',
    fr: 'Transformation et conservation de fruits, sauf fabrication de fruits surgelés',
    en: 'Processing and preserving of fruit, except manufacture of frozen fruit',
    de: 'Verarbeitung und Konservierung von Obst, mit Ausnahme der Herstellung von tiefgefrorenem Obst',
  },
  {
    code: '10393',
    nl: 'Productie van diepgevroren groenten en fruit',
    fr: 'Fabrication de légumes et de fruits surgelés',
    en: 'Manufacture of frozen fruit and vegetables',
    de: 'Herstellung von tiefgefrorenem Gemüse und Obst',
  },
  {
    code: '1041',
    nl: 'Vervaardiging van oliën en vetten',
    fr: 'Fabrication d’huiles et graisses',
    en: 'Manufacture of oils and fats',
    de: 'Herstellung von Ölen und Fetten, ohne Margarine u. Ä. Nahrungsfette',
  },
  {
    code: '1042',
    nl: 'Vervaardiging van margarine en andere spijsvetten',
    fr: 'Fabrication de margarine et graisses comestibles similaires',
    en: 'Manufacture of margarine and similar edible fats',
    de: 'Herstellung von Margarine u. Ä. Nahrungsfetten',
  },
  {
    code: '1051',
    nl: 'Vervaardiging van zuivelproducten',
    fr: 'Fabrication de produits laitiers',
    en: 'Manufacture of dairy products',
    de: 'Herstellung von Milcherzeugnissen',
  },
  {
    code: '1052',
    nl: 'Vervaardiging van roomijs en ander consumptie-ijs',
    fr: 'Fabrication de crèmes glacées et autres glaces alimentaires',
    en: 'Manufacture of ice cream and other edible ice',
    de: 'Herstellung von Speiseeis',
  },
  {
    code: '1061',
    nl: 'Vervaardiging van maalderijproducten',
    fr: 'Travail des grains',
    en: 'Manufacture of grain mill products',
    de: 'Mahl- und Schälmühlen',
  },
  {
    code: '1062',
    nl: 'Vervaardiging van zetmeel en zetmeelproducten',
    fr: 'Fabrication de produits amylacés',
    en: 'Manufacture of starches and starch products',
    de: 'Herstellung von Stärke und Stärkeerzeugnissen',
  },
  {
    code: '1071',
    nl: 'Vervaardiging van brood; vervaardiging van vers banketbakkerswerk',
    fr: 'Fabrication de pain; fabrication de pâtisserie fraîche',
    en: 'Manufacture of bread; manufacture of fresh pastry goods and cakes',
    de: 'Herstellung von Backwaren, ohne Dauerbackwaren',
  },
  {
    code: '10711',
    nl: 'Industriële vervaardiging van brood en van vers banketbakkerswerk',
    fr: 'Fabrication industrielle de pain et de pâtisserie fraîche',
    en: 'Industrial manufacture of bread and fresh pastry goods and cakes',
    de: 'Industrielle Herstellung von Brot und frischen Backwaren',
  },
  {
    code: '10712',
    nl: 'Ambachtelijke vervaardiging van brood en van vers banketbakkerswerk',
    fr: 'Fabrication artisanale de pain et de pâtisserie fraîche',
    en: 'Small-scale manufacture of bread and fresh pastry goods and cakes',
    de: 'Handwerkliche Herstellung von Brot und frischen Backwaren',
  },
  {
    code: '1072',
    nl: 'Vervaardiging van beschuit, biscuit en houdbaar banketbakkerswerk',
    fr: 'Fabrication de biscuits, biscottes et pâtisseries de conservation',
    en: 'Manufacture of rusks, biscuits, preserved pastries and cakes',
    de: 'Herstellung von Dauerbackwaren',
  },
  {
    code: '1073',
    nl: 'Vervaardiging van deegwaren',
    fr: 'Fabrication de pâtes alimentaires',
    en: 'Manufacture of farinaceous products',
    de: 'Herstellung von Teigwaren',
  },
  {
    code: '1081',
    nl: 'Vervaardiging van suiker',
    fr: 'Fabrication de sucre',
    en: 'Manufacture of sugar',
    de: 'Herstellung von Zucker',
  },
  {
    code: '1082',
    nl: 'Vervaardiging van cacao, chocolade en suikerwerk',
    fr: 'Fabrication de cacao, de chocolat et de produits de confiserie',
    en: 'Manufacture of cocoa, chocolate and sugar confectionery',
    de: 'Herstellung von Süßwaren, ohne Dauerbackwaren',
  },
  {
    code: '1083',
    nl: 'Verwerking van thee en koffie',
    fr: 'Transformation du thé et du café',
    en: 'Processing of tea and coffee',
    de: 'Verarbeitung von Kaffee und Tee, Herstellung von Kaffee-Ersatz',
  },
  {
    code: '1084',
    nl: 'Vervaardiging van specerijen, sauzen en kruiderijen',
    fr: 'Fabrication de condiments et assaisonnements',
    en: 'Manufacture of condiments and seasonings',
    de: 'Herstellung von Würzmitteln und Soßen',
  },
  {
    code: '1085',
    nl: 'Vervaardiging van bereide maaltijden en schotels',
    fr: 'Fabrication de plats préparés',
    en: 'Manufacture of prepared meals and dishes',
    de: 'Herstellung von Fertiggerichten',
  },
  {
    code: '1086',
    nl: 'Vervaardiging van gehomogeniseerde voedingspreparaten en dieetvoeding',
    fr: 'Fabrication d’aliments homogénéisés et diététiques',
    en: 'Manufacture of homogenised food preparations and dietetic food',
    de: 'Herstellung von homogenisierten und diätetischen Nahrungsmitteln',
  },
  {
    code: '1089',
    nl: 'Vervaardiging van andere voedingsmiddelen, n.e.g.',
    fr: 'Fabrication d’autres produits alimentaires n.c.a.',
    en: 'Manufacture of other food products n.e.c.',
    de: 'Herstellung von sonstigen Nahrungsmitteln a. n. g.',
  },
  {
    code: '1091',
    nl: 'Vervaardiging van veevoeders',
    fr: 'Fabrication d’aliments pour animaux de ferme',
    en: 'Manufacture of prepared feeds for farm animals',
    de: 'Herstellung von Futtermitteln für Nutztiere',
  },
  {
    code: '1092',
    nl: 'Vervaardiging van voeders voor huisdieren',
    fr: 'Fabrication d’aliments pour animaux de compagnie',
    en: 'Manufacture of prepared pet foods',
    de: 'Herstellung von Futtermitteln für sonstige Tiere',
  },
  {
    code: '1101',
    nl: 'Vervaardiging van gedistilleerde dranken door distilleren, rectificeren en mengen',
    fr: 'Fabrication de boissons distillées, par distillation, rectification et mélange',
    en: 'Distilling, rectifying and blending of spirits',
    de: 'Herstellung von Spirituosen',
  },
  {
    code: '1102',
    nl: 'Vervaardiging van wijn uit druiven',
    fr: 'Production de vin (de raisin)',
    en: 'Manufacture of wine from grape',
    de: 'Herstellung von Traubenwein',
  },
  {
    code: '1103',
    nl: 'Vervaardiging van cider en andere gefermenteerde vruchtendranken',
    fr: 'Fabrication de cidre et autres boissons fermentées à base de fruits',
    en: 'Manufacture of cider and other fermented fruit beverages',
    de: 'Herstellung von Apfelwein und sonstigen gegorenen Getränken aus Obst',
  },
  {
    code: '1104',
    nl: 'Vervaardiging van andere niet-gedistilleerde gegiste dranken',
    fr: 'Production d’autres boissons fermentées non distillées',
    en: 'Manufacture of other non-distilled fermented beverages',
    de: 'Herstellung von Wermutwein und sonstigen aromatisierten Weinen',
  },
  {
    code: '1105',
    nl: 'Vervaardiging van bier',
    fr: 'Fabrication de bière',
    en: 'Manufacture of beer',
    de: 'Herstellung von Bier',
  },
  {
    code: '1106',
    nl: 'Vervaardiging van mout',
    fr: 'Fabrication de malt',
    en: 'Manufacture of malt',
    de: 'Herstellung von Malz',
  },
  {
    code: '1107',
    nl: 'Vervaardiging van frisdranken en water in flessen',
    fr: 'Fabrication de boissons non alcoolisées et d’eaux embouteillées',
    en: 'Manufacture of soft drinks and bottled waters',
    de: 'Herstellung von Erfrischungsgetränken und Mineralwässern',
  },
  {
    code: '1200',
    nl: 'Vervaardiging van tabaksproducten',
    fr: 'Fabrication de produits à base de tabac',
    en: 'Manufacture of tobacco products',
    de: 'Tabakverarbeitung',
  },
  {
    code: '1310',
    nl: 'Bewerken en spinnen van textielvezels',
    fr: 'Préparation de fibres textiles et filature',
    en: 'Preparation and spinning of textile fibres',
    de: 'Spinnstoffaufbereitung und Spinnerei',
  },
  {
    code: '1320',
    nl: 'Weven van textiel',
    fr: 'Tissage',
    en: 'Weaving of textiles',
    de: 'Weberei',
  },
  {
    code: '1330',
    nl: 'Textielveredeling',
    fr: 'Ennoblissement textile',
    en: 'Finishing of textiles',
    de: 'Veredlung von Textilien und Bekleidung',
  },
  {
    code: '1391',
    nl: 'Vervaardiging van gebreide en gehaakte stoffen',
    fr: 'Fabrication d’étoffes à mailles',
    en: 'Manufacture of knitted and crocheted fabrics',
    de: 'Herstellung von gewirktem und gestricktem Stoff',
  },
  {
    code: '1392',
    nl: 'Vervaardiging van huishoudtextiel en geconfectioneerde artikelen voor stoffering',
    fr: 'Fabrication de textiles ménagers et d’articles d’ameublement confectionnés',
    en: 'Manufacture of household textiles and made-up furnishing articles',
    de: 'Herstellung von Heimtextilien und konfektionierten Textilwaren für die Innenausstattung',
  },
  {
    code: '13921',
    nl: 'Vervaardiging van beddengoed, tafellinnen en textielwaren voor huishoudelijk gebruik',
    fr: "Fabrication de linges de lit et de table et d'articles textiles à usage domestique",
    en: 'Manufacture of bed and table linen and textile articles for domestic use',
    de: 'Herstellung von Bettwäsche, Tischwäsche und Heimtextilien',
  },
  {
    code: '13929',
    nl: 'Vervaardiging van overige geconfectioneerde artikelen van textiel, m.u.v. kleding',
    fr: "Fabrication d'autres articles textiles confectionnés, sauf habillement",
    en: 'Manufacture of other made-up textile articles, except wearing apparel',
    de: 'Herstellung von anderen konfektionierten Textilartikeln mit Ausnahme von Kleidung',
  },
  {
    code: '1393',
    nl: 'Vervaardiging van vloerkleden en tapijt',
    fr: 'Fabrication de tapis et moquettes',
    en: 'Manufacture of carpets and rugs',
    de: 'Herstellung von Teppichen',
  },
  {
    code: '1394',
    nl: 'Vervaardiging van koord, bindgaren, touw en netten',
    fr: 'Fabrication de ficelles, cordes, cordages et filets',
    en: 'Manufacture of cordage, rope, twine and netting',
    de: 'Herstellung von Seilerwaren',
  },
  {
    code: '1395',
    nl: 'Vervaardiging van ongeweven stoffen en artikelen van ongeweven stoffen',
    fr: 'Fabrication de textiles non-tissés et articles non-tissés',
    en: 'Manufacture of non-wovens and non-woven articles',
    de: 'Herstellung von Vliesstoff und nicht-konfektionierten Erzeugnissen daraus',
  },
  {
    code: '1396',
    nl: 'Vervaardiging van ander technisch en industrieel textiel',
    fr: 'Fabrication d’autres textiles techniques et industriels',
    en: 'Manufacture of other technical and industrial textiles',
    de: 'Herstellung von technischen Textilien',
  },
  {
    code: '1399',
    nl: 'Vervaardiging van andere textielproducten, n.e.g.',
    fr: 'Fabrication d’autres textiles n.c.a.',
    en: 'Manufacture of other textiles n.e.c.',
    de: 'Herstellung von sonstigen Textilwaren a. n. g.',
  },
  {
    code: '1410',
    nl: 'Vervaardiging van gebreide en gehaakte kleding',
    fr: 'Fabrication d’articles à mailles',
    en: 'Manufacture of knitted and crocheted apparel',
    de: 'Herstellung von Bekleidung aus gewirktem und gestricktem Stoff',
  },
  {
    code: '1421',
    nl: 'Vervaardiging van bovenkleding',
    fr: 'Fabrication de vêtements de dessus',
    en: 'Manufacture of outerwear',
    de: 'Herstellung von Oberbekleidung',
  },
  {
    code: '1422',
    nl: 'Vervaardiging van onderkleding',
    fr: 'Fabrication de vêtements de dessous',
    en: 'Manufacture of underwear',
    de: 'Herstellung von Wäsche',
  },
  {
    code: '1423',
    nl: 'Vervaardiging van werkkleding',
    fr: 'Fabrication de vêtements de travail',
    en: 'Manufacture of workwear',
    de: 'Herstellung von Arbeits- und Berufsbekleidung',
  },
  {
    code: '1424',
    nl: 'Vervaardiging van kleding van leer en van bont',
    fr: 'Fabrication de vêtements en cuir et en fourrure',
    en: 'Manufacture of leather clothes and fur apparel',
    de: 'Herstellung von Lederbekleidung und Pelzwaren',
  },
  {
    code: '1429',
    nl: 'Vervaardiging van andere kleding en toebehoren, n.e.g.',
    fr: 'Fabrication d’autres articles d’habillement et accessoires n.c.a.',
    en: 'Manufacture of other wearing apparel and accessories n.e.c.',
    de: 'Herstellung von sonstiger Bekleidung und Bekleidungszubehör a. n. g.',
  },
  {
    code: '14291',
    nl: 'Vervaardiging van hoeden en petten',
    fr: 'Fabrication de chapeaux et de bonnets',
    en: 'Manufacture of hats and caps',
    de: 'Herstellung von Hüten und Mützen',
  },
  {
    code: '14299',
    nl: 'Vervaardiging van overige kleding en toebehoren, n.e.g.',
    fr: "Fabrication d'autres vêtements et accessoires n.c.a.",
    en: 'Manufacture of other miscellaneous wearing apparel and accessories n.e.c.',
    de: 'Herstellung von sonstiger Bekleidung und Bekleidungszubehör a. n. g.',
  },
  {
    code: '1511',
    nl: 'Looien, bereiden en verven van leder en bont',
    fr: 'Tannage, apprêt et teinture des cuirs et des fourrures',
    en: 'Tanning, dressing, dyeing of leather and fur',
    de: 'Gerben, Färben, Zurichten von Leder und Fellen',
  },
  {
    code: '1512',
    nl: 'Vervaardiging van koffers, tassen, zadel- en tuigmakerswerk van ongeacht welk materiaal',
    fr: 'Fabrication de bagages, de maroquinerie, sellerie et bourrellerie, en toutes matières',
    en: 'Manufacture of luggage, handbags, saddlery and harness of any material',
    de: 'Herstellung von Reisegepäck, Handtaschen, Sattlerwaren und Geschirren aus Stoffen aller Art',
  },
  {
    code: '1520',
    nl: 'Vervaardiging van schoeisel',
    fr: 'Fabrication de chaussures',
    en: 'Manufacture of footwear',
    de: 'Herstellung von Schuhen',
  },
  {
    code: '1611',
    nl: 'Zagen en schaven van hout',
    fr: 'Sciage et rabotage du bois',
    en: 'Sawmilling and planing of wood',
    de: 'Säge-, Hobel- und Holzimprägnierwerke',
  },
  {
    code: '1612',
    nl: 'Verwerking en afwerking van hout',
    fr: 'Façonnage et finition du bois',
    en: 'Processing and finishing of wood',
    de: 'Bearbeitung und Veredlung von Holz',
  },
  {
    code: '1621',
    nl: 'Vervaardiging van fineer en van panelen op basis van hout',
    fr: 'Fabrication de placage et de panneaux de bois',
    en: 'Manufacture of veneer sheets and wood-based panels',
    de: 'Herstellung von Furnier-, Sperrholz-, Holzfaser- und Holzspanplatten',
  },
  {
    code: '1622',
    nl: 'Vervaardiging van geassembleerde parketvloeren',
    fr: 'Fabrication de parquets assemblés',
    en: 'Manufacture of assembled parquet floors',
    de: 'Herstellung von Parketttafeln',
  },
  {
    code: '1623',
    nl: 'Vervaardiging van ander schrijn- en timmerwerk',
    fr: 'Fabrication de charpentes et d’autres menuiseries',
    en: 'Manufacture of other builders’ carpentry and joinery',
    de: 'Herstellung von sonstigen Konstruktionsteilen, Fertigbauteilen, Ausbauelementen und Fertigteilbauten aus Holz',
  },
  {
    code: '1624',
    nl: 'Vervaardiging van houten emballage',
    fr: 'Fabrication d’emballages en bois',
    en: 'Manufacture of wooden containers',
    de: 'Herstellung von Verpackungsmitteln, Lagerbehältern und Ladungsträgern aus Holz',
  },
  {
    code: '1625',
    nl: 'Vervaardiging van houten deuren en vensters',
    fr: 'Fabrication de portes et fenêtres en bois',
    en: 'Manufacture of doors and windows of wood',
    de: 'Herstellung von Türen und Fenstern aus Holz',
  },
  {
    code: '1626',
    nl: 'Vervaardiging van vaste brandstoffen uit plantaardige biomassa',
    fr: 'Fabrication de combustibles solides à partir de biomasse végétale',
    en: 'Manufacture of solid fuels from vegetable biomass',
    de: 'Herstellung von festen Brennstoffen aus pflanzlicher Biomasse',
  },
  {
    code: '1627',
    nl: 'Afwerking van houten producten',
    fr: 'Finition de produits en bois',
    en: 'Finishing of wooden products',
    de: 'Veredlung von Holzwaren',
  },
  {
    code: '1628',
    nl: 'Vervaardiging van andere artikelen van hout en van artikelen van kurk, riet of vlechtwerk',
    fr: 'Fabrication d’objets divers en bois, d’objets en liège, vannerie et sparterie',
    en: 'Manufacture of other products of wood and articles of cork, straw and plaiting materials',
    de: 'Herstellung von sonstigen Holzwaren sowie Kork-, Flecht- und Korbwaren',
  },
  {
    code: '16281',
    nl: 'Vervaardiging van andere artikelen van hout',
    fr: "Fabrication d'objets divers en bois",
    en: 'Manufacture of other products of wood',
    de: 'Herstellung von sonstigen Waren aus Papier, Karton und Pappe',
  },
  {
    code: '16282',
    nl: 'Vervaardiging van artikelen van kurk, riet of vlechtwerk',
    fr: "Fabrication d'objets en liège, vannerie et sparterie",
    en: 'Manufacture of products of cork, straw and plaiting materials',
    de: 'Herstellung von sonstigen Holz-, Kork-, Flecht- und Korbwaren',
  },
  {
    code: '1711',
    nl: 'Vervaardiging van papierpulp',
    fr: 'Fabrication de pâte à papier',
    en: 'Manufacture of pulp',
    de: 'Herstellung von Holz- und Zellstoff',
  },
  {
    code: '1712',
    nl: 'Vervaardiging van papier en karton',
    fr: 'Fabrication de papier et de carton',
    en: 'Manufacture of paper and paperboard',
    de: 'Herstellung von Papier, Karton und Pappe',
  },
  {
    code: '1721',
    nl: 'Vervaardiging van gegolfd papier, golfkarton en verpakkingsmateriaal van papier en karton',
    fr: 'Fabrication de papier et carton ondulés et d’emballages en papier ou en carton',
    en: 'Manufacture of corrugated paper, paperboard and containers of paper and paperboard',
    de: 'Herstellung von Wellpapier und -pappe sowie von Verpackungsmitteln aus Papier, Karton und Pappe',
  },
  {
    code: '1722',
    nl: 'Vervaardiging van huishoudelijke en sanitaire papierwaren',
    fr: 'Fabrication d’articles en papier à usage sanitaire ou domestique',
    en: 'Manufacture of household and sanitary goods and of toilet requisites',
    de: 'Herstellung von Haushalts-, Hygiene- und Toilettenartikeln aus Zellstoff, Papier und Pappe',
  },
  {
    code: '1723',
    nl: 'Vervaardiging van kantoorbenodigdheden van papier',
    fr: 'Fabrication d’articles de papeterie',
    en: 'Manufacture of paper stationery',
    de: 'Herstellung von Schreibwaren und Bürobedarf aus Papier, Karton und Pappe',
  },
  {
    code: '1724',
    nl: 'Vervaardiging van behangpapier',
    fr: 'Fabrication de papiers peints',
    en: 'Manufacture of wallpaper',
    de: 'Herstellung von Tapeten',
  },
  {
    code: '1725',
    nl: 'Vervaardiging van andere artikelen van papier of karton',
    fr: 'Fabrication d’autres articles en papier ou en carton',
    en: 'Manufacture of other articles of paper and paperboard',
    de: 'Herstellung von sonstigen Waren aus Papier, Karton und Pappe',
  },
  {
    code: '1811',
    nl: 'Drukken van dagbladen',
    fr: 'Imprimerie de journaux',
    en: 'Printing of newspapers',
    de: 'Drucken von Zeitungen',
  },
  {
    code: '1812',
    nl: 'Overige activiteiten op het gebied van drukwerk',
    fr: 'Autres activités d’imprimerie',
    en: 'Other printing',
    de: 'Sonstiges Drucken',
  },
  {
    code: '1813',
    nl: 'Prepress- en premediadiensten',
    fr: 'Activités de pré-presse',
    en: 'Pre-press and pre-media services',
    de: 'Druck- und Medienvorstufe',
  },
  {
    code: '1814',
    nl: 'Activiteiten van binderijen en aanverwante diensten',
    fr: 'Reliure et activités connexes',
    en: 'Binding and related services',
    de: 'Binden von Druckerzeugnissen und damit verbundene Dienstleistungen',
  },
  {
    code: '1820',
    nl: 'Reproductie van opgenomen media',
    fr: 'Reproduction d’enregistrements',
    en: 'Reproduction of recorded media',
    de: 'Vervielfältigung von bespielten Ton-, Bild- und Datenträgern',
  },
  {
    code: '1910',
    nl: 'Vervaardiging van cokesovenproducten',
    fr: 'Cokéfaction',
    en: 'Manufacture of coke oven products',
    de: 'Kokerei',
  },
  {
    code: '1920',
    nl: 'Vervaardiging van geraffineerde aardolieproducten en van producten uit fossiele brandstoffen',
    fr: 'Raffinage du pétrole et fabrication de produits à base de combustibles fossiles',
    en: 'Manufacture of refined petroleum products and fossil fuel products',
    de: 'Herstellung von Mineralölerzeugnissen und von fossilen Brennstoffen',
  },
  {
    code: '2011',
    nl: 'Vervaardiging van industriële gassen',
    fr: 'Fabrication de gaz industriels',
    en: 'Manufacture of industrial gases',
    de: 'Herstellung von Industriegasen',
  },
  {
    code: '2012',
    nl: 'Vervaardiging van kleurstoffen en pigmenten',
    fr: 'Fabrication de colorants et de pigments',
    en: 'Manufacture of dyes and pigments',
    de: 'Herstellung von Farbstoffen und Pigmenten',
  },
  {
    code: '2013',
    nl: 'Vervaardiging van andere anorganische chemische basisproducten',
    fr: 'Fabrication d’autres produits chimiques inorganiques de base',
    en: 'Manufacture of other inorganic basic chemicals',
    de: 'Herstellung von sonstigen anorganischen Grundstoffen und Chemikalien',
  },
  {
    code: '2014',
    nl: 'Vervaardiging van andere organische chemische basisproducten',
    fr: 'Fabrication d’autres produits chimiques organiques de base',
    en: 'Manufacture of other organic basic chemicals',
    de: 'Herstellung von sonstigen organischen Grundstoffen und Chemikalien',
  },
  {
    code: '2015',
    nl: 'Vervaardiging van kunstmeststoffen en stikstofverbindingen',
    fr: 'Fabrication de produits azotés et d’engrais',
    en: 'Manufacture of fertilisers and nitrogen compounds',
    de: 'Herstellung von Düngemitteln und Stickstoffverbindungen',
  },
  {
    code: '2016',
    nl: 'Vervaardiging van kunststoffen in primaire vormen',
    fr: 'Fabrication de matières plastiques de base',
    en: 'Manufacture of plastics in primary forms',
    de: 'Herstellung von Kunststoffen in Primärformen',
  },
  {
    code: '2017',
    nl: 'Vervaardiging van synthetische rubber in primaire vormen',
    fr: 'Fabrication de caoutchouc synthétique',
    en: 'Manufacture of synthetic rubber in primary forms',
    de: 'Herstellung von synthetischem Kautschuk in Primärformen',
  },
  {
    code: '2020',
    nl: 'Vervaardiging van verdelgingsmiddelen, ontsmettingsmiddelen en andere chemische producten voor de landbouw',
    fr: 'Fabrication de pesticides, de désinfectants et d’autres produits agrochimiques',
    en: 'Manufacture of pesticides, disinfectants and other agrochemical products',
    de: 'Herstellung von Schädlingsbekämpfungs-, Pflanzenschutz- und Desinfektionsmitteln',
  },
  {
    code: '2030',
    nl: 'Vervaardiging van verf, vernis e.d., drukinkt en mastiek',
    fr: 'Fabrication de peintures, vernis, encres et mastics',
    en: 'Manufacture of paints, varnishes and similar coatings, printing ink and mastics',
    de: 'Herstellung von Anstrichmitteln, Druckfarben und Kitten',
  },
  {
    code: '2041',
    nl: 'Vervaardiging van zeep en wasmiddelen, poets- en reinigingsmiddelen',
    fr: 'Fabrication de savons, détergents et produits d’entretien',
    en: 'Manufacture of soap and detergents, cleaning and polishing preparations',
    de: 'Herstellung von Seifen, Wasch-, Reinigungs- und Poliermitteln',
  },
  {
    code: '20411',
    nl: 'Vervaardiging van zeep en wasmiddelen',
    fr: 'Fabrication de savons et de détergents',
    en: 'Manufacture of soap and detergents',
    de: 'Herstellung von Seifen und Waschmitteln',
  },
  {
    code: '20412',
    nl: 'Vervaardiging van poets- en reinigingsmiddelen',
    fr: "Fabrication de  produits d'entretien et de nettoyage",
    en: 'Manufacture of cleaning and polishing preparations',
    de: 'Herstellung von Reinigungs- und Poliermitteln',
  },
  {
    code: '2042',
    nl: 'Vervaardiging van parfums en toiletartikelen',
    fr: 'Fabrication de parfums et de produits pour la toilette',
    en: 'Manufacture of perfume and toilet preparations',
    de: 'Herstellung von Körperpflegemitteln und Duftstoffen',
  },
  {
    code: '2051',
    nl: 'Vervaardiging van vloeibare biobrandstoffen',
    fr: 'Fabrication de biocarburants liquides',
    en: 'Manufacture of liquid biofuels',
    de: 'Herstellung von flüssigen Biokraftstoffen',
  },
  {
    code: '2059',
    nl: 'Vervaardiging van andere chemische producten, n.e.g.',
    fr: 'Fabrication d’autres produits chimiques n.c.a.',
    en: 'Manufacture of other chemical products n.e.c.',
    de: 'Herstellung von sonstigen chemischen Erzeugnissen a. n. g.',
  },
  {
    code: '2060',
    nl: 'Vervaardiging van synthetische en kunstmatige vezels',
    fr: 'Fabrication de fibres artificielles ou synthétiques',
    en: 'Manufacture of man-made fibres',
    de: 'Herstellung von Chemiefasern',
  },
  {
    code: '2110',
    nl: 'Vervaardiging van farmaceutische grondstoffen',
    fr: 'Fabrication de produits pharmaceutiques de base',
    en: 'Manufacture of basic pharmaceutical products',
    de: 'Herstellung von pharmazeutischen Grundstoffen',
  },
  {
    code: '2120',
    nl: 'Vervaardiging van farmaceutische producten',
    fr: 'Fabrication de préparations pharmaceutiques',
    en: 'Manufacture of pharmaceutical preparations',
    de: 'Herstellung von pharmazeutischen Spezialitäten und sonstigen pharmazeutischen Erzeugnissen',
  },
  {
    code: '21201',
    nl: 'Vervaardiging van geneesmiddelen',
    fr: 'Fabrication de médicaments',
    en: 'Manufacture of medicaments',
    de: 'Herstellung von Arzneimitteln',
  },
  {
    code: '21209',
    nl: 'Vervaardiging van overige farmaceutische producten',
    fr: "Fabrication d'autres produits pharmaceutiques",
    en: 'Manufacture of other pharmaceutical products',
    de: 'Herstellung von sonstigen pharmazeutischen Erzeugnissen',
  },
  {
    code: '2211',
    nl: 'Vervaardiging en loopvlakvernieuwing van rubberbanden en vervaardiging van binnenbanden',
    fr: 'Fabrication et rechapage de pneus en caoutchouc et fabrication de chambres à air',
    en: 'Manufacture, retreading and rebuilding of rubber tyres and manufacture of tubes',
    de: 'Herstellung und Runderneuerung von Bereifungen',
  },
  {
    code: '2212',
    nl: 'Vervaardiging van andere producten van rubber',
    fr: 'Fabrication d’autres articles en caoutchouc',
    en: 'Manufacture of other rubber products',
    de: 'Herstellung von sonstigen Gummiwaren',
  },
  {
    code: '2221',
    nl: 'Vervaardiging van platen, vellen, buizen en profielen van kunststof',
    fr: 'Fabrication de plaques, feuilles, tubes et profilés en matières plastiques',
    en: 'Manufacture of plastic plates, sheets, tubes and profiles',
    de: 'Herstellung von Platten, Folien, Schläuchen und Profilen aus Kunststoffen',
  },
  {
    code: '2222',
    nl: 'Vervaardiging van verpakkingsmateriaal van kunststof',
    fr: 'Fabrication d’emballages en matières plastiques',
    en: 'Manufacture of plastic packing goods',
    de: 'Herstellung von Verpackungsmitteln aus Kunststoffen',
  },
  {
    code: '2223',
    nl: 'Vervaardiging van deuren en vensters van kunststof',
    fr: 'Fabrication de portes et fenêtres en matières plastiques',
    en: 'Manufacture of doors and windows of plastic',
    de: 'Herstellung von Türen und Fenstern aus Kunststoffen',
  },
  {
    code: '2224',
    nl: 'Vervaardiging van kunststofartikelen voor de bouw',
    fr: 'Fabrication d’éléments en matières plastiques pour la construction',
    en: 'Manufacture of builders’ ware of plastic',
    de: 'Herstellung von Baubedarfsartikeln aus Kunststoffen',
  },
  {
    code: '2225',
    nl: 'Verwerking en afwerking van kunststofproducten',
    fr: 'Façonnage et finition de produits en matières plastiques',
    en: 'Processing and finishing of plastic products',
    de: 'Bearbeitung und Veredlung von Kunststoffwaren',
  },
  {
    code: '2226',
    nl: 'Vervaardiging van andere producten van kunststof',
    fr: 'Fabrication d’autres articles en matières plastiques',
    en: 'Manufacture of other plastic products',
    de: 'Herstellung von sonstigen Kunststoffwaren',
  },
  {
    code: '2311',
    nl: 'Vervaardiging van vlakglas',
    fr: 'Fabrication de verre plat',
    en: 'Manufacture of flat glass',
    de: 'Herstellung von Flachglas',
  },
  {
    code: '2312',
    nl: 'Vormen en bewerken van vlakglas',
    fr: 'Façonnage et transformation du verre plat',
    en: 'Shaping and processing of flat glass',
    de: 'Veredlung und Bearbeitung von Flachglas',
  },
  {
    code: '2313',
    nl: 'Vervaardiging van holglas',
    fr: 'Fabrication de verre creux',
    en: 'Manufacture of hollow glass',
    de: 'Herstellung von Hohlglas',
  },
  {
    code: '2314',
    nl: 'Vervaardiging van glasvezels',
    fr: 'Fabrication de fibres de verre',
    en: 'Manufacture of glass fibres',
    de: 'Herstellung von Glasfasern und Waren daraus',
  },
  {
    code: '2315',
    nl: 'Vervaardiging en bewerking van overig glas, inclusief technisch glaswerk',
    fr: 'Fabrication et façonnage d’autres articles en verre, y compris verre technique',
    en: 'Manufacture and processing of other glass, including technical glassware',
    de: 'Herstellung, Veredlung und Bearbeitung von sonstigem Glas einschließlich technischen Glaswaren',
  },
  {
    code: '2320',
    nl: 'Vervaardiging van vuurvaste producten',
    fr: 'Fabrication de produits réfractaires',
    en: 'Manufacture of refractory products',
    de: 'Herstellung von feuerfesten keramischen Werkstoffen und Waren',
  },
  {
    code: '2331',
    nl: 'Vervaardiging van keramische tegels en plavuizen',
    fr: 'Fabrication de carreaux en céramique',
    en: 'Manufacture of ceramic tiles and flags',
    de: 'Herstellung von keramischen Wand- und Bodenfliesen und -platten',
  },
  {
    code: '2332',
    nl: 'Vervaardiging van bakstenen, tegels en producten voor de bouw, van gebakken klei',
    fr: 'Fabrication de briques, tuiles et produits de construction, en terre cuite',
    en: 'Manufacture of bricks, tiles and construction products, in baked clay',
    de: 'Herstellung von Ziegeln und sonstiger Baukeramik',
  },
  {
    code: '23321',
    nl: 'Vervaardiging van bakstenen',
    fr: 'Fabrication de briques',
    en: 'Manufacture of bricks',
    de: 'Herstellung von Mauerziegeln',
  },
  {
    code: '23322',
    nl: 'Vervaardiging dakpannen, tegels en andere producten voor de bouw, van gebakken klei',
    fr: 'Fabrication de tuiles, de carrelages et de produits de construction en terre cuite',
    en: 'Manufacture of tiles and construction products, in baked clay',
    de: 'Herstellung von Dachziegeln, Ziegeln und anderen Baustoffen aus Ziegelerde',
  },
  {
    code: '2341',
    nl: 'Vervaardiging van huishoudelijk en sieraardewerk',
    fr: 'Fabrication d’articles céramiques à usage domestique ou ornemental',
    en: 'Manufacture of ceramic household and ornamental articles',
    de: 'Herstellung von keramischen Haushaltswaren und Ziergegenständen',
  },
  {
    code: '2342',
    nl: 'Vervaardiging van sanitair aardewerk',
    fr: 'Fabrication d’appareils sanitaires en céramique',
    en: 'Manufacture of ceramic sanitary fixtures',
    de: 'Herstellung von Sanitärkeramik',
  },
  {
    code: '2343',
    nl: 'Vervaardiging van isolatoren en isolatiemateriaal, van keramische stoffen',
    fr: 'Fabrication d’isolateurs et pièces isolantes en céramique',
    en: 'Manufacture of ceramic insulators and insulating fittings',
    de: 'Herstellung von Isolatoren und Isolierteilen aus Keramik',
  },
  {
    code: '2344',
    nl: 'Vervaardiging van ander technisch aardewerk',
    fr: 'Fabrication d’autres produits céramiques à usage technique',
    en: 'Manufacture of other technical ceramic products',
    de: 'Herstellung von keramischen Erzeugnissen für sonstige technische Zwecke',
  },
  {
    code: '2345',
    nl: 'Vervaardiging van andere keramische producten',
    fr: 'Fabrication d’autres produits céramiques',
    en: 'Manufacture of other ceramic products',
    de: 'Herstellung von sonstigen keramischen Erzeugnissen',
  },
  {
    code: '2351',
    nl: 'Vervaardiging van cement',
    fr: 'Fabrication de ciment',
    en: 'Manufacture of cement',
    de: 'Herstellung von Zement',
  },
  {
    code: '2352',
    nl: 'Vervaardiging van kalk en gips',
    fr: 'Fabrication de chaux et plâtre',
    en: 'Manufacture of lime and plaster',
    de: 'Herstellung von Kalk und gebranntem Gips',
  },
  {
    code: '2361',
    nl: 'Vervaardiging van artikelen van beton voor de bouw',
    fr: 'Fabrication d’éléments en béton pour la construction',
    en: 'Manufacture of concrete products for construction purposes',
    de: 'Herstellung von Erzeugnissen aus Beton, Zement und Kalksandstein für den Bau',
  },
  {
    code: '2362',
    nl: 'Vervaardiging van artikelen van gips voor de bouw',
    fr: 'Fabrication d’éléments en plâtre pour la construction',
    en: 'Manufacture of plaster products for construction purposes',
    de: 'Herstellung von Gipserzeugnissen für den Bau',
  },
  {
    code: '2363',
    nl: 'Vervaardiging van stortklare beton',
    fr: 'Fabrication de béton prêt à l’emploi',
    en: 'Manufacture of ready-mixed concrete',
    de: 'Herstellung von Frischbeton, Transportbeton',
  },
  {
    code: '2364',
    nl: 'Vervaardiging van mortel',
    fr: 'Fabrication de mortiers',
    en: 'Manufacture of mortars',
    de: 'Herstellung von Mörtel und sonstigem Beton, ohne Frischbeton',
  },
  {
    code: '2365',
    nl: 'Vervaardiging van producten van vezelcement',
    fr: 'Fabrication d’ouvrages en fibre-ciment',
    en: 'Manufacture of fibre cement',
    de: 'Herstellung von Faserzementwaren',
  },
  {
    code: '2366',
    nl: 'Vervaardiging van andere artikelen van beton, cement en gips',
    fr: 'Fabrication d’autres ouvrages en béton, en ciment ou en plâtre',
    en: 'Manufacture of other articles of concrete, cement and plaster',
    de: 'Herstellung von sonstigen Erzeugnissen aus Beton, Zement und Gips',
  },
  {
    code: '2370',
    nl: 'Houwen, bewerken en afwerken van natuursteen',
    fr: 'Taille, façonnage et finissage de pierres',
    en: 'Cutting, shaping and finishing of stone',
    de: 'Be- und Verarbeitung von Naturwerksteinen und Natursteinen',
  },
  {
    code: '2391',
    nl: 'Vervaardiging van schuurmiddelen',
    fr: 'Fabrication de produits abrasifs',
    en: 'Manufacture of abrasive products',
    de: 'Herstellung von Schleifkörpern und Schleifmitteln auf Unterlage',
  },
  {
    code: '2399',
    nl: 'Vervaardiging van andere niet-metaalhoudende minerale producten, n.e.g.',
    fr: 'Fabrication d’autres produits minéraux non métalliques n.c.a.',
    en: 'Manufacture of other non-metallic mineral products n.e.c.',
    de: 'Herstellung von sonstigen Erzeugnissen aus nichtmetallischen Mineralien a. n. g.',
  },
  {
    code: '2410',
    nl: 'Vervaardiging van ijzer en staal en van ferrolegeringen',
    fr: 'Sidérurgie',
    en: 'Manufacture of basic iron and steel and of ferro-alloys',
    de: 'Erzeugung von Roheisen, Stahl und Ferrolegierungen',
  },
  {
    code: '2420',
    nl: 'Vervaardiging van buizen, pijpen, holle profielen en fittings daarvoor, van staal',
    fr: 'Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier',
    en: 'Manufacture of tubes, pipes, hollow profiles and related fittings, of steel',
    de: 'Herstellung von Stahlrohren, Rohrform-, Rohrverschluss- und Rohrverbindungsstücken aus Stahl',
  },
  {
    code: '2431',
    nl: 'Koudtrekken van staven',
    fr: 'Étirage à froid de barres',
    en: 'Cold drawing of bars',
    de: 'Herstellung von Blankstahl',
  },
  {
    code: '2432',
    nl: 'Koudwalsen van bandstaal',
    fr: 'Laminage à froid de feuillards',
    en: 'Cold rolling of narrow strip',
    de: 'Herstellung von Kaltband mit einer Breite von weniger als 600 mm',
  },
  {
    code: '2433',
    nl: 'Koudvervormen of koudfelsen',
    fr: 'Profilage à froid par formage ou pliage',
    en: 'Cold forming or folding',
    de: 'Herstellung von Kaltprofilen',
  },
  {
    code: '2434',
    nl: 'Koudtrekken van draad',
    fr: 'Tréfilage à froid',
    en: 'Cold drawing of wire',
    de: 'Herstellung von kaltgezogenem Draht',
  },
  {
    code: '2441',
    nl: 'Productie van edelmetalen',
    fr: 'Production de métaux précieux',
    en: 'Precious metals production',
    de: 'Erzeugung und erste Bearbeitung von Edelmetallen',
  },
  {
    code: '2442',
    nl: 'Productie van aluminium',
    fr: 'Métallurgie de l’aluminium',
    en: 'Aluminium production',
    de: 'Erzeugung und erste Bearbeitung von Aluminium',
  },
  {
    code: '2443',
    nl: 'Productie van lood, zink en tin',
    fr: 'Métallurgie du plomb, du zinc ou de l’étain',
    en: 'Lead, zinc and tin production',
    de: 'Erzeugung und erste Bearbeitung von Blei, Zink und Zinn',
  },
  {
    code: '2444',
    nl: 'Productie van koper',
    fr: 'Métallurgie du cuivre',
    en: 'Copper production',
    de: 'Erzeugung und erste Bearbeitung von Kupfer',
  },
  {
    code: '2445',
    nl: 'Productie van andere non-ferrometalen',
    fr: 'Métallurgie des autres métaux non ferreux',
    en: 'Other non-ferrous metal production',
    de: 'Erzeugung und erste Bearbeitung von sonstigen NE-Metallen',
  },
  {
    code: '2446',
    nl: 'Bewerking van splijt- en kweekstoffen',
    fr: 'Élaboration et transformation de matières nucléaires',
    en: 'Processing of nuclear fuel',
    de: 'Aufbereitung von Kernbrennstoffen',
  },
  {
    code: '2451',
    nl: 'Gieten van ijzer',
    fr: 'Fonderie de fonte',
    en: 'Casting of iron',
    de: 'Eisengießereien',
  },
  {
    code: '2452',
    nl: 'Gieten van staal',
    fr: 'Fonderie d’acier',
    en: 'Casting of steel',
    de: 'Stahlgießereien',
  },
  {
    code: '2453',
    nl: 'Gieten van lichte metalen',
    fr: 'Fonderie de métaux légers',
    en: 'Casting of light metals',
    de: 'Leichtmetallgießereien',
  },
  {
    code: '2454',
    nl: 'Gieten van andere non-ferrometalen',
    fr: 'Fonderie d’autres métaux non ferreux',
    en: 'Casting of other non-ferrous metals',
    de: 'Buntmetallgießereien',
  },
  {
    code: '2511',
    nl: 'Vervaardiging van metalen constructiewerken en delen daarvan',
    fr: 'Fabrication de structures métalliques et de parties de structures',
    en: 'Manufacture of metal structures and parts of structures',
    de: 'Herstellung von Metallkonstruktionen',
  },
  {
    code: '2512',
    nl: 'Vervaardiging van metalen deuren en vensters',
    fr: 'Fabrication de portes et fenêtres en métal',
    en: 'Manufacture of doors and windows of metal',
    de: 'Herstellung von Ausbauelementen aus Metall',
  },
  {
    code: '2521',
    nl: 'Vervaardiging van radiatoren, stoomketels en ketels voor centrale verwarming',
    fr: 'Fabrication de radiateurs, de générateurs de vapeur et de chaudières pour le chauffage central',
    en: 'Manufacture of central heating radiators, steam generators and boilers',
    de: 'Herstellung von Heizkörpern, Dampfkesseln und Kesseln zum Erzeugen von überhitztem Wasser',
  },
  {
    code: '2522',
    nl: 'Vervaardiging van andere tanks, reservoirs en bergingsmiddelen, van metaal',
    fr: 'Fabrication d’autres réservoirs, citernes et conteneurs métalliques',
    en: 'Manufacture of other tanks, reservoirs and containers of metal',
    de: 'Herstellung von Sammelbehältern, Tanks u. Ä. Behältern aus Metall',
  },
  {
    code: '2530',
    nl: 'Vervaardiging van wapens en munitie',
    fr: 'Fabrication d’armes et de munitions',
    en: 'Manufacture of weapons and ammunition',
    de: 'Herstellung von Waffen und Munition',
  },
  {
    code: '2540',
    nl: 'Smeden en bewerken van metaal en poedermetallurgie',
    fr: 'Forgeage et façonnage de métal; métallurgie des poudres',
    en: 'Forging and shaping metal and powder metallurgy',
    de: 'Herstellung von Schmiede-, Press-, Zieh- und Stanzteilen und pulvermetallurgischen Erzeugnissen',
  },
  {
    code: '25401',
    nl: 'Smeden van metaal',
    fr: 'Forgeage de métal',
    en: 'Forging metal',
    de: 'Herstellung von Schmiedeteilen',
  },
  {
    code: '25402',
    nl: 'Bewerken van metaal en poedermetallurgie',
    fr: 'Façonnage de métal; métallurgie des poudres',
    en: 'Shaping metal and powder metallurgy',
    de: 'Herstellung von Press-, Zieh- und Stanzteilen und pulvermetallurgischen Erzeugnissen',
  },
  {
    code: '2551',
    nl: 'Coating van metalen',
    fr: 'Revêtement des métaux',
    en: 'Coating of metals',
    de: 'Beschichten von Metallen',
  },
  {
    code: '2552',
    nl: 'Warmtebehandeling van metaal',
    fr: 'Traitement thermique des métaux',
    en: 'Heat treatment of metals',
    de: 'Wärmebehandlung von Metallen',
  },
  {
    code: '2553',
    nl: 'Verspanend bewerken van metalen',
    fr: 'Usinage des métaux',
    en: 'Machining of metals',
    de: 'Metallbearbeitung',
  },
  {
    code: '2561',
    nl: 'Vervaardiging van scharen, messen, bestekken enz.',
    fr: 'Fabrication de coutellerie',
    en: 'Manufacture of cutlery',
    de: 'Herstellung von Schneidwaren und Bestecken aus unedlen Metallen',
  },
  {
    code: '2562',
    nl: 'Vervaardiging van hang- en sluitwerk',
    fr: 'Fabrication de serrures et de ferrures',
    en: 'Manufacture of locks and hinges',
    de: 'Herstellung von Schlössern und Beschlägen aus unedlen Metallen',
  },
  {
    code: '2563',
    nl: 'Vervaardiging van gereedschap',
    fr: 'Fabrication d’outillage',
    en: 'Manufacture of tools',
    de: 'Herstellung von Werkzeugen',
  },
  {
    code: '25631',
    nl: 'Vervaardiging van vormkasten en gietvormen',
    fr: 'Fabrication de moules et modèles',
    en: 'Manufacture of moulds and models',
    de: 'Herstellung von Formenkästen und Gießformen',
  },
  {
    code: '25639',
    nl: 'Vervaardiging van gereedschap, m.u.v. vormkasten en gietvormen',
    fr: "Fabrication d'outillage, à l’exception des moules et des modèles",
    en: 'Manufacture of tools, except moulds and models',
    de: 'Herstellung von Werkzeugen mit Ausnahme von Formkästen und Gussformen',
  },
  {
    code: '2591',
    nl: 'Vervaardiging van stalen vaten en dergelijke',
    fr: 'Fabrication de fûts et emballages métalliques similaires',
    en: 'Manufacture of steel drums and similar containers',
    de: 'Herstellung von Fässern, Trommeln, Dosen, Eimern u. Ä. Behältern aus Metall',
  },
  {
    code: '2592',
    nl: 'Vervaardiging van verpakkingsmiddelen van licht metaal',
    fr: 'Fabrication d’emballages métalliques légers',
    en: 'Manufacture of light metal packaging',
    de: 'Herstellung von Verpackungen und Verschlüssen aus Eisen, Stahl und NE-Metall',
  },
  {
    code: '2593',
    nl: 'Vervaardiging van artikelen van draad en van kettingen en veren',
    fr: 'Fabrication d’articles en fils métalliques, de chaînes et de ressorts',
    en: 'Manufacture of wire products, chain and springs',
    de: 'Herstellung von Drahtwaren, Ketten und Federn',
  },
  {
    code: '2594',
    nl: 'Vervaardiging van bouten, schroeven en moeren',
    fr: "Fabrication de vis, de boulons et d'écrous",
    en: 'Manufacture of fasteners and screw machine products',
    de: 'Herstellung von Schrauben und Nieten',
  },
  {
    code: '2599',
    nl: 'Vervaardiging van andere producten van metaal n.e.g.',
    fr: 'Fabrication d’autres produits métalliques n.c.a.',
    en: 'Manufacture of other fabricated metal products n.e.c.',
    de: 'Herstellung von sonstigen Metallwaren a. n. g.',
  },
  {
    code: '25991',
    nl: 'Vervaardiging van huishoudelijke en sanitaire producten van metaal',
    fr: "Fabrication d'articles métalliques à usage ménager et sanitaire",
    en: 'Manufacture of metal household and sanitary articles',
    de: 'Herstellung von Haushalts- und Sanitärwaren aus Metall',
  },
  {
    code: '25999',
    nl: 'Vervaardiging van overige producten van metaal, n.e.g.',
    fr: "Fabrication d'autres articles métalliques n.c.a.",
    en: 'Manufacture of other metal products n.e.c.',
    de: 'Herstellung von sonstigen Metallwaren a.n.g.',
  },
  {
    code: '2611',
    nl: 'Vervaardiging van elektronische onderdelen',
    fr: 'Fabrication de composants électroniques',
    en: 'Manufacture of electronic components',
    de: 'Herstellung von elektronischen Bauelementen',
  },
  {
    code: '2612',
    nl: 'Vervaardiging van elektronische printplaten',
    fr: 'Fabrication de cartes électroniques assemblées',
    en: 'Manufacture of loaded electronic boards',
    de: 'Herstellung von bestückten Leiterplatten',
  },
  {
    code: '2620',
    nl: 'Vervaardiging van computers en randapparatuur',
    fr: 'Fabrication d’ordinateurs et d’équipements périphériques',
    en: 'Manufacture of computers and peripheral equipment',
    de: 'Herstellung von Datenverarbeitungsgeräten und peripheren Geräten',
  },
  {
    code: '2630',
    nl: 'Vervaardiging van communicatieapparatuur',
    fr: 'Fabrication d’équipements de communication',
    en: 'Manufacture of communication equipment',
    de: 'Herstellung von Geräten und Einrichtungen der Telekommunikationstechnik',
  },
  {
    code: '2640',
    nl: 'Vervaardiging van consumentenelektronica',
    fr: 'Fabrication de produits électroniques grand public',
    en: 'Manufacture of consumer electronics',
    de: 'Herstellung von Geräten der Unterhaltungselektronik',
  },
  {
    code: '2651',
    nl: 'Vervaardiging van meet-, controle- en navigatie-instrumenten en -apparatuur',
    fr: 'Fabrication d’instruments et d’appareils de mesure, d’essai et de navigation',
    en: 'Manufacture of instruments and appliances for measuring, testing and navigation',
    de: 'Herstellung von Mess-, Kontroll-, Navigations- u. Ä. Instrumenten und Vorrichtungen',
  },
  {
    code: '2652',
    nl: 'Vervaardiging van klokken en horloges',
    fr: "Fabrication d'horloges et de montres",
    en: 'Manufacture of watches and clocks',
    de: 'Herstellung von Uhren',
  },
  {
    code: '2660',
    nl: 'Vervaardiging van bestralingsapparatuur en van elektromedische en elektrotherapeutische apparatuur',
    fr: 'Fabrication d’équipements d’irradiation médicale, d’équipements électromédicaux et électrothérapeutiques',
    en: 'Manufacture of irradiation, electromedical and electrotherapeutic equipment',
    de: 'Herstellung von Bestrahlungs- und Elektrotherapiegeräten und elektromedizinischen Geräten',
  },
  {
    code: '2670',
    nl: 'Vervaardiging van optische instrumenten, magnetische en optische dragers en fotografische apparatuur',
    fr: 'Fabrication de matériels optique et photographique et de supports magnétiques et optiques',
    en: 'Manufacture of optical instruments, magnetic and optical media and photographic equipment',
    de: 'Herstellung von optischen und fotografischen Instrumenten und Geräten sowie von magnetischen und optischen Datenträgern',
  },
  {
    code: '2711',
    nl: 'Vervaardiging van elektromotoren en van elektrische generatoren en transformatoren',
    fr: 'Fabrication de moteurs, génératrices et transformateurs électriques',
    en: 'Manufacture of electric motors, generators and transformers',
    de: 'Herstellung von Elektromotoren, Generatoren und Transformatoren',
  },
  {
    code: '2712',
    nl: 'Vervaardiging van schakel- en verdeelinrichtingen',
    fr: 'Fabrication de matériel de distribution et de commande électrique',
    en: 'Manufacture of electricity distribution and control apparatus',
    de: 'Herstellung von Elektrizitätsverteilungs- und -schalteinrichtungen',
  },
  {
    code: '2720',
    nl: 'Vervaardiging van batterijen en accumulatoren',
    fr: 'Fabrication de piles et d’accumulateurs électriques',
    en: 'Manufacture of batteries and accumulators',
    de: 'Herstellung von Batterien und Akkumulatoren',
  },
  {
    code: '2731',
    nl: 'Vervaardiging van kabels van optische vezels',
    fr: 'Fabrication de câbles de fibres optiques',
    en: 'Manufacture of fibre optic cables',
    de: 'Herstellung von Glasfaserkabeln',
  },
  {
    code: '2732',
    nl: 'Vervaardiging van andere elektrische en elektronische draden en kabels',
    fr: 'Fabrication d’autres fils et câbles électroniques ou électriques',
    en: 'Manufacture of other electronic and electric wires and cables',
    de: 'Herstellung von sonstigen elektronischen und elektrischen Drähten und Kabeln',
  },
  {
    code: '2733',
    nl: 'Vervaardiging van onderdelen van elektrische installaties',
    fr: 'Fabrication de matériel d’installation électrique',
    en: 'Manufacture of wiring devices',
    de: 'Herstellung von elektrischem Installationsmaterial',
  },
  {
    code: '2740',
    nl: 'Vervaardiging van verlichtingsbenodigdheden',
    fr: 'Fabrication d’appareils d’éclairage',
    en: 'Manufacture of lighting equipment',
    de: 'Herstellung von Lampen und Leuchten',
  },
  {
    code: '27401',
    nl: 'Vervaardiging van lampen',
    fr: 'Fabrication de lampes',
    en: 'Manufacture of lamps',
    de: 'Herstellung von elektrischen Lampen',
  },
  {
    code: '27402',
    nl: 'Vervaardiging van verlichtingsapparaten',
    fr: "Fabrication d'appareils d'éclairage électrique",
    en: 'Manufacture of electric lighting equipment',
    de: 'Herstellung von sonstigen elektrischen Leuchten',
  },
  {
    code: '2751',
    nl: 'Vervaardiging van elektrische huishoudapparaten',
    fr: 'Fabrication d’appareils électroménagers',
    en: 'Manufacture of electric domestic appliances',
    de: 'Herstellung von elektrischen Haushaltsgeräten',
  },
  {
    code: '2752',
    nl: 'Vervaardiging van niet-elektrische huishoudapparaten',
    fr: 'Fabrication d’appareils ménagers non électriques',
    en: 'Manufacture of non-electric domestic appliances',
    de: 'Herstellung von nichtelektrischen Haushaltsgeräten',
  },
  {
    code: '2790',
    nl: 'Vervaardiging van andere elektrische apparatuur',
    fr: 'Fabrication d’autres matériels électriques',
    en: 'Manufacture of other electrical equipment',
    de: 'Herstellung von sonstigen elektrischen Ausrüstungen und Geräten',
  },
  {
    code: '2811',
    nl: 'Vervaardiging van motoren en turbines, exclusief motoren voor luchtvaartuigen, motorvoertuigen en bromfietsen',
    fr: 'Fabrication de moteurs et turbines, à l’exception des moteurs d’avions, de véhicules automobiles et de cyclomoteurs',
    en: 'Manufacture of engines and turbines, except aircraft, vehicle and cycle engines',
    de: 'Herstellung von Verbrennungsmotoren und Turbinen, ohne Motoren für Luft- und Straßenfahrzeuge',
  },
  {
    code: '2812',
    nl: 'Vervaardiging van hydraulische en pneumatische apparatuur',
    fr: 'Fabrication d’équipements de transmission de puissance hydrauliques et pneumatiques',
    en: 'Manufacture of fluid power equipment',
    de: 'Herstellung von hydraulischen und pneumatischen Komponenten und Systemen',
  },
  {
    code: '2813',
    nl: 'Vervaardiging van andere pompen en compressoren',
    fr: 'Fabrication d’autres pompes et compresseurs',
    en: 'Manufacture of other pumps and compressors',
    de: 'Herstellung von sonstigen Pumpen und Kompressoren',
  },
  {
    code: '2814',
    nl: 'Vervaardiging van andere kranen en dergelijke artikelen',
    fr: 'Fabrication d’autres articles de robinetterie',
    en: 'Manufacture of other taps and valves',
    de: 'Herstellung von sonstigen Armaturen',
  },
  {
    code: '2815',
    nl: 'Vervaardiging van tandwielen, lagers en andere drijfwerkelementen',
    fr: 'Fabrication de roulements et de transmissions mécaniques',
    en: 'Manufacture of bearings, gears, gearing and driving elements',
    de: 'Herstellung von Lagern, Getrieben, Zahnrädern und Antriebselementen',
  },
  {
    code: '2821',
    nl: 'Vervaardiging van ovens en permanente verwarmingstoestellen voor huishoudelijk gebruik',
    fr: 'Fabrication de fours et brûleurs et d’équipements fixes de chauffage domestique',
    en: 'Manufacture of ovens, furnaces and permanent household heating equipment',
    de: 'Herstellung von Öfen, Brennern und ortsfesten Heizgeräten für den Haushalt',
  },
  {
    code: '2822',
    nl: 'Vervaardiging van hijs-, hef- en transportwerktuigen',
    fr: 'Fabrication de matériel de levage et de manutention',
    en: 'Manufacture of lifting and handling equipment',
    de: 'Herstellung von Hebezeugen und Fördermitteln',
  },
  {
    code: '2823',
    nl: 'Vervaardiging van kantoormachines en -uitrusting (exclusief computers en randapparatuur)',
    fr: 'Fabrication de machines et d’équipements de bureau (à l’exception des ordinateurs et équipements périphériques)',
    en: 'Manufacture of office machinery and equipment, except computers and peripheral equipment',
    de: 'Herstellung von Büromaschinen, ohne Datenverarbeitungsgeräte und periphere Geräte',
  },
  {
    code: '2824',
    nl: 'Vervaardiging van elektrisch handgereedschap',
    fr: 'Fabrication d’outillage portatif à moteur incorporé',
    en: 'Manufacture of power-driven hand tools',
    de: 'Herstellung von handgeführten Werkzeugen mit Motorantrieb',
  },
  {
    code: '2825',
    nl: 'Vervaardiging van machines en apparaten voor klimaatregeling, voor niet-huishoudelijk gebruik',
    fr: "Fabrication de machines et d'appareils conditionnement d’air pour usage non domestique",
    en: 'Manufacture of non-domestic air conditioning equipment',
    de: 'Herstellung von kälte- und lufttechnischen Erzeugnissen, nicht für den Haushalt',
  },
  {
    code: '2829',
    nl: 'Vervaardiging van andere machines en apparaten voor algemeen gebruik, n.e.g.',
    fr: 'Fabrication de machines diverses d’usage général',
    en: 'Manufacture of other general-purpose machinery n.e.c.',
    de: 'Herstellung von sonstigen nicht wirtschaftszweigspezifischen Maschinen a. n. g.',
  },
  {
    code: '28291',
    nl: 'Vervaardiging van verpakkingsmachines',
    fr: "Fabrication d'équipements d'emballage",
    en: 'Manufacture of packaging equipment',
    de: 'Herstellung von Verpackungsmaschinen und -apparaten',
  },
  {
    code: '28292',
    nl: 'Vervaardiging van weegtoestellen',
    fr: "Fabrication d'appareils de pesage",
    en: 'Manufacture of weighing devices',
    de: 'Herstellung von Waagen',
  },
  {
    code: '28293',
    nl: 'Vervaardiging van toestellen voor het spuiten van vloeistoffen of poeder, inclusief brandblusapparaten',
    fr: "Fabrication d'appareils de projection, y compris les extincteurs",
    en: 'Manufacture of spraying equipment, including fire extinguishers',
    de: 'Herstellung von Geräten zum Sprühen von Flüssigkeiten oder Puder, einschliesslich Feuerlöscher',
  },
  {
    code: '28294',
    nl: 'Vervaardiging van verkoopautomaten',
    fr: 'Fabrication de machines automatiques de vente de produits',
    en: 'Manufacture of automatic vending machines',
    de: 'Herstellung von Warenverkaufsautomaten',
  },
  {
    code: '28295',
    nl: 'Vervaardiging van filtreertoestellen',
    fr: "Fabrication d'appareils de filtrage",
    en: 'Manufacture of filtering devices',
    de: 'Herstellung von Filterapparaten',
  },
  {
    code: '28296',
    nl: 'Vervaardiging van hogedrukreinigers, zandstraalapparaten en dergelijk reinigingsmateriaal',
    fr: 'Fabrication de nettoyeurs à haute pression, de matériel industriel de nettoyage au sable et similaires',
    en: 'Manufacture of pressure cleaners, industrial sand blasting and similar equipment',
    de: 'Herstellung von Hochdruckreinigern, Sandstrahlgeräten und ähnlichen Reinigungsapparten',
  },
  {
    code: '28299',
    nl: 'Vervaardiging van overige machines en apparaten voor algemeen gebruik, n.e.g.',
    fr: "Fabrication d'autres machines et appareils d'usage général n.c.a.",
    en: 'Manufacture of other general-purpose machinery and appliances n.e.c.',
    de: 'Herstellung von sonstigen nicht wirtschaftszweigspezifischen Maschinen a. n. g.',
  },
  {
    code: '2830',
    nl: 'Vervaardiging van machines voor de landbouw en de bosbouw',
    fr: 'Fabrication de machines agricoles et forestières',
    en: 'Manufacture of agricultural and forestry machinery',
    de: 'Herstellung von land- und forstwirtschaftlichen Maschinen',
  },
  {
    code: '2841',
    nl: 'Vervaardiging van niet-verspanende machines voor de metaalbewerking en van gereedschapswerktuigen voor metaalbewerking',
    fr: 'Fabrication de machines et machines-outils pour le formage et le travail des métaux',
    en: 'Manufacture of metal forming machinery and machine tools for metal work',
    de: 'Herstellung von Werkzeugmaschinen für die Metallbearbeitung',
  },
  {
    code: '2842',
    nl: 'Vervaardiging van andere gereedschapswerktuigen',
    fr: 'Fabrication d’autres machines-outils',
    en: 'Manufacture of other machine tools',
    de: 'Herstellung von sonstigen Werkzeugmaschinen',
  },
  {
    code: '2891',
    nl: 'Vervaardiging van machines voor de metallurgie',
    fr: 'Fabrication de machines pour la métallurgie',
    en: 'Manufacture of machinery for metallurgy',
    de: 'Herstellung von Maschinen für die Metallerzeugung, von Walzwerkseinrichtungen und Gießmaschinen',
  },
  {
    code: '2892',
    nl: 'Vervaardiging van machines voor de winning van delfstoffen en voor de bouw',
    fr: 'Fabrication de machines pour l’extraction ou la construction',
    en: 'Manufacture of machinery for mining, quarrying and construction',
    de: 'Herstellung von Bergwerks-, Bau- und Baustoffmaschinen',
  },
  {
    code: '2893',
    nl: 'Vervaardiging van machines voor de productie van voedings- en genotmiddelen',
    fr: 'Fabrication de machines pour l’industrie agroalimentaire et la transformation du tabac',
    en: 'Manufacture of machinery for food, beverage and tobacco processing',
    de: 'Herstellung von Maschinen für die Nahrungs- und Genussmittelerzeugung und die Tabakverarbeitung',
  },
  {
    code: '2894',
    nl: 'Vervaardiging van machines voor de productie van textiel, kleding en leer',
    fr: 'Fabrication de machines pour les industries textiles et du cuir',
    en: 'Manufacture of machinery for textile, apparel and leather production',
    de: 'Herstellung von Maschinen für die Textil- und Bekleidungsherstellung und die Lederverarbeitung',
  },
  {
    code: '2895',
    nl: 'Vervaardiging van machines voor de productie van papier en karton',
    fr: 'Fabrication de machines pour les industries du papier et du carton',
    en: 'Manufacture of machinery for paper and paperboard production',
    de: 'Herstellung von Maschinen für die Papiererzeugung und -verarbeitung',
  },
  {
    code: '2896',
    nl: 'Vervaardiging van machines voor de kunststof- en rubberindustrie',
    fr: 'Fabrication de machines pour le travail du caoutchouc ou des plastiques',
    en: 'Manufacture of plastics and rubber machinery',
    de: 'Herstellung von Maschinen für die Verarbeitung von Kunststoffen und Kautschuk',
  },
  {
    code: '2897',
    nl: 'Vervaardiging van machines voor additieve productie',
    fr: 'Fabrication de machines de fabrication additive',
    en: 'Manufacture of additive manufacturing machinery',
    de: 'Herstellung von Maschinen für die additive Fertigung',
  },
  {
    code: '2899',
    nl: 'Vervaardiging van andere machines voor specifieke doeleinden n.e.g.',
    fr: 'Fabrication d’autres machines d’usage spécifique n.c.a.',
    en: 'Manufacture of other special-purpose machinery n.e.c.',
    de: 'Herstellung von Maschinen für sonstige bestimmte Wirtschaftszweige a. n. g.',
  },
  {
    code: '2910',
    nl: 'Vervaardiging van motorvoertuigen',
    fr: 'Construction de véhicules automobiles',
    en: 'Manufacture of motor vehicles',
    de: 'Herstellung von Kraftwagen und Kraftwagenmotoren',
  },
  {
    code: '2920',
    nl: 'Vervaardiging van carrosserieën voor motorvoertuigen; vervaardiging van aanhangwagens en opleggers',
    fr: 'Fabrication de carrosseries de véhicules automobiles; fabrication de remorques et de semi-remorques',
    en: 'Manufacture of bodies and coachwork for motor vehicles; manufacture of trailers and semi-trailers',
    de: 'Herstellung von Karosserien, Aufbauten und Anhängern',
  },
  {
    code: '29201',
    nl: 'Vervaardiging van carrosserieën voor motorvoertuigen',
    fr: 'Fabrication de carrosseries de véhicules automobiles',
    en: 'Manufacture of bodies and coachwork for motor vehicles',
    de: 'Herstellung von Karosserien für Kraftfahrzeuge',
  },
  {
    code: '29202',
    nl: 'Vervaardiging van aanhangwagens, opleggers en caravans',
    fr: 'Fabrication de remorques, de semi-remorques et de caravanes',
    en: 'Manufacture of trailers, semi-trailers and caravans',
    de: 'Herstellung von Aufbauten, Anhängern und Wohnwagen',
  },
  {
    code: '2931',
    nl: 'Vervaardiging van elektrische en elektronische benodigdheden voor motorvoertuigen',
    fr: 'Fabrication d’équipements électriques et électroniques pour véhicules automobiles',
    en: 'Manufacture of electrical and electronic equipment for motor vehicles',
    de: 'Herstellung elektrischer und elektronischer Ausrüstungsgegenstände für Kraftwagen',
  },
  {
    code: '2932',
    nl: 'Vervaardiging van andere delen en toebehoren voor motorvoertuigen',
    fr: "Fabrication d'autres pièces et accessoires pour véhicules automobiles",
    en: 'Manufacture of other parts and accessories for motor vehicles',
    de: 'Herstellung von sonstigen Teilen und sonstigem Zubehör für Kraftwagen',
  },
  {
    code: '3011',
    nl: 'Bouw van civiele schepen en drijvend materieel',
    fr: 'Construction de navires et de structures flottantes civiles',
    en: 'Building of civilian ships and floating structures',
    de: 'Bau von Schiffen und schwimmenden Vorrichtungen für zivile Zwecke, ohne Boots- und Yachtbau',
  },
  {
    code: '3012',
    nl: 'Bouw van plezier- en sportvaartuigen',
    fr: 'Construction de bateaux de plaisance et de sport',
    en: 'Building of pleasure and sporting boats',
    de: 'Boots- und Yachtbau',
  },
  {
    code: '3013',
    nl: 'Bouw van militaire schepen en vaartuigen',
    fr: 'Construction de bateaux et navires militaires',
    en: 'Building of military ships and vessels',
    de: 'Bau von Kriegsschiffen',
  },
  {
    code: '3020',
    nl: 'Vervaardiging van locomotieven en ander rollend materieel voor spoorwegen',
    fr: 'Construction de locomotives et d’autre matériel ferroviaire roulant',
    en: 'Manufacture of railway locomotives and rolling stock',
    de: 'Schienenfahrzeugbau',
  },
  {
    code: '3031',
    nl: 'Vervaardiging van civiele lucht- en ruimtevaartuigen en van toestellen in verband daarmee',
    fr: 'Construction d’aéronefs et d’engins spatiaux civils et machines connexes',
    en: 'Manufacture of civilian air and spacecraft and related machinery',
    de: 'Luft- und Raumfahrzeugbau für zivile Zwecke',
  },
  {
    code: '3032',
    nl: 'Vervaardiging van militaire lucht- en ruimtevaartuigen en van toestellen in verband daarmee',
    fr: 'Construction d’aéronefs et d’engins spatiaux militaires et machines connexes',
    en: 'Manufacture of military air and spacecraft and related machinery',
    de: 'Luft- und Raumfahrzeugbau für militärische Zwecke',
  },
  {
    code: '3040',
    nl: 'Vervaardiging van militaire gevechtsvoertuigen',
    fr: 'Construction de véhicules militaires de combat',
    en: 'Manufacture of military fighting vehicles',
    de: 'Herstellung von militärischen Kampffahrzeugen',
  },
  {
    code: '3091',
    nl: 'Vervaardiging van motorfietsen',
    fr: 'Fabrication de motocycles',
    en: 'Manufacture of motorcycles',
    de: 'Herstellung von Krafträdern',
  },
  {
    code: '3092',
    nl: 'Vervaardiging van fietsen en invalidenwagens',
    fr: 'Fabrication de bicyclettes et de véhicules pour invalides',
    en: 'Manufacture of bicycles and invalid carriages',
    de: 'Herstellung von Fahrrädern sowie von Behindertenfahrzeugen',
  },
  {
    code: '3099',
    nl: 'Vervaardiging van andere transportmiddelen, n.e.g.',
    fr: 'Fabrication d’autres équipements de transport n.c.a.',
    en: 'Manufacture of other transport equipment n.e.c.',
    de: 'Herstellung von sonstigen Beförderungsmitteln a. n. g.',
  },
  {
    code: '3100',
    nl: 'Vervaardiging van meubelen',
    fr: 'Fabrication de meubles',
    en: 'Manufacture of furniture',
    de: 'Herstellung von Möbeln',
  },
  {
    code: '31001',
    nl: 'Vervaardiging van kantoor- en winkelmeubelen',
    fr: 'Fabrication de meubles de bureau et de magasin',
    en: 'Manufacture of office and shop furniture',
    de: 'Herstellung von Büro- und Ladenmöbeln',
  },
  {
    code: '31002',
    nl: 'Vervaardiging van keukenmeubelen',
    fr: 'Fabrication de meubles de cuisine',
    en: 'Manufacture of kitchen furniture',
    de: 'Herstellung von Küchenmöbeln',
  },
  {
    code: '31003',
    nl: 'Vervaardiging van matrassen',
    fr: 'Fabrication de matelas',
    en: 'Manufacture of mattresses',
    de: 'Herstellung von Matratzen',
  },
  {
    code: '31004',
    nl: 'Vervaardiging van eetkamer-, zitkamer-, slaapkamer- en badkamermeubelen',
    fr: 'Fabrication de meubles de salle à manger, de salon, de chambre à coucher et de salle de bain',
    en: 'Manufacture of furniture for dining room, living room, bedroom and bathroom',
    de: 'Herstellung von Ess-, Wohn-, Schlaf- und Badezimmermöbeln',
  },
  {
    code: '31009',
    nl: 'Vervaardiging van andere meubelen, n.e.g.',
    fr: "Fabrication d'autres meubles n.c.a.",
    en: 'Manufacture of other furniture n.e.c.',
    de: 'Herstellung von sonstigen Möbeln a.n.g.',
  },
  {
    code: '3211',
    nl: 'Slaan van munten',
    fr: 'Frappe de monnaie',
    en: 'Striking of coins',
    de: 'Herstellung von Münzen',
  },
  {
    code: '3212',
    nl: 'Bewerken van edelstenen en vervaardiging van sieraden en dergelijke artikelen',
    fr: 'Fabrication d’articles de joaillerie et bijouterie',
    en: 'Manufacture of jewellery and related articles',
    de: 'Herstellung von Münzen, Schmuck und ähnlichen Erzeugnissen',
  },
  {
    code: '32121',
    nl: 'Bewerken van diamant',
    fr: 'Travail du diamant',
    en: 'Processing of diamonds',
    de: 'Bearbeitung von Diamanten',
  },
  {
    code: '32122',
    nl: 'Bewerken van edelstenen (m.u.v. diamant) en van halfedelstenen',
    fr: 'Travail des pierres précieuses (sauf le diamant) et des pierres semiprécieuses',
    en: 'Processing of precious stones (excluding diamonds) and semi-precious stones',
    de: 'Bearbeitung von Edelsteinen (außer Diamanten) und von Halbedelsteinen',
  },
  {
    code: '32123',
    nl: 'Vervaardiging van sieraden',
    fr: 'Fabrication de bijoux',
    en: 'Manufacture of jewels',
    de: 'Herstellung von Schmuckstücken',
  },
  {
    code: '32124',
    nl: 'Vervaardiging van edelsmeedwerk',
    fr: "Fabrication d'articles d'orfèvrerie",
    en: "Manufacture of goldsmith's articles",
    de: 'Herstellung von Gold- und Silberschmiedewaren',
  },
  {
    code: '32129',
    nl: 'Vervaardiging van overige artikelen van edele metalen, n.e.g.',
    fr: "Fabrication d'articles de joaillerie et de bijouterie n.c.a.",
    en: 'Manufacture of jewellery and related articles n.e.c.',
    de: 'Herstellung von sonstigen Artikeln aus Edelmetallen a.n.g.',
  },
  {
    code: '3213',
    nl: 'Vervaardiging van imitatiesieraden en dergelijke artikelen',
    fr: 'Fabrication d’articles de bijouterie fantaisie et articles similaires',
    en: 'Manufacture of imitation jewellery and related articles',
    de: 'Herstellung von Fantasieschmuck',
  },
  {
    code: '3220',
    nl: 'Vervaardiging van muziekinstrumenten',
    fr: 'Fabrication d’instruments de musique',
    en: 'Manufacture of musical instruments',
    de: 'Herstellung von Musikinstrumenten',
  },
  {
    code: '3230',
    nl: 'Vervaardiging van sportartikelen',
    fr: 'Fabrication d’articles de sport',
    en: 'Manufacture of sports goods',
    de: 'Herstellung von Sportgeräten',
  },
  {
    code: '3240',
    nl: 'Vervaardiging van spellen en speelgoed',
    fr: 'Fabrication de jeux et jouets',
    en: 'Manufacture of games and toys',
    de: 'Herstellung von Spielwaren',
  },
  {
    code: '3250',
    nl: 'Vervaardiging van medische en tandheelkundige instrumenten en benodigdheden',
    fr: 'Fabrication d’instruments et de fournitures à usage médical et dentaire',
    en: 'Manufacture of medical and dental instruments and supplies',
    de: 'Herstellung von medizinischen und zahnmedizinischen Apparaten und Materialien',
  },
  {
    code: '3291',
    nl: 'Vervaardiging van borstelwaren',
    fr: 'Fabrication d’articles de brosserie',
    en: 'Manufacture of brooms and brushes',
    de: 'Herstellung von Besen und Bürsten',
  },
  {
    code: '3299',
    nl: 'Overige industrie, n.e.g.',
    fr: 'Autres activités manufacturières n.c.a.',
    en: 'Other manufacturing n.e.c.',
    de: 'Herstellung von sonstigen Erzeugnissen a. n. g.',
  },
  {
    code: '3311',
    nl: 'Reparatie en onderhoud van producten van metaal',
    fr: 'Réparation et entretien d’ouvrages en métaux',
    en: 'Repair and maintenance of fabricated metal products',
    de: 'Reparatur und Instandhaltung von Metallerzeugnissen',
  },
  {
    code: '3312',
    nl: 'Reparatie en onderhoud van machines',
    fr: 'Réparation et entretien de machines',
    en: 'Repair and maintenance of machinery',
    de: 'Reparatur und Instandhaltung von Maschinen',
  },
  {
    code: '3313',
    nl: 'Reparatie en onderhoud van elektronische en optische apparatuur',
    fr: 'Réparation et entretien de matériels électroniques et optiques',
    en: 'Repair and maintenance of electronic and optical equipment',
    de: 'Reparatur und Instandhaltung von elektronischen und optischen Geräten',
  },
  {
    code: '3314',
    nl: 'Reparatie en onderhoud van elektrische apparatuur',
    fr: 'Réparation et entretien d’équipements électriques',
    en: 'Repair and maintenance of electrical equipment',
    de: 'Reparatur und Instandhaltung von elektrischen Ausrüstungen',
  },
  {
    code: '3315',
    nl: 'Reparatie en onderhoud van civiele schepen',
    fr: 'Réparation et entretien de bateaux et navires civils',
    en: 'Repair and maintenance of civilian ships and boats',
    de: 'Reparatur und Instandhaltung von zivilen Schiffen, Booten und Yachten',
  },
  {
    code: '3316',
    nl: 'Reparatie en onderhoud van civiele lucht- en ruimtevaartuigen',
    fr: 'Réparation et entretien d’aéronefs et d’engins spatiaux civils',
    en: 'Repair and maintenance of civilian air and spacecraft',
    de: 'Reparatur und Instandhaltung von zivilen Luft- und Raumfahrzeugen',
  },
  {
    code: '3317',
    nl: 'Reparatie en onderhoud van andere civiele transportmiddelen',
    fr: 'Réparation et entretien d’autres équipements de transport civils',
    en: 'Repair and maintenance of other civilian transport equipment',
    de: 'Reparatur und Instandhaltung von sonstigen zivilen Beförderungsmitteln',
  },
  {
    code: '3318',
    nl: 'Reparatie en onderhoud van militaire gevechtsvoertuigen, schepen, lucht- en ruimtevaartuigen',
    fr: 'Réparation et entretien de véhicules de combat, de navires, de bateaux, d’aéronefs et d’engins spatiaux militaires',
    en: 'Repair and maintenance of military fighting vehicles, ships, boats, air and spacecraft',
    de: 'Reparatur und Instandhaltung von militärischen Kampffahrzeugen, Luft- und Raumfahrzeugen sowie Kriegsschiffen',
  },
  {
    code: '3319',
    nl: 'Reparatie en onderhoud van andere apparatuur',
    fr: 'Réparation et entretien d’autres équipements',
    en: 'Repair and maintenance of other equipment',
    de: 'Reparatur und Instandhaltung von sonstigen Ausrüstungen',
  },
  {
    code: '3320',
    nl: 'Installatie van industriële machines, toestellen en werktuigen',
    fr: 'Installation de machines et d’équipements industriels',
    en: 'Installation of industrial machinery and equipment',
    de: 'Installation von Industriemaschinen und -ausrüstungen',
  },
  {
    code: '3511',
    nl: 'Productie van elektriciteit uit niet-hernieuwbare bronnen',
    fr: 'Production d’électricité à partir de sources non renouvelables',
    en: 'Production of electricity from non-renewable sources',
    de: 'Elektrizitätserzeugung aus nicht erneuerbaren Energieträgern',
  },
  {
    code: '3512',
    nl: 'Productie van elektriciteit uit hernieuwbare bronnen',
    fr: 'Production d’électricité à partir de sources renouvelables',
    en: 'Production of electricity from renewable sources',
    de: 'Elektrizitätserzeugung aus erneuerbaren Energieträgern',
  },
  {
    code: '3513',
    nl: 'Transmissie van elektriciteit',
    fr: 'Transport d’électricité',
    en: 'Transmission of electricity',
    de: 'Elektrizitätsübertragung',
  },
  {
    code: '3514',
    nl: 'Distributie van elektriciteit',
    fr: 'Distribution d’électricité',
    en: 'Distribution of electricity',
    de: 'Elektrizitätsverteilung',
  },
  {
    code: '3515',
    nl: 'Handel in elektriciteit',
    fr: 'Commerce d’électricité',
    en: 'Trade of electricity',
    de: 'Elektrizitätshandel',
  },
  {
    code: '3516',
    nl: 'Opslag van elektriciteit',
    fr: 'Stockage de l’électricité',
    en: 'Storage of electricity',
    de: 'Speichern von elektrischer Energie',
  },
  {
    code: '3521',
    nl: 'Productie van gas',
    fr: 'Production de gaz',
    en: 'Manufacture of gas',
    de: 'Gaserzeugung',
  },
  {
    code: '3522',
    nl: 'Distributie van gasvormige brandstoffen via leidingen',
    fr: 'Distribution de combustibles gazeux par conduites',
    en: 'Distribution of gaseous fuels through mains',
    de: 'Gasverteilung durch Rohrleitungen',
  },
  {
    code: '3523',
    nl: 'Handel in gas via leidingen',
    fr: 'Commerce de combustibles gazeux par conduites',
    en: 'Trade of gas through mains',
    de: 'Gashandel durch Rohrleitungen',
  },
  {
    code: '3524',
    nl: 'Opslag van gas als onderdeel van netwerkleveringsdiensten',
    fr: 'Stockage de gaz dans le cadre de services d’approvisionnement en réseau',
    en: 'Storage of gas as part of network supply services',
    de: 'Speichern von Gas zu Versorgungszwecken',
  },
  {
    code: '3530',
    nl: 'Productie en distributie van stoom en gekoelde lucht',
    fr: 'Production et distribution de vapeur et d’air conditionné',
    en: 'Steam and air conditioning supply',
    de: 'Wärme- und Kälteversorgung',
  },
  {
    code: '3540',
    nl: 'Activiteiten van makelaars en agenten voor elektriciteit en aardgas',
    fr: 'Activités des courtiers et agents pour l’électricité et le gaz naturel',
    en: 'Activities of brokers and agents for electric power and natural gas',
    de: 'Tätigkeiten von Strom- und Erdgasmaklerinnen und -maklern',
  },
  {
    code: '3600',
    nl: 'Winning, behandeling en distributie van water',
    fr: 'Captage, traitement et distribution d’eau',
    en: 'Water collection, treatment and supply',
    de: 'Wasserversorgung',
  },
  {
    code: '3700',
    nl: 'Afvalwaterafvoer',
    fr: 'Collecte et traitement des eaux usées',
    en: 'Sewerage',
    de: 'Abwasserentsorgung',
  },
  {
    code: '3811',
    nl: 'Inzameling van ongevaarlijk afval',
    fr: 'Collecte des déchets non dangereux',
    en: 'Collection of non-hazardous waste',
    de: 'Sammlung nicht gefährlicher Abfälle',
  },
  {
    code: '3812',
    nl: 'Inzameling van gevaarlijk afval',
    fr: 'Collecte des déchets dangereux',
    en: 'Collection of hazardous waste',
    de: 'Sammlung gefährlicher Abfälle',
  },
  {
    code: '3821',
    nl: 'Terugwinning van materialen uit afval',
    fr: 'Récupération de matériaux provenant de déchets',
    en: 'Materials recovery',
    de: 'Rückgewinnung',
  },
  {
    code: '3822',
    nl: 'Winning van energie uit afval',
    fr: 'Valorisation énergétique de déchets',
    en: 'Energy recovery',
    de: 'Energetische Verwertung von Abfällen',
  },
  {
    code: '3823',
    nl: 'Andere terugwinning uit afval',
    fr: 'Autre valorisation des déchets',
    en: 'Other waste recovery',
    de: 'Sonstige Verwertung von Abfällen',
  },
  {
    code: '3831',
    nl: 'Verbranding zonder energieterugwinning',
    fr: 'Incinération sans récupération d’énergie',
    en: 'Incineration without energy recovery',
    de: 'Verbrennung von Abfällen ohne energetische Verwertung',
  },
  {
    code: '3832',
    nl: 'Storten of permanent opslaan',
    fr: 'Mise en décharge ou stockage permanent',
    en: 'Landfilling or permanent storage',
    de: 'Deponierung oder Dauerlagerung von Abfällen',
  },
  {
    code: '3833',
    nl: 'Andere afvalverwijdering',
    fr: 'Autre élimination des déchets',
    en: 'Other waste disposal',
    de: 'Sonstige Beseitigung von Abfällen',
  },
  {
    code: '3900',
    nl: 'Sanering en ander afvalbeheer',
    fr: 'Activités de dépollution et autres activités de service de gestion des déchets',
    en: 'Remediation activities and other waste management service activities',
    de: 'Beseitigung von Umweltverschmutzungen und sonstige Tätigkeiten in der Abfallbewirtschaftung',
  },
  {
    code: '4100',
    nl: 'Burgerlijke en utiliteitsbouw',
    fr: 'Construction de bâtiments résidentiels et non résidentiels',
    en: 'Construction of residential and non-residential buildings',
    de: 'Hochbau',
  },
  {
    code: '41001',
    nl: 'Algemene bouw van residentiële gebouwen',
    fr: 'Construction générale de bâtiments résidentiels',
    en: 'General construction of residential buildings',
    de: 'Allgemeiner Bau von Wohngebäuden',
  },
  {
    code: '41002',
    nl: 'Algemene bouw van kantoorgebouwen',
    fr: "Construction générale d'immeubles de bureaux",
    en: 'General construction of office buildings',
    de: 'Algemeiner Bau von Bürogebäuden',
  },
  {
    code: '41003',
    nl: 'Algemene bouw van andere niet-residentiële gebouwen',
    fr: "Construction générale d'autres bâtiments non résidentiels",
    en: 'General construction of other non-residential buildings',
    de: 'Algemeiner Bau von Nichtwohngebäuden',
  },
  {
    code: '4211',
    nl: 'Bouw van autowegen en andere wegen',
    fr: 'Construction de routes et autoroutes',
    en: 'Construction of roads and motorways',
    de: 'Bau von Straßen',
  },
  {
    code: '4212',
    nl: 'Bouw van boven- en ondergrondse spoorwegen',
    fr: 'Construction de voies ferrées de surface et souterraines',
    en: 'Construction of railways and underground railways',
    de: 'Bau von Bahnverkehrsstrecken',
  },
  {
    code: '4213',
    nl: 'Bouw van bruggen en tunnels',
    fr: 'Construction de ponts et tunnels',
    en: 'Construction of bridges and tunnels',
    de: 'Brücken- und Tunnelbau',
  },
  {
    code: '4221',
    nl: 'Bouw van civieltechnische werken voor vloeistoffen',
    fr: "Construction d'ouvrages de génie civil pour les fluides",
    en: 'Construction of utility projects for fluids',
    de: 'Rohrleitungstiefbau, Brunnenbau und Kläranlagenbau',
  },
  {
    code: '42211',
    nl: 'Bouw van water- en gasdistributienetten',
    fr: "Construction de réseaux de distribution d'eau et de gaz",
    en: 'Construction of water and gas distribution networks',
    de: 'Bau von Wasser- und Gasverteilungsnetzen',
  },
  {
    code: '42212',
    nl: 'Bouw van rioleringen',
    fr: "Construction de réseaux d'évacuation des eaux usées",
    en: 'Construction of waste water disposal systems',
    de: 'Bau von Kanalisationsnetzen',
  },
  {
    code: '42219',
    nl: 'Bouw van civieltechnische werken voor vloeistoffen, n.e.g.',
    fr: "Construction d'ouvrages de génie civil pour les fluides, n.c.a.",
    en: 'Construction of utility projects for fluids n.e.c.',
    de: 'Bau von Leitungsnetzen für Flüssigkeiten a.n.g.',
  },
  {
    code: '4222',
    nl: 'Bouw van civieltechnische werken voor elektriciteit en telecommunicatie',
    fr: "Construction d'ouvrages de génie civil pour l'électricité et les télécommunications",
    en: 'Construction of utility projects for electricity and telecommunications',
    de: 'Bau von Versorgungseinrichtungen für Elektrizität und Telekommunikation',
  },
  {
    code: '4291',
    nl: 'Waterbouw',
    fr: 'Construction d’ouvrages maritimes et fluviaux',
    en: 'Construction of water projects',
    de: 'Wasserbau',
  },
  {
    code: '42911',
    nl: 'Baggerwerken',
    fr: 'Travaux de dragage',
    en: 'Dredging',
    de: 'Baggerarbeiten',
  },
  {
    code: '42919',
    nl: 'Waterbouw, m.u.v. baggerwerken',
    fr: "Construction d'autres ouvrages maritimes et fluviaux, à l'exception des travaux de dragage",
    en: 'Construction of water projects, except of dredging',
    de: 'Wasserbau, mit Ausnahme von Baggerarbeiten',
  },
  {
    code: '4299',
    nl: 'Bouw van andere civieltechnische werken, n.e.g.',
    fr: 'Construction d’autres ouvrages de génie civil n.c.a.',
    en: 'Construction of other civil engineering projects n.e.c.',
    de: 'Sonstiger Tiefbau a. n. g.',
  },
  {
    code: '4311',
    nl: 'Slopen',
    fr: 'Démolition',
    en: 'Demolition',
    de: 'Abbrucharbeiten',
  },
  {
    code: '4312',
    nl: 'Bouwrijp maken van terreinen',
    fr: 'Travaux de préparation des sites',
    en: 'Site preparation',
    de: 'Vorbereitende Baustellenarbeiten',
  },
  {
    code: '4313',
    nl: 'Proefboren en boren',
    fr: 'Forages et sondages',
    en: 'Test drilling and boring',
    de: 'Test- und Suchbohrung',
  },
  {
    code: '4321',
    nl: 'Elektrische installatie',
    fr: 'Installation électrique',
    en: 'Electrical installation',
    de: 'Elektroinstallation',
  },
  {
    code: '43211',
    nl: 'Algemene elektrotechnische installatiewerken',
    fr: "Travaux généraux d'installation électrotechnique",
    en: 'General work of electrical installation',
    de: 'Allgemeine elektrotechnische Installationsarbeiten',
  },
  {
    code: '43212',
    nl: 'Elektrotechnische installatiewerken van nijverheidsinrichtingen',
    fr: "Travaux d'installation électrotechnique d’établissements industriels",
    en: 'General work of electrical installation in industrial plants',
    de: 'Elektrotechnische Installationsarbeiten an Industriebauwerke',
  },
  {
    code: '43213',
    nl: 'Installatie van duurzame elektrische installaties',
    fr: "Installation d'installations électriques durables",
    en: 'Installation of durable electrical installations',
    de: 'Installation von dauerhaften Elektroinstallationen',
  },
  {
    code: '43214',
    nl: 'Installatie van elektronische beveiligingssystemen',
    fr: 'Installation de systèmes de sécurité électroniques',
    en: 'Installation of electronic security systems',
    de: 'Installation von elektronischen Sicherheitssystemen',
  },
  {
    code: '4322',
    nl: 'Loodgieterswerk, installatie van verwarming en klimaatregeling',
    fr: 'Travaux de plomberie et installation de chauffage et de conditionnement d’air',
    en: 'Plumbing, heat and air-conditioning installation',
    de: 'Gas-, Wasser-, Heizungs- sowie Lüftungs- und Klimainstallation',
  },
  {
    code: '43221',
    nl: 'Sanitaire werkzaamheden',
    fr: 'Travaux sanitaires',
    en: 'Sanitary work',
    de: 'Sanitärausstattung',
  },
  {
    code: '43222',
    nl: 'Installatie van verwarming, klimaatregeling, koeling en ventilatie  aangedreven door elektriciteit',
    fr: "Installation de systèmes de chauffage, de climatisation, de refroidissement et de ventilation alimentés par l'électricité",
    en: 'Installation of heating, ventilating, air conditioning, refrigeration installations powered by electricity',
    de: 'Heizungs- sowie Lüftungs- und Klimainstallation, getrieben mit elektrischem Strom',
  },
  {
    code: '43223',
    nl: 'Installatie van verwarming, klimaatregeling, koeling en ventilatie aangedreven door andere energiebronnen dan elektriciteit',
    fr: "Installation de systèmes de chauffage, de climatisation,  de refroidissement et de ventilation alimentés par d’autres sources d'énergie que l'électricité",
    en: 'Installation of heating, ventilating, air conditioning, refrigeration installations powered by energy sources other than electricity',
    de: 'Heizungs- sowie Lüftungs- und Klimainstallation, getrieben mit anderen Energiequellen als elektrischem Strom',
  },
  {
    code: '4323',
    nl: 'Installatie van isolatie',
    fr: 'Mise en place de l’isolation',
    en: 'Installation of insulation',
    de: 'Einbau von Isolierungen',
  },
  {
    code: '4324',
    nl: 'Overige bouwinstallatie',
    fr: 'Autres travaux d’installation',
    en: 'Other construction installation',
    de: 'Sonstige Bauinstallation',
  },
  {
    code: '4331',
    nl: 'Stukadoorswerk',
    fr: 'Travaux de plâtrerie',
    en: 'Plastering',
    de: 'Anbringen von Stuckaturen, Gipserei und Verputzerei',
  },
  {
    code: '4332',
    nl: 'Schrijnwerk',
    fr: 'Travaux de menuiserie',
    en: 'Joinery installation',
    de: 'Bautischlerei und -schlosserei',
  },
  {
    code: '4333',
    nl: 'Vloerafwerking en behangen',
    fr: 'Travaux de revêtement des sols et des murs',
    en: 'Floor and wall covering',
    de: 'Fußboden-, Fliesen- und Plattenlegerei, Tapeziererei',
  },
  {
    code: '43331',
    nl: 'Plaatsen van vloer- en wandtegels',
    fr: 'Pose de revêtements des sols et des murs en carrelage',
    en: 'Floor and wall covering with tiles',
    de: 'Fliesen- und Plattenlegerei',
  },
  {
    code: '43332',
    nl: 'Plaatsen van vloerbedekking en wandbekleding van hout',
    fr: 'Pose de revêtements des sols et des murs en bois',
    en: 'Floor and wall covering with wood',
    de: 'Verlegung von Bodenbelägen aus Holz',
  },
  {
    code: '43333',
    nl: 'Plaatsen van behang en vloerbedekking en wandbekleding van andere materialen',
    fr: "Pose de papiers peints et de revêtements de murs et de sols en d'autres matériaux",
    en: 'Floor and wall covering with other materials',
    de: 'Anbringen von Tapeten, Bodenbelägen und Wandbekleidungen aus anderen Materialien',
  },
  {
    code: '4334',
    nl: 'Schilderen en glaszetten',
    fr: 'Travaux de peinture et vitrerie',
    en: 'Painting and glazing',
    de: 'Malerei und Glaserei',
  },
  {
    code: '43341',
    nl: 'Schilderen van gebouwen',
    fr: 'Peinture de bâtiments',
    en: 'Painting of buildings',
    de: 'Anstrich von Gebäuden',
  },
  {
    code: '43342',
    nl: 'Schilderen van civieltechnische werken',
    fr: 'Peinture de travaux de génie civil',
    en: 'Painting of civil engineering works',
    de: 'Anstrich von Ingenieurbauten',
  },
  {
    code: '43343',
    nl: 'Glaszetten',
    fr: 'Vitrerie',
    en: 'Glazing',
    de: 'Glasergewerbe',
  },
  {
    code: '4335',
    nl: 'Overige werkzaamheden in verband met de afwerking van gebouwen',
    fr: 'Autres travaux de finition',
    en: 'Other building completion and finishing',
    de: 'Sonstiger Ausbau',
  },
  {
    code: '4341',
    nl: 'Dakwerkzaamheden',
    fr: 'Travaux de couverture',
    en: 'Roofing activities',
    de: 'Dachdeckerei und Zimmerei',
  },
  {
    code: '4342',
    nl: 'Overige gespecialiseerde bouwactiviteiten in de constructie van gebouwen',
    fr: 'Autres travaux de construction spécialisés dans la construction de bâtiments',
    en: 'Other specialised construction activities in construction of buildings',
    de: 'Sonstige spezialisierte Bautätigkeiten im Hochbau',
  },
  {
    code: '43421',
    nl: 'Waterdichtingswerken van muren',
    fr: "Travaux d'étanchéification des murs",
    en: 'Waterproofing of walls',
    de: 'Arbeiten zur Abdichtung von Mauern',
  },
  {
    code: '43422',
    nl: 'Chapewerken',
    fr: 'Pose de chapes',
    en: 'Laying of screeds',
    de: 'Anbringung von Abdeckungen',
  },
  {
    code: '43429',
    nl: 'Overige gespecialiseerde bouwactiviteiten in de constructie van gebouwen, n.e.g.',
    fr: 'Autres travaux de construction spécialisés dans la construction de bâtiments, n.c.a.',
    en: 'Other specialised construction activities in construction of buildings n.e.c.',
    de: 'Sonstige spezialisierte Bautätigkeiten im Hochbau a.n.g.',
  },
  {
    code: '4350',
    nl: 'Gespecialiseerde bouwactiviteiten op het gebied van weg- en waterbouw',
    fr: 'Travaux de construction spécialisés en génie civil',
    en: 'Specialised construction activities in civil engineering',
    de: 'Spezialisierte Bautätigkeiten im Tiefbau',
  },
  {
    code: '4360',
    nl: 'Bemiddelingsactiviteiten in verband met gespecialiseerde bouwnijverheid',
    fr: 'Activités de service d’intermédiation pour des travaux de construction spécialisés',
    en: 'Intermediation service activities for specialised construction services',
    de: 'Vermittlungstätigkeiten für spezialisierte Bautätigkeiten',
  },
  {
    code: '4391',
    nl: 'Metselwerk',
    fr: 'Travaux de maçonnerie et de pose de briques',
    en: 'Masonry and bricklaying activities',
    de: 'Maurerarbeiten',
  },
  {
    code: '4399',
    nl: 'Overige gespecialiseerde bouwactiviteiten, n.e.g.',
    fr: 'Autres travaux de construction spécialisés n.c.a.',
    en: 'Other specialised construction activities n.e.c.',
    de: 'Sonstige spezialisierte Bautätigkeiten a. n. g.',
  },
  {
    code: '4611',
    nl: 'Handelsbemiddeling in de groothandel in landbouwgrondstoffen, levende dieren en textielgrondstoffen en halffabricaten',
    fr: 'Activités d’intermédiaire du commerce de gros en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis',
    en: 'Activities of agents involved in the wholesale of agricultural raw materials, live animals, textile raw materials and semi-finished goods',
    de: 'Tätigkeiten der Großhandelsvermittlung von landwirtschaftlichen Grundstoffen, lebenden Tieren, textilen Rohstoffen und Halbwaren',
  },
  {
    code: '4612',
    nl: 'Handelsbemiddeling in de groothandel in brandstoffen, ertsen, metalen en chemische producten',
    fr: 'Activités d’intermédiaire du commerce de gros en combustibles, minérais, métaux et produits chimiques',
    en: 'Activities of agents involved in the wholesale of fuels, ores, metals and industrial chemicals',
    de: 'Tätigkeiten der Großhandelsvermittlung von Brennstoffen, Erzen, Metallen und technischen Chemikalien',
  },
  {
    code: '4613',
    nl: 'Handelsbemiddeling in de groothandel in hout en bouwmaterialen',
    fr: 'Activités d’intermédiaire du commerce de gros en bois et matériaux de construction',
    en: 'Activities of agents involved in the wholesale of timber and building materials',
    de: 'Tätigkeiten der Großhandelsvermittlung von Holz, Baustoffen und Anstrichmitteln',
  },
  {
    code: '4614',
    nl: 'Handelsbemiddeling in de groothandel in machines, apparaten en werktuigen voor de industrie en in schepen en luchtvaartuigen',
    fr: 'Activités d’intermédiaire du commerce de gros en machines, équipements industriels, navires et avions',
    en: 'Activities of agents involved in the wholesale of machinery, industrial equipment, ships and aircraft',
    de: 'Tätigkeiten der Großhandelsvermittlung von Maschinen, technischem Bedarf, Wasser- und Luftfahrzeugen',
  },
  {
    code: '4615',
    nl: 'Handelsbemiddeling in de groothandel in meubelen, huishoudelijke artikelen en ijzerwaren',
    fr: 'Activités d’intermédiaire du commerce de gros en meubles, biens domestiques et quincaillerie',
    en: 'Activities of agents involved in the wholesale of furniture, household goods, hardware and ironmongery',
    de: 'Tätigkeiten der Großhandelsvermittlung von Möbeln, Einrichtungs- und Haushaltsgegenständen, Eisen- und Metallwaren',
  },
  {
    code: '4616',
    nl: 'Handelsbemiddeling in de groothandel in textiel, kleding, bont, schoeisel en lederwaren',
    fr: 'Activités d’intermédiaire du commerce de gros en textiles, habillement, fourrures, chaussures et articles en cuir',
    en: 'Activities of agents involved in the wholesale of textiles, clothing, fur, footwear and leather goods',
    de: 'Tätigkeiten der Großhandelsvermittlung von Textilien, Bekleidung, Schuhen und Lederwaren',
  },
  {
    code: '4617',
    nl: 'Handelsbemiddeling in de groothandel in voedings- en genotmiddelen',
    fr: 'Activités d’intermédiaire du commerce de gros en produits alimentaires et tabac',
    en: 'Activities of agents involved in the wholesale of food, beverages and tobacco',
    de: 'Tätigkeiten der Großhandelsvermittlung von Nahrungsmitteln, Getränken und Tabakwaren',
  },
  {
    code: '4618',
    nl: 'Handelsbemiddeling in de groothandel in andere specifieke goederen',
    fr: 'Activités d’intermédiaire spécialisé dans le commerce de gros d’autres produits spécifiques',
    en: 'Activities of agents involved in the wholesale of other particular products',
    de: 'Tätigkeiten der Großhandelsvermittlung von sonstigen Waren',
  },
  {
    code: '4619',
    nl: 'Handelsbemiddeling in de niet-gespecialiseerde groothandel',
    fr: 'Activités d’intermédiaire non spécialisé du commerce de gros',
    en: 'Activities of agents involved in non-specialised wholesale',
    de: 'Tätigkeiten der Großhandelsvermittlung von Waren ohne ausgeprägten Schwerpunkt',
  },
  {
    code: '4621',
    nl: 'Groothandel in granen, ruwe tabak, zaden en diervoeders',
    fr: 'Commerce de gros de céréales, de tabac non manufacturé, de semences et d’aliments pour animaux',
    en: 'Wholesale of grain, unmanufactured tobacco, seeds and animal feeds',
    de: 'Großhandel mit Getreide, Rohtabak, Saatgut und Futtermitteln',
  },
  {
    code: '46211',
    nl: 'Groothandel in granen en zaden',
    fr: 'Commerce de gros de céréales et de semences',
    en: 'Wholesale of grain and seeds',
    de: 'Großhandel mit Getreide und Saatgut',
  },
  {
    code: '46212',
    nl: 'Groothandel in veevoeders',
    fr: "Commerce de gros d'aliments pour le bétail",
    en: 'Wholesale of animal feeds',
    de: 'Großhandel mit Viehfutter',
  },
  {
    code: '46213',
    nl: 'Groothandel in ruwe plantaardige en dierlijke oliën en vetten',
    fr: "Commerce de gros d'huiles et de graisses d'origine végétale et animale",
    en: 'Wholesale of vegetable and animal oils and fats',
    de: 'Großhandel mit Ölen und Speisefetten tierischen und pflanzlichen Ursprungs',
  },
  {
    code: '46214',
    nl: 'Groothandel in andere akkerbouwproducten',
    fr: "Commerce de gros d'autres produits agricoles",
    en: 'Wholesale of other agricultural products',
    de: 'Großhandel mit sonstigen Landwirtschaftsprodukten',
  },
  {
    code: '46215',
    nl: 'Groothandel in ruwe tabak',
    fr: 'Commerce de gros de tabac non manufacturé',
    en: 'Wholesale of raw tobacco',
    de: 'Großhandel mit Rohtabak',
  },
  {
    code: '46216',
    nl: 'Groothandel in akkerbouwproducten en veevoeders, algemeen assortiment',
    fr: "Commerce de gros d'aliments pour le bétail et de produits agricoles, assortiment général",
    en: 'Wholesale of cattle feeds and agricultural products, general selection',
    de: 'Großhandel mit Landwirtschaftsprodukten und Viehfutter, Vollsortiment',
  },
  {
    code: '4622',
    nl: 'Groothandel in bloemen en planten',
    fr: 'Commerce de gros de fleurs et de plantes',
    en: 'Wholesale of flowers and plants',
    de: 'Großhandel mit Blumen und Pflanzen',
  },
  {
    code: '4623',
    nl: 'Groothandel in levende dieren',
    fr: 'Commerce de gros d’animaux vivants',
    en: 'Wholesale of live animals',
    de: 'Großhandel mit lebenden Tieren',
  },
  {
    code: '46231',
    nl: 'Groothandel in levend vee',
    fr: 'Commerce de gros de bétail',
    en: 'Wholesale of cattle',
    de: 'Großhandel mit lebendem Vieh',
  },
  {
    code: '46232',
    nl: 'Groothandel in levende dieren, m.u.v. levend vee',
    fr: "Commerce de gros d'animaux vivants, sauf bétail",
    en: 'Wholesale of live animals, except cattle',
    de: 'Großhandel mit lebenden Tieren, mit Ausnahme von Vieh',
  },
  {
    code: '4624',
    nl: 'Groothandel in huiden, vellen en leer',
    fr: 'Commerce de gros de cuirs et de peaux',
    en: 'Wholesale of hides, skins and leather',
    de: 'Großhandel mit Häuten, Fellen und Leder',
  },
  {
    code: '4631',
    nl: 'Groothandel in groenten en fruit',
    fr: 'Commerce de gros de fruits et légumes',
    en: 'Wholesale of fruit and vegetables',
    de: 'Großhandel mit Obst, Gemüse und Kartoffeln',
  },
  {
    code: '46311',
    nl: 'Groothandel in consumptieaardappelen',
    fr: 'Commerce de gros de pommes de terre de consommation',
    en: 'Wholesale of ware potatoes',
    de: 'Großhandel mit Esskartoffeln',
  },
  {
    code: '46319',
    nl: 'Groothandel in groenten en fruit, m.u.v. consumptieaardappelen',
    fr: 'Commerce de gros de fruits et de légumes, à l’exception des pommes de terre de consommation',
    en: 'Wholesale of fruit and vegetables, except ware potatoes',
    de: 'Großhandel mit Obst und Gemüse, mit Ausnahme von Esskartoffeln',
  },
  {
    code: '4632',
    nl: 'Groothandel in vlees, vleesproducten, vis en visproducten',
    fr: 'Commerce de gros de viande, de produits à base de viande, de poisson et de produits à base de poisson',
    en: 'Wholesale of meat, meat products, fish and fish products',
    de: 'Großhandel mit Fleisch, Fleischwaren, Fisch und Fischerzeugnissen',
  },
  {
    code: '46321',
    nl: 'Groothandel in vlees en vleesproducten, uitgezonderd vlees van wild en van gevogelte',
    fr: 'Commerce de gros de viandes et de produits à base de viande, sauf viande de volaille et de gibier',
    en: 'Wholesale of meat and meat products, except meat of poultry and game animals',
    de: 'Großhandel mit Fleisch und Fleischwaren, mit Ausnahme von Geflügel- und Wildfleisch',
  },
  {
    code: '46322',
    nl: 'Groothandel in vlees van wild en van gevogelte',
    fr: 'Commerce de gros de viande de volaille et de gibier',
    en: 'Wholesale of meat of poultry and game animals',
    de: 'Großhandel mit Fleisch von Geflügel und Wild',
  },
  {
    code: '46323',
    nl: 'Groothandel in vis en schaal- en weekdieren',
    fr: 'Commerce de gros de poissons, crustacés et mollusques',
    en: 'Wholesale of fish, crustaceans and molluscs',
    de: 'Grosshandel mit Fisch, Schalentieren und Muscheln',
  },
  {
    code: '4633',
    nl: 'Groothandel in zuivelproducten, eieren en spijsoliën en -vetten',
    fr: 'Commerce de gros de produits laitiers, œufs, huiles et matières grasses comestibles',
    en: 'Wholesale of dairy products, eggs and edible oils and fats',
    de: 'Großhandel mit Milch, Milcherzeugnissen, Eiern, Speiseölen und Nahrungsfetten',
  },
  {
    code: '46331',
    nl: 'Groothandel in zuivelproducten en eieren',
    fr: "Commerce de gros de produits laitiers et d'oeufs",
    en: 'Wholesale of dairy products and eggs',
    de: 'Großhandel mit Milchprodukten und Eiern',
  },
  {
    code: '46332',
    nl: 'Groothandel in spijsoliën en -vetten',
    fr: "Commerce de gros d'huiles et de matières grasses comestibles",
    en: 'Wholesale of edible oils and fats',
    de: 'Großhandel mit Speiseölen und Nahrungsfetten',
  },
  {
    code: '4634',
    nl: 'Groothandel in dranken',
    fr: 'Commerce de gros de boissons',
    en: 'Wholesale of beverages',
    de: 'Großhandel mit Getränken',
  },
  {
    code: '46341',
    nl: 'Groothandel in wijnen en geestrijke dranken',
    fr: 'Commerce de gros de vin et de spiritueux',
    en: 'Wholesale of wine and spirits',
    de: 'Großhandel mit Wein und Spirituosen',
  },
  {
    code: '46349',
    nl: 'Groothandel in dranken, algemeen assortiment',
    fr: 'Commerce de gros de boissons, assortiment général',
    en: 'Wholesale of beverages, general selection',
    de: 'Großhandel mit Getränken, Vollsortiment',
  },
  {
    code: '4635',
    nl: 'Groothandel in tabaksproducten',
    fr: 'Commerce de gros de produits à base de tabac',
    en: 'Wholesale of tobacco products',
    de: 'Großhandel mit Tabakwaren',
  },
  {
    code: '4636',
    nl: 'Groothandel in suiker, chocolade en suikerwerk',
    fr: 'Commerce de gros de sucre, chocolat et confiserie',
    en: 'Wholesale of sugar, chocolate and sugar confectionery',
    de: 'Großhandel mit Zucker, Süßwaren und Backwaren',
  },
  {
    code: '4637',
    nl: 'Groothandel in koffie, thee, cacao en specerijen',
    fr: 'Commerce de gros de café, thé, cacao et épices',
    en: 'Wholesale of coffee, tea, cocoa and spices',
    de: 'Großhandel mit Kaffee, Tee, Kakao und Gewürzen',
  },
  {
    code: '4638',
    nl: 'Groothandel in andere voedingsmiddelen',
    fr: 'Commerce de gros d’autres denrées alimentaires',
    en: 'Wholesale of other food',
    de: 'Großhandel mit sonstigen Nahrungs- und Genussmitteln',
  },
  {
    code: '46381',
    nl: 'Groothandel in aardappelproducten',
    fr: 'Commerce de gros de produits à base de pommes de terre',
    en: 'Wholesale of potato products',
    de: 'Großhandel mit Kartoffelerzeugnissen',
  },
  {
    code: '46382',
    nl: 'Groothandel in voedsel voor huisdieren',
    fr: "Commerce de gros d'aliments pour animaux de compagnie",
    en: 'Wholesale of pet food',
    de: 'Großhandlung mit Nahrungsmitteln für Haustiere',
  },
  {
    code: '46389',
    nl: 'Groothandel in andere voedingsmiddelen, n.e.g.',
    fr: "Commerce de gros d'autres produits alimentaires n.c.a.",
    en: 'Wholesale of other food n.e.c.',
    de: 'Großhandel mit sonstigen Lebensmitteln a.n.g.',
  },
  {
    code: '4639',
    nl: 'Niet-gespecialiseerde groothandel in voedings- en genotmiddelen',
    fr: 'Commerce de gros non spécialisé de denrées, boissons et tabac',
    en: 'Non-specialised wholesale of food, beverages and tobacco',
    de: 'Großhandel mit Nahrungs- und Genussmitteln, Getränken und Tabakwaren, ohne ausgeprägten Schwerpunkt',
  },
  {
    code: '46391',
    nl: 'Niet-gespecialiseerde groothandel in diepgevroren voedingsmiddelen',
    fr: 'Commerce de gros non spécialisé de denrées surgelées',
    en: 'Non-specialised wholesale of frozen food',
    de: 'Nicht spezialisierter Großhandel mit Tiefkühlkost',
  },
  {
    code: '46392',
    nl: 'Niet-gespecialiseerde groothandel in niet-diepgevroren voedingsmiddelen, dranken en genotmiddelen',
    fr: 'Commerce de gros non spécialisé de denrées fraîches, boissons et tabac',
    en: 'Non-specialised wholesale of fresh food, beverages and tobacco',
    de: 'Nicht spezialisierter Großhandel mit nicht tiefgekühlten Lebensmitteln, Getränken und Tabak',
  },
  {
    code: '4641',
    nl: 'Groothandel in textiel',
    fr: 'Commerce de gros de textiles',
    en: 'Wholesale of textiles',
    de: 'Großhandel mit Textilien',
  },
  {
    code: '46411',
    nl: 'Groothandel in weefsels, stoffen en fournituren',
    fr: "Commerce de gros d'étoffes et de fournitures",
    en: 'Wholesale of fabrics and smallwares',
    de: 'Stoff-, Gewebe- und Kurzwarengroßhandel',
  },
  {
    code: '46412',
    nl: 'Groothandel in huishoudtextiel en beddengoed',
    fr: 'Commerce de gros de linge de maison et de literie',
    en: 'Wholesale of household linen and bed linen',
    de: 'Großhandel mit Haustextilien und Bettwäsche',
  },
  {
    code: '46419',
    nl: 'Groothandel in overig textiel',
    fr: "Commerce de gros d'autres textiles",
    en: 'Wholesale of other textiles',
    de: 'Großhandel mit sonstigen Textilien',
  },
  {
    code: '4642',
    nl: 'Groothandel in kleding en schoeisel',
    fr: 'Commerce de gros d’habillement et de chaussures',
    en: 'Wholesale of clothing and footwear',
    de: 'Großhandel mit Bekleidung und Schuhen',
  },
  {
    code: '46421',
    nl: 'Groothandel in werkkleding',
    fr: 'Commerce de gros de vêtements de travail',
    en: 'Wholesale of workwear',
    de: 'Großhandel mit Arbeitskleidung',
  },
  {
    code: '46422',
    nl: 'Groothandel in onderkleding',
    fr: 'Commerce de gros de sous-vêtements',
    en: 'Wholesale of underwear',
    de: 'Großhandel mit Unterwäsche',
  },
  {
    code: '46423',
    nl: 'Groothandel in kleding, met uitzondering van werk- en onderkleding',
    fr: 'Commerce de gros de vêtements, autres que vêtements de travail et sous-vêtements',
    en: 'Wholesale of clothing, other than workwear and underwear',
    de: 'Bekleidungsgroßhandel mit Ausnahme von Arbeitskleidung und Unterwäsche',
  },
  {
    code: '46424',
    nl: 'Groothandel in kledingaccessoires',
    fr: "Commerce de gros d'accessoires du vêtement",
    en: 'Wholesale of clothing accessories',
    de: 'Großhandel mit Bekleidungszubehör',
  },
  {
    code: '46425',
    nl: 'Groothandel in schoeisel',
    fr: 'Commerce de gros de chaussures',
    en: 'Wholesale of footwear',
    de: 'Großhandel mit Schuhen',
  },
  {
    code: '4643',
    nl: 'Groothandel in elektrische huishoudelijke apparaten',
    fr: 'Commerce de gros d’appareils électroménagers',
    en: 'Wholesale of electrical household appliances',
    de: 'Großhandel mit Foto- und optischen Erzeugnissen, elektrischen Haushaltsgeräten und Geräten der Unterhaltungselektronik',
  },
  {
    code: '46431',
    nl: 'Groothandel in elektrische huishoudelijke apparaten en audio- en videoapparatuur',
    fr: "Commerce de gros d'appareils électroménagers et audio-vidéo",
    en: 'Wholesale of electrical household and audio and video appliances',
    de: 'Großhandel mit elektrischen Haushaltsgeräten, Rundfunk- und Fernsehgeräten',
  },
  {
    code: '46432',
    nl: 'Groothandel in foto- en filmapparatuur en in andere optische artikelen',
    fr: 'Commerce de gros de produits photographiques et optiques',
    en: 'Wholesale of optical instruments and photographic equipment',
    de: 'Großhandel mit Fotoapparaten und Filmkameras sowie anderen Optikartikeln',
  },
  {
    code: '4644',
    nl: 'Groothandel in porselein, glaswerk en reinigingsmiddelen',
    fr: 'Commerce de gros de vaisselle, verrerie et produits d’entretien',
    en: 'Wholesale of china and glassware and cleaning materials',
    de: 'Großhandel mit keramischen Erzeugnissen, Glaswaren und Reinigungsmitteln',
  },
  {
    code: '46441',
    nl: 'Groothandel in porselein en glaswerk',
    fr: 'Commerce de gros de porcelaine et de verrerie',
    en: 'Wholesale of china and glassware',
    de: 'Großhandel mit keramischen Erzeugnissen und Glaswaren',
  },
  {
    code: '46442',
    nl: 'Groothandel in reinigingsmiddelen',
    fr: "Commerce de gros de produits d'entretien",
    en: 'Wholesale of cleaning preparations',
    de: 'Großhandel mit Reinigungsmitteln',
  },
  {
    code: '4645',
    nl: 'Groothandel in parfumerieën en cosmetica',
    fr: 'Commerce de gros de parfumerie et de produits de beauté',
    en: 'Wholesale of perfume and cosmetics',
    de: 'Großhandel mit kosmetischen Erzeugnissen und Körperpflegemitteln',
  },
  {
    code: '4646',
    nl: 'Groothandel in farmaceutische en medische artikelen',
    fr: 'Commerce de gros de produits pharmaceutiques et médicaux',
    en: 'Wholesale of pharmaceutical and medical goods',
    de: 'Großhandel mit pharmazeutischen Erzeugnissen und medizinischen Hilfsmitteln',
  },
  {
    code: '4647',
    nl: 'Groothandel in huishoudelijke, kantoor- en winkelmeubelen, tapijten en verlichtingstoestellen',
    fr: 'Commerce de gros de meubles à usage domestique, de bureau et de magasin, de tapis et d’appareils d’éclairage',
    en: 'Wholesale of household, office and shop furniture, carpets and lighting equipment',
    de: 'Großhandel mit Möbeln, Teppichen, Lampen und Leuchten',
  },
  {
    code: '46471',
    nl: 'Groothandel in huismeubilair',
    fr: 'Commerce de gros de mobilier domestique',
    en: 'Wholesale of household furniture',
    de: 'Großhandel mit Haushaltsmöbeln',
  },
  {
    code: '46472',
    nl: 'Groothandel in kantoor- en winkelmeubelen',
    fr: 'Commerce de gros de mobilier de bureau et de magasin',
    en: 'Wholesale of office and shop furniture',
    de: 'Großhandel mit Büro- und Ladenmöbeln',
  },
  {
    code: '46473',
    nl: 'Groothandel in tapijten',
    fr: 'Commerce de gros de tapis',
    en: 'Wholesale of carpets',
    de: 'Großhandel mit Teppichen',
  },
  {
    code: '46474',
    nl: 'Groothandel in verlichtingsapparatuur',
    fr: "Commerce de gros d'appareils d'éclairage",
    en: 'Wholesale of lighting equipment',
    de: 'Großhandel mit Beleuchtungskörpern',
  },
  {
    code: '4648',
    nl: 'Groothandel in uurwerken en sieraden',
    fr: 'Commerce de gros d’articles d’horlogerie et de bijouterie',
    en: 'Wholesale of watches and jewellery',
    de: 'Großhandel mit Uhren und Schmuck',
  },
  {
    code: '4649',
    nl: 'Groothandel in andere consumentenartikelen',
    fr: 'Commerce de gros d’autres biens domestiques',
    en: 'Wholesale of other household goods',
    de: 'Großhandel mit sonstigen Gebrauchs- und Verbrauchsgütern',
  },
  {
    code: '46491',
    nl: 'Groothandel in kranten, boeken en tijdschriften',
    fr: 'Commerce de gros de journaux, de livres et de périodiques',
    en: 'Wholesale of newspapers, books and periodicals',
    de: 'Großhandel mit Büchern, Zeitschriften und Zeitungen',
  },
  {
    code: '46492',
    nl: 'Groothandel in kantoor- en schoolbenodigdheden',
    fr: 'Commerce de gros de fournitures scolaires et de bureau',
    en: 'Wholesale of school and office supplies',
    de: 'Großhandel mit Büro- und Schulbedarf',
  },
  {
    code: '46493',
    nl: 'Groothandel in papier- en kartonwaren',
    fr: "Commerce de gros d'articles en papier et carton",
    en: 'Wholesale of paper and paperboard products',
    de: 'Großhandel mit Papier- und Pappwaren',
  },
  {
    code: '46494',
    nl: 'Groothandel in niet-elektrische huishoudelijke artikelen',
    fr: "Commerce de gros d'articles ménagers non électriques",
    en: 'Wholesale of non-electrical household articles',
    de: 'Großhandel mit nicht elektrischen Haushaltsgeräten',
  },
  {
    code: '46495',
    nl: 'Groothandel in fietsen',
    fr: 'Commerce de gros de cycles',
    en: 'Wholesale of bicycles',
    de: 'Großhandel mit Fahrrädern',
  },
  {
    code: '46496',
    nl: 'Groothandel in sport- en kampeerartikelen, met uitzondering van fietsen',
    fr: "Commerce de gros d'articles de sport et de camping, sauf cycles",
    en: 'Wholesale of equipment for sport and camping, except bicycles',
    de: 'Großhandel mit Sport- und Campingartikeln, mit Ausnahme von Fahrrädern',
  },
  {
    code: '46497',
    nl: 'Groothandel in spellen en speelgoed',
    fr: 'Commerce de gros de jeux et de jouets',
    en: 'Wholesale of games and toys',
    de: 'Großhandel mit Spielen und Spielzeug',
  },
  {
    code: '46498',
    nl: 'Groothandel in lederwaren en reisartikelen',
    fr: "Commerce de gros de maroquinerie et d'articles de voyage",
    en: 'Wholesale of luggage and handbags',
    de: 'Großhandel mit Leder- und Täschnerwaren',
  },
  {
    code: '46499',
    nl: 'Groothandel in andere consumentenartikelen, n.e.g.',
    fr: "Commerce de gros d'autres biens domestiques n.c.a.",
    en: 'Wholesale of other household goods n.e.c.',
    de: 'Großhandel mit sonstigen Konsumgütern a.n.g.',
  },
  {
    code: '4650',
    nl: 'Groothandel in informatie- en communicatieapparatuur',
    fr: 'Commerce de gros d’équipements de l’information et de la communication',
    en: 'Wholesale of information and communication equipment',
    de: 'Großhandel mit Geräten der Informations- und Kommunikationstechnik',
  },
  {
    code: '4661',
    nl: 'Groothandel in machines, werktuigen en toebehoren voor de landbouw',
    fr: 'Commerce de gros de matériel agricole',
    en: 'Wholesale of agricultural machinery, equipment and supplies',
    de: 'Großhandel mit landwirtschaftlichen Maschinen und Geräten',
  },
  {
    code: '4662',
    nl: 'Groothandel in gereedschapswerktuigen',
    fr: 'Commerce de gros de machines-outils',
    en: 'Wholesale of machine tools',
    de: 'Großhandel mit Werkzeugmaschinen',
  },
  {
    code: '4663',
    nl: 'Groothandel in machines voor de mijnbouw, de bouwnijverheid en de weg- en waterbouw',
    fr: 'Commerce de gros de machines pour l’extraction, la construction et le génie civil',
    en: 'Wholesale of mining, construction and civil engineering machinery',
    de: 'Großhandel mit Bergwerks-, Bau- und Baustoffmaschinen',
  },
  {
    code: '4664',
    nl: 'Groothandel in andere machines en werktuigen',
    fr: 'Commerce de gros d’autres machines et équipements',
    en: 'Wholesale of other machinery and equipment',
    de: 'Großhandel mit sonstigen Maschinen und Ausrüstungen',
  },
  {
    code: '46641',
    nl: 'Groothandel in machines voor de productie van voedings- en genotmiddelen',
    fr: "Commerce de gros de machines pour la production d'aliments, de boissons et de tabac",
    en: 'Wholesale of food, beverage, and tobacco production machinery',
    de: 'Großhandel mit Maschinen für die Herstellung von Nahrungs- und Genussmitteln',
  },
  {
    code: '46642',
    nl: 'Groothandel in verpakkingsmachines en weegtoestellen',
    fr: "Commerce de gros de machines d'emballage et d'appareils de pesage",
    en: 'Wholesale of packaging equipment and weighing devices',
    de: 'Großhandel mit Verpackungsmaschinen und Wiegegeräten',
  },
  {
    code: '46643',
    nl: 'Groothandel in elektrisch materiaal, inclusief installatiemateriaal',
    fr: "Commerce de gros de matériel électrique, y compris le matériel d'installation",
    en: 'Wholesale of wiring devices, including installation equipment',
    de: 'Großhandel mit Elektromaterial, einschliesslich Installationsmaterial',
  },
  {
    code: '46644',
    nl: 'Groothandel in hijs-, hef- en transportwerktuigen',
    fr: 'Commerce de gros de matériel de levage et de manutention',
    en: 'Wholesale of lifting and handling equipment',
    de: 'Großhandel mit Lade-, Hebe- und Fördergeräten',
  },
  {
    code: '46645',
    nl: 'Groothandel in pompen en compressoren',
    fr: 'Commerce de gros de pompes et de compresseurs',
    en: 'Wholesale of pumps and compressors',
    de: 'Großhandel mit Pumpen und Kompressoren',
  },
  {
    code: '46646',
    nl: 'Groothandel in meet-, controle- en navigatieinstrumenten',
    fr: "Commerce de gros d'instruments de mesure, de contrôle et de navigation",
    en: 'Wholesale of measuring, testing and navigating equipment',
    de: 'Großhandel mit Mess-, Kontroll- und Navigationsinstrumenten',
  },
  {
    code: '46647',
    nl: 'Groothandel in machines en apparaten voor de warmte-, koel- en vriestechniek voor industrieel gebruik',
    fr: "Commerce de gros de machines et d'appareils de chauffage, de congélation et de refroidissement à usage industriel",
    en: 'Wholesale of industrial heating, freezing and cooling equipment for industrial use',
    de: 'Großhandel mit Maschinen und Geräten der Wärme-, Kühl- und Gefriertechnik für den industriellen Gebrauch',
  },
  {
    code: '46648',
    nl: 'Groothandel in machines voor de textielindustrie en in naai- en breimachines',
    fr: "Commerce de gros de machines pour l'industrie textile et de machines à coudre et à tricoter",
    en: 'Wholesale of machinery for the textile industry and of sewing and knitting machines',
    de: 'Großhandel mit Textil-, Näh- und Strickmaschinen',
  },
  {
    code: '46649',
    nl: 'Groothandel in andere machines en werktuigen, n.e.g.',
    fr: "Commerce de gros d'autres machines et équipements n.c.a.",
    en: 'Wholesale of other machinery and equipment n.e.c.',
    de: 'Großhandel mit sonstigen Maschinen und Werkzeugen a.n.g.',
  },
  {
    code: '4671',
    nl: 'Groothandel in motorvoertuigen',
    fr: 'Commerce de gros de véhicules automobiles',
    en: 'Wholesale of motor vehicles',
    de: 'Großhandel mit Kraftwagen',
  },
  {
    code: '46711',
    nl: "Groothandel in auto's en lichte bestelwagens (<= 3,5 ton)",
    fr: 'Commerce de gros de voitures et de véhicules automobiles légers (<= 3,5 tonnes)',
    en: 'Wholesale of cars and light motor vehicles (<= 3,5 tons)',
    de: 'Großhandel mit Kraftfahrzeugen mit einem Gesamtgewicht von 3,5 t oder weniger',
  },
  {
    code: '46712',
    nl: 'Groothandel in andere motorvoertuigen (> 3,5 ton)',
    fr: "Commerce de gros d'autres véhicules automobiles (> 3,5 tonnes)",
    en: 'Wholesale of other motor vehicles (> 3,5 tons)',
    de: 'Großhandel mit sonstigen Kraftfahrzeugen mit einem Gesamtgewicht von mehr als 3,5 t',
  },
  {
    code: '46713',
    nl: 'Groothandel in aanhangwagens, opleggers en caravans',
    fr: 'Commerce de gros de remorques, de semi-remorques et de caravanes',
    en: 'Wholesale of trailers, semi-trailers and caravans',
    de: 'Großhandel mit Anhängern, Sattelschleppern und Wohnwagen',
  },
  {
    code: '4672',
    nl: 'Groothandel in delen en toebehoren van motorvoertuigen',
    fr: 'Commerce de gros de pièces et accessoires de véhicules automobiles',
    en: 'Wholesale of motor vehicle parts and accessories',
    de: 'Großhandel mit Kraftwagenteilen und -zubehör',
  },
  {
    code: '4673',
    nl: 'Groothandel in motorfietsen, delen en toebehoren van motorfietsen',
    fr: 'Commerce de gros de motocycles et de pièces et accessoires pour motocycles',
    en: 'Wholesale of motorcycles, motorcycle parts and accessories',
    de: 'Großhandel mit Krafträdern, Kraftradteilen und -zubehör',
  },
  {
    code: '4681',
    nl: 'Groothandel in vaste, vloeibare en gasvormige brandstoffen en aanverwante producten',
    fr: 'Commerce de gros de combustibles solides, liquides et gazeux et de produits annexes',
    en: 'Wholesale of solid, liquid and gaseous fuels and related products',
    de: 'Großhandel mit festen Brennstoffen und Mineralölerzeugnissen',
  },
  {
    code: '4682',
    nl: 'Groothandel in metalen en metaalertsen',
    fr: 'Commerce de gros de minerais métalliques et de métaux',
    en: 'Wholesale of metals and metal ores',
    de: 'Großhandel mit Erzen, Metallen und Metallhalbzeug',
  },
  {
    code: '4683',
    nl: 'Groothandel in hout, bouwmaterialen en sanitair',
    fr: 'Commerce de gros de bois, de matériaux de construction et d’appareils sanitaires',
    en: 'Wholesale of wood, construction materials and sanitary equipment',
    de: 'Großhandel mit Holz, Baustoffen, Anstrichmitteln und Sanitärausstattung',
  },
  {
    code: '46831',
    nl: 'Groothandel in bouwmaterialen, algemeen assortiment',
    fr: 'Commerce de gros de matériaux de construction, assortiment général',
    en: 'Wholesale of construction materials, general selection',
    de: 'Baustoffgroßhandel, Vollsortiment',
  },
  {
    code: '46832',
    nl: 'Groothandel in hout',
    fr: 'Commerce de gros de bois',
    en: 'Wholesale of wood',
    de: 'Großhandel mit Holz',
  },
  {
    code: '46833',
    nl: 'Groothandel in behang, verf en woningtextiel',
    fr: "Commerce de gros de papiers peints, de peintures et de tissus d'ameublement",
    en: 'Wholesale of wallpaper, paint and furnishing fabrics',
    de: 'Großhandel mit Tapeten, Farben und Textilien für die Innenausstattung',
  },
  {
    code: '46834',
    nl: 'Groothandel in vlakglas',
    fr: 'Commerce de gros de verre plat',
    en: 'Wholesale of flat glass',
    de: 'Flachglasgroßhandel',
  },
  {
    code: '46835',
    nl: 'Groothandel in vloer- en wandtegels',
    fr: 'Commerce de gros de carrelages',
    en: 'Wholesale of tiles',
    de: 'Großhandel mit Boden- und Wandfliesen',
  },
  {
    code: '46836',
    nl: 'Groothandel in sanitair',
    fr: "Commerce de gros d'équipements sanitaires",
    en: 'Wholesale of sanitary equipment',
    de: 'Sanitärgroßhandel',
  },
  {
    code: '46839',
    nl: 'Groothandel in overige bouwmaterialen',
    fr: "Commerce de gros d'autres matériaux de construction",
    en: 'Wholesale of other construction materials',
    de: 'Großhandel mit sonstigen Baumaterialien:',
  },
  {
    code: '4684',
    nl: 'Groothandel in ijzerwaren en in installatiemateriaal voor loodgieterswerk en verwarming',
    fr: 'Commerce de gros de quincaillerie et fournitures pour plomberie et chauffage',
    en: 'Wholesale of hardware, plumbing and heating equipment and supplies',
    de: 'Großhandel mit Metall- und Kunststoffwaren für Bauzwecke sowie Installationsbedarf für Gas, Wasser und Heizung',
  },
  {
    code: '46841',
    nl: 'Groothandel in ijzerwaren',
    fr: 'Commerce de gros de quincaillerie',
    en: 'Wholesale of hardware',
    de: 'Großhandel mit Bauelementen aus Metall',
  },
  {
    code: '46842',
    nl: 'Groothandel in installatiemateriaal voor loodgieterswerk en verwarming',
    fr: 'Commerce de gros de fournitures pour plomberie et chauffage',
    en: 'Wholesale of plumbing and heating equipment and supplies',
    de: 'Großhandel mit Installationsmaterialien für Sanitär- und Heizungsanlagen',
  },
  {
    code: '4685',
    nl: 'Groothandel in chemische producten',
    fr: 'Commerce de gros de produits chimiques',
    en: 'Wholesale of chemical products',
    de: 'Großhandel mit chemischen Erzeugnissen',
  },
  {
    code: '46851',
    nl: 'Groothandel in chemische producten voor industrieel gebruik',
    fr: 'Commerce de gros de produits chimiques à usage industriel',
    en: 'Wholesale of chemical products for industrial use',
    de: 'Großhandel mit chemischen Produkten für den industriellen Gebrauch',
  },
  {
    code: '46852',
    nl: 'Groothandel in kunstmeststoffen en andere agrochemische producten',
    fr: "Commerce de gros d'engrais et de produits agrochimiques",
    en: 'Wholesale of fertilisers and agrochemical products',
    de: 'Großhandel mit Kunstdüngern und Pflanzenschutzmitteln',
  },
  {
    code: '4686',
    nl: 'Groothandel in andere intermediaire producten',
    fr: 'Commerce de gros d’autres produits intermédiaires',
    en: 'Wholesale of other intermediate products',
    de: 'Großhandel mit sonstigen Halbwaren',
  },
  {
    code: '46861',
    nl: 'Groothandel in diamant en andere edelstenen',
    fr: "Commerce de gros de diamants et d'autres pierres précieuses",
    en: 'Wholesale of diamonds and other precious stones',
    de: 'Großhandel mit Diamanten und sonstigen Edelsteinen',
  },
  {
    code: '46869',
    nl: 'Groothandel in andere intermediaire producten, n.e.g.',
    fr: "Commerce de gros d'autres produits intermédiaires n.c.a.",
    en: 'Wholesale of other intermediate products n.e.c.',
    de: 'Großhandel mit sonstigen Zwischenprodukten a.n.g.',
  },
  {
    code: '4687',
    nl: 'Groothandel in afval en schroot',
    fr: 'Commerce de gros de déchets et débris',
    en: 'Wholesale of waste and scrap',
    de: 'Großhandel mit Altmaterialien und Reststoffen',
  },
  {
    code: '46871',
    nl: 'Groothandel in autosloopmateriaal',
    fr: "Commerce de gros d'épaves de véhicules automobiles et de pièces réutilisables",
    en: 'Wholesale of motor vehicle wrecks and reusable parts',
    de: 'Großhandel mit Altfahrzeugen und Fahrzeugteilen',
  },
  {
    code: '46872',
    nl: 'Groothandel in ijzer- en staalschroot en in oude non-ferrometalen',
    fr: "Commerce de gros de déchets de fer et d'acier et de déchets métalliques non ferreux",
    en: 'Wholesale of iron and steel scrap and non-ferrous metal scrap',
    de: 'Großhandel mit Eisen- und Stahlschrott und Nichteisenaltmetallen',
  },
  {
    code: '46879',
    nl: 'Groothandel in afval en schroot, n.e.g.',
    fr: 'Commerce de gros de déchets et débris n.c.a.',
    en: 'Wholesale of waste and scrap n.e.c.',
    de: 'Großhandel mit Abfällen und Schrott a.n.g.',
  },
  {
    code: '4689',
    nl: 'Overige gespecialiseerde groothandel, n.e.g.',
    fr: 'Autre commerce de gros spécialisé n.c.a.',
    en: 'Other specialised wholesale n.e.c.',
    de: 'Sonstiger Großhandel a. n. g.',
  },
  {
    code: '4690',
    nl: 'Niet-gespecialiseerde groothandel',
    fr: 'Commerce de gros non spécialisé',
    en: 'Non-specialised wholesale trade',
    de: 'Großhandel ohne ausgeprägten Schwerpunkt',
  },
  {
    code: '4711',
    nl: 'Niet-gespecialiseerde detailhandel waarbij voedings- en genotmiddelen overheersen',
    fr: 'Commerce de détail non spécialisé dans lequel les produits alimentaires et le tabac prédominent',
    en: 'Non-specialised retail sale of predominately food, beverages or tobacco',
    de: 'Einzelhandel mit Waren verschiedener Art, Hauptrichtung Nahrungs- und Genussmittel',
  },
  {
    code: '4712',
    nl: 'Overige niet-gespecialiseerde detailhandel',
    fr: 'Autre commerce de détail non spécialisé',
    en: 'Other non-specialised retail sale',
    de: 'Sonstiger Einzelhandel mit Waren verschiedener Art',
  },
  {
    code: '4721',
    nl: 'Detailhandel in groenten en fruit',
    fr: 'Commerce de détail de fruits et légumes',
    en: 'Retail sale of fruit and vegetables',
    de: 'Einzelhandel mit Obst, Gemüse und Kartoffeln',
  },
  {
    code: '4722',
    nl: 'Detailhandel in vlees en vleeswaren',
    fr: 'Commerce de détail de viande et de produits à base de viande',
    en: 'Retail sale of meat and meat products',
    de: 'Einzelhandel mit Fleisch und Fleischwaren',
  },
  {
    code: '47221',
    nl: 'Detailhandel in vlees en vleesproducten, m.u.v. vlees van wild en van gevogelte',
    fr: 'Commerce de détail de viandes et de produits à base de viande, sauf viande de gibier et de volaille',
    en: 'Retail sale of meat and meat products, except meat of poultry and game animals',
    de: 'Einzelhandel mit Fleisch und Fleischwaren, mit Ausnahme von Geflügel- und Wildfleisch',
  },
  {
    code: '47222',
    nl: 'Detailhandel in vlees van wild en van gevogelte',
    fr: 'Commerce de détail de viande de gibier et de volaille',
    en: 'Retail sale of meat of poultry and game animals',
    de: 'Einzelhandel mit Fleisch von Geflügel- und Wildfleisch',
  },
  {
    code: '4723',
    nl: 'Detailhandel in vis en schaal- en weekdieren',
    fr: 'Commerce de détail de poisson, de crustacés et de mollusques',
    en: 'Retail sale of fish, crustaceans and molluscs',
    de: 'Einzelhandel mit Fisch, Meeresfrüchten und Fischerzeugnissen',
  },
  {
    code: '4724',
    nl: 'Detailhandel in brood, banket en suikerwerk',
    fr: 'Commerce de détail de pain, de pâtisserie et de confiserie',
    en: 'Retail sale of bread, cake and confectionery',
    de: 'Einzelhandel mit Back- und Süßwaren',
  },
  {
    code: '47241',
    nl: 'Detailhandel in brood en banketbakkerswerk (koude bakkers)',
    fr: 'Commerce de détail de pain et de pâtisserie (dépôts)',
    en: 'Retail sale of bread, cake and confectionery (bread shops)',
    de: 'Einzelhandel mit Brot und Backwaren (Depot)',
  },
  {
    code: '47242',
    nl: 'Detailhandel in chocolade en suikerwerk',
    fr: 'Commerce de détail de chocolat et de confiserie',
    en: 'Retail sale of chocolate and sugar confectionery',
    de: 'Einzelhandel mit Schokolade und Süßwaren',
  },
  {
    code: '4725',
    nl: 'Detailhandel in dranken',
    fr: 'Commerce de détail de boissons',
    en: 'Retail sale of beverages',
    de: 'Einzelhandel mit Getränken',
  },
  {
    code: '47251',
    nl: 'Detailhandel in wijnen en geestrijke dranken',
    fr: 'Commerce de détail de vins et de spiritueux',
    en: 'Retail sale of wine and spirits',
    de: 'Einzelhandel mit Wein und Spirituosen',
  },
  {
    code: '47252',
    nl: 'Detailhandel in dranken, algemeen assortiment',
    fr: 'Commerce de détail de boissons, assortiment général',
    en: 'Retail sale of beverages, general selection',
    de: 'Einzelhandel mit Getränken, Vollsortiment',
  },
  {
    code: '4726',
    nl: 'Detailhandel in tabaksproducten',
    fr: 'Commerce de détail de produits à base de tabac',
    en: 'Retail sale of tobacco products',
    de: 'Einzelhandel mit Tabakwaren',
  },
  {
    code: '4727',
    nl: 'Detailhandel in andere voedingsmiddelen',
    fr: 'Commerce de détail d’autres produits alimentaires',
    en: 'Retail sale of other food',
    de: 'Einzelhandel mit sonstigen Nahrungs- und Genussmitteln',
  },
  {
    code: '47271',
    nl: 'Detailhandel in zuivelproducten en eieren',
    fr: "Commerce de détail de produits laitiers et d'oeufs",
    en: 'Retail sale of dairy products and eggs',
    de: 'Einzelhandel mit Milchprodukten und Eiern',
  },
  {
    code: '47279',
    nl: 'Overige detailhandel in voedingsmiddelen, n.e.g.',
    fr: 'Autres commerces de détail alimentaires n.c.a.',
    en: 'Retail sale of other food n.e.c.',
    de: 'Sonstiger Nahrungsmitteleinzelhandel a.n.g.',
  },
  {
    code: '4730',
    nl: 'Detailhandel in motorbrandstoffen',
    fr: 'Commerce de détail de carburants',
    en: 'Retail sale of automotive fuel',
    de: 'Einzelhandel mit Motorenkraftstoffen',
  },
  {
    code: '4740',
    nl: 'Detailhandel in ICT-apparatuur',
    fr: 'Commerce de détail d’équipements de l’information et de la communication',
    en: 'Retail sale of information and communication equipment',
    de: 'Einzelhandel mit Geräten der Informations- und Kommunikationstechnik',
  },
  {
    code: '4751',
    nl: 'Detailhandel in textiel',
    fr: 'Commerce de détail de textiles',
    en: 'Retail sale of textiles',
    de: 'Einzelhandel mit Textilien',
  },
  {
    code: '47511',
    nl: 'Detailhandel in kledingstoffen',
    fr: "Commerce de détail de tissus d'habillement",
    en: 'Retail sale of clothing materials',
    de: 'Einzelhandel mit Bekleidungsstoffen',
  },
  {
    code: '47512',
    nl: 'Detailhandel in huishoudtextiel en beddengoed',
    fr: 'Commerce de détail de linges de maison',
    en: 'Retail sale of household linen',
    de: 'Einzelhandel mit Haustextilien und Bettwäsche',
  },
  {
    code: '47513',
    nl: 'Detailhandel in breigarens, handwerken en fournituren',
    fr: "Commerce de détail de fils à tricoter et d'articles de mercerie",
    en: 'Retail sale of knitting yarn and haberdashery',
    de: 'Einzelhandel mit Strickgarne und Kurzwaren',
  },
  {
    code: '47519',
    nl: 'Detailhandel in overig textiel',
    fr: "Commerce de détail d'autres textiles",
    en: 'Retail sale of other textiles',
    de: 'Einzelhandel mit sonstigen Textilien',
  },
  {
    code: '4752',
    nl: 'Detailhandel in ijzerwaren, bouwmaterialen, verf en glas',
    fr: 'Commerce de détail de quincaillerie, de matériaux de construction et de bricolage, de peinture et de verre',
    en: 'Retail sale of hardware, building materials, paints and glass',
    de: 'Einzelhandel mit Metallwaren, Anstrichmitteln, Bau- und Heimwerkerbedarf',
  },
  {
    code: '47521',
    nl: 'Detailhandel in ijzerwaren, bouwmaterialen, verf en glas (algemeen assortiment)',
    fr: 'Commerce de détail de quincaillerie, de matériaux de construction et de bricolage, de peinture et de verre (assortiment général)',
    en: 'Retail sale of hardware, building materials, paints and glass (general selection)',
    de: 'Einzelhandel mit Metallwaren, Anstrichmitteln, Bau- und Heimwerkerbedarf, Vollsortiment',
  },
  {
    code: '47522',
    nl: 'Detailhandel in houten bouw- en tuinmaterialen',
    fr: 'Commerce de détail de matériaux de construction et de matériaux de jardin, en bois',
    en: 'Retail sale of wooden building materials and garden furniture',
    de: 'Einzelhandel mit Bau- und Gartenmaterialien aus Holz',
  },
  {
    code: '47523',
    nl: 'Detailhandel in wand- en vloertegels',
    fr: 'Commerce de détail de carrelage',
    en: 'Retail sale of tiles',
    de: 'Einzelhandel mit Boden- und Wandfliesen',
  },
  {
    code: '47524',
    nl: 'Detailhandel in parket-, laminaat- en kurkvloeren',
    fr: 'Commerce de détail de parquet, de laminés et de revêtement en liège',
    en: 'Retail sale of wooden, laminate and cork flooring',
    de: 'Einzelhandel mit Parkett-, Laminat- und Korkböden',
  },
  {
    code: '47525',
    nl: 'Detailhandel in ijzerwaren en gereedschappen',
    fr: "Commerce de détail de quincaillerie et d'outils",
    en: 'Retail sale of hardware and tools',
    de: 'Einzelhandel mit Eisenwaren und Werkzeugen',
  },
  {
    code: '47526',
    nl: 'Detailhandel in verf en verfwaren',
    fr: 'Commerce de détail de peinture et de vernis',
    en: 'Retail sale of paints and varnishes',
    de: 'Einzelhandel mit Farben und Farbwaren',
  },
  {
    code: '47527',
    nl: 'Detailhandel in sanitaire artikelen en sanitair installatiemateriaal',
    fr: "Commerce de détail d'articles et de matériels d'installations sanitaires",
    en: 'Retail sale of sanitary ware and equipment',
    de: 'Einzelhandel mit Sanitärartikeln und Installationszubehör',
  },
  {
    code: '47529',
    nl: 'Detailhandel in overige bouwmaterialen, n.e.g.',
    fr: "Commerce de détail d'autres matériaux de construction, n.c.a.",
    en: 'Retail sale of other construction materials',
    de: 'Einzelhandelsleistungen mit sonstigen Baumaterialien a.n.g.',
  },
  {
    code: '4753',
    nl: 'Detailhandel in tapijten en andere vloerbedekking en wandbekleding',
    fr: 'Commerce de détail de tapis, moquettes et revêtements de murs et de sols',
    en: 'Retail sale of carpets, rugs, wall and floor coverings',
    de: 'Einzelhandel mit Vorhängen, Teppichen, Fußbodenbelägen und Tapeten',
  },
  {
    code: '4754',
    nl: 'Detailhandel in elektrische huishoudapparaten',
    fr: 'Commerce de détail d’appareils électroménagers',
    en: 'Retail sale of electrical household appliances',
    de: 'Einzelhandel mit elektrischen Haushaltsgeräten',
  },
  {
    code: '4755',
    nl: 'Detailhandel in meubelen, verlichtingstoestellen, tafelgerei en andere huishoudelijke artikelen',
    fr: 'Commerce de détail de meubles, d’appareils d’éclairage, de vaisselle et d’autres articles de ménage biens domestiques',
    en: 'Retail sale of furniture, lighting equipment, tableware and other household goods',
    de: 'Einzelhandel mit Möbeln, Einrichtungsgegenständen und sonstigem Hausrat',
  },
  {
    code: '47551',
    nl: 'Detailhandel in huismeubilair',
    fr: 'Commerce de détail de mobilier de maison',
    en: 'Retail sale of home furniture',
    de: 'Einzelhandel mit Wohnmöbeln',
  },
  {
    code: '47552',
    nl: 'Detailhandel in verlichtingsartikelen',
    fr: "Commerce de détail d'appareils d'éclairage",
    en: 'Retail sale of lighting equipment',
    de: 'Einzelhandel mit Beleuchtungskörpern',
  },
  {
    code: '47553',
    nl: 'Detailhandel in glas-, porselein- en aardewerk en in niet-elektrische huishoudelijke artikelen',
    fr: "Commerce de détail d'appareils ménagers non électriques, de vaisselle, de verrerie, de porcelaine et de poterie",
    en: 'Retail sale of non-electric household appliances, crockery, glassware, china and earthenware',
    de: 'Einzelhandel mit nicht elektrischen Haushaltsgeräten, Geschirr, Glas, Porzellan und Steingut',
  },
  {
    code: '47554',
    nl: 'Detailhandel in babyartikelen (algemeen assortiment)',
    fr: "Commerce de détail d'articles de puériculture (assortiment général)",
    en: 'Retail sale of childcare articles (general selection)',
    de: 'Einzelhandel mit Babyartikeln, Vollsortiment',
  },
  {
    code: '47559',
    nl: 'Detailhandel in andere huishoudelijke artikelen, n.e.g.',
    fr: "Commerce de détail d'autres articles de ménage n.c.a.",
    en: 'Retail sale of other household goods n.e.c.',
    de: 'Einzelhandel mit sonstigen Haushaltsartikeln a.n.g.',
  },
  {
    code: '4761',
    nl: 'Detailhandel in boeken',
    fr: 'Commerce de détail de livres',
    en: 'Retail sale of books',
    de: 'Einzelhandel mit Büchern',
  },
  {
    code: '4762',
    nl: 'Detailhandel in kranten en andere tijdschriften en kantoorbehoeften',
    fr: 'Commerce de détail de journaux et autres publications périodiques et de papeterie',
    en: 'Retail sale of newspapers, and other periodical publications and stationery',
    de: 'Einzelhandel mit Zeitungen, sonstigen Zeitschriften, Schreibwaren und Bürobedarf',
  },
  {
    code: '47621',
    nl: 'Detailhandel in kranten en andere tijdschriften',
    fr: 'Commerce de détail de journaux et autres publications périodiques',
    en: 'Retail sale of newspapers, and other periodical publications',
    de: 'Einzelhandel mit Zeitungen und sonstigen Zeitschriften',
  },
  {
    code: '47622',
    nl: 'Detailhandel in kantoorbehoeften',
    fr: 'Commerce de détail de papeterie',
    en: 'Retail sale of stationery',
    de: 'Einzelhandel mit  Schreibwaren und Bürobedarf',
  },
  {
    code: '4763',
    nl: 'Detailhandel in sportartikelen',
    fr: 'Commerce de détail d’articles de sport',
    en: 'Retail sale of sporting equipment',
    de: 'Einzelhandel mit Fahrrädern, Sport- und Campingartikeln',
  },
  {
    code: '47631',
    nl: 'Detailhandel in wapens en munitie',
    fr: "Commerce de détail d'armes et de munitions",
    en: 'Retail sale of weapons and ammunition',
    de: 'Einzelhandel mit Waffen und Munition',
  },
  {
    code: '47632',
    nl: 'Detailhandel in fietsen',
    fr: 'Commerce de détail de cycles',
    en: 'Retail sale of bicycles',
    de: 'Einzelhandel mit Fahrrädern',
  },
  {
    code: '47639',
    nl: 'Detailhandel in overige sportartikelen',
    fr: 'Commerce de détail d’autres articles de sport',
    en: 'Retail sale of other sporting equipment',
    de: 'Einzelhandel mit sonstigen Sportartikeln',
  },
  {
    code: '4764',
    nl: 'Detailhandel in spellen en speelgoed',
    fr: 'Commerce de détail de jeux et jouets',
    en: 'Retail sale of games and toys',
    de: 'Einzelhandel mit Spielwaren',
  },
  {
    code: '4769',
    nl: 'Detailhandel in cultuur- en recreatieartikelen, n.e.g.',
    fr: 'Commerce de détail de biens culturels et de loisirs n.c.a.',
    en: 'Retail sale of cultural and recreational goods n.e.c.',
    de: 'Einzelhandel mit Kunst- und Kulturerzeugnissen a. n. g.',
  },
  {
    code: '4771',
    nl: 'Detailhandel in kleding',
    fr: 'Commerce de détail d’habillement',
    en: 'Retail sale of clothing',
    de: 'Einzelhandel mit Bekleidung',
  },
  {
    code: '47711',
    nl: 'Detailhandel in damesbovenkleding',
    fr: 'Commerce de détail de vêtements pour dame',
    en: 'Retail sale of clothing for women',
    de: 'Einzelhandel mit Damenoberbekleidung',
  },
  {
    code: '47712',
    nl: 'Detailhandel in herenbovenkleding',
    fr: 'Commerce de détail de vêtements pour homme',
    en: 'Retail sale of clothing for men',
    de: 'Einzelhandel mit Herrenoberbekleidung',
  },
  {
    code: '47713',
    nl: 'Detailhandel in baby- en kinderbovenkleding',
    fr: 'Commerce de détail de vêtements pour bébé et enfant',
    en: 'Retail sale of clothing for baby and children',
    de: 'Einzelhandel mit Baby- und Kinderoberbekleidung',
  },
  {
    code: '47714',
    nl: 'Detailhandel in onderkleding, lingerie en strand- en badkleding',
    fr: 'Commerce de détail de sous-vêtements, de lingerie et de vêtements de bain',
    en: 'Retail sale of underwear, lingerie and swimwear',
    de: 'Einzelhandel mit Unterwäsche, Damenunterwäsche und Strand- und Badekleidung',
  },
  {
    code: '47715',
    nl: 'Detailhandel in kledingaccessoires',
    fr: "Commerce de détail d'accessoires du vêtement",
    en: 'Retail sale of clothing accessories',
    de: 'Einzelhandel mit Bekleidungsasccessoires',
  },
  {
    code: '47716',
    nl: 'Detailhandel in dames-, heren-, baby- en kinderboven- en onderkleding en kledingaccessoires (algemeen assortiment)',
    fr: "Commerce de détail de vêtements, de sous-vêtements et d'accessoires pour dame, homme, enfant et bébé, assortiment général",
    en: 'Retail sale of clothing, underwear and clothing accessories for men, women, children and baby, general selection',
    de: 'Einzelhandel mit Damen-, Herren- Baby- und Kinderober- und -unterbekleidung und Bekleidungsasccessoires (Vollsortiment)',
  },
  {
    code: '4772',
    nl: 'Detailhandel in schoeisel en lederwaren',
    fr: 'Commerce de détail de chaussures et d’articles en cuir',
    en: 'Retail sale of footwear and leather goods',
    de: 'Einzelhandel mit Schuhen und Lederwaren',
  },
  {
    code: '47721',
    nl: 'Detailhandel in schoeisel',
    fr: 'Commerce de détail de chaussures',
    en: 'Retail sale of footwear',
    de: 'Einzelhandel mit Schuhen',
  },
  {
    code: '47722',
    nl: 'Detailhandel in lederwaren en reisartikelen',
    fr: "Commerce de détail d'articles en cuir et d'articles de voyage",
    en: 'Retail sale of leather goods and luggage',
    de: 'Einzelhandel mit Lederwaren und Reiseaccessoires',
  },
  {
    code: '4773',
    nl: 'Detailhandel in farmaceutische producten',
    fr: 'Commerce de détail de produits pharmaceutiques',
    en: 'Retail sale of pharmaceutical products',
    de: 'Einzelhandel mit pharmazeutischen Erzeugnissen',
  },
  {
    code: '4774',
    nl: 'Detailhandel in medische en orthopedische artikelen',
    fr: 'Commerce de détail d’articles médicaux et orthopédiques',
    en: 'Retail sale of medical and orthopaedic goods',
    de: 'Einzelhandel mit medizinischen und orthopädischen Artikeln',
  },
  {
    code: '47741',
    nl: 'Detailhandel in medische en orthopedische artikelen, m.u.v. corrigerende brillen, lenzen en zonnebrillen',
    fr: "Commerce de détail d'articles médicaux et orthopédiques, à l'exception de lunettes de correction, de lentilles et de lunettes de soleil",
    en: 'Retail sale of medical and orthopaedic goods, except corrective glasses, lenses and sunglasses',
    de: 'Einzelhandel mit medizinischen und orthopädischen Artikeln, mit Ausnahme von Korrektionsbrillen, Brillengläsern und Sonnenbrillen',
  },
  {
    code: '47742',
    nl: 'Detailhandel in corrigerende brillen, lenzen en zonnebrillen',
    fr: 'Commerce de détail de lunettes de correction, de lentilles et de lunettes de soleil',
    en: 'Retail sale of corrective glasses, lenses and sunglasses',
    de: 'Einzelhandel mit Korrektionsbrillen, Brillengläsern und Sonnenbrillen',
  },
  {
    code: '4775',
    nl: 'Detailhandel in cosmetica en toiletartikelen',
    fr: "Commerce de détail de produits cosmétiques et d'articles de toilette",
    en: 'Retail sale of cosmetic and toilet articles',
    de: 'Einzelhandel mit kosmetischen Erzeugnissen und Körperpflegemitteln',
  },
  {
    code: '4776',
    nl: 'Detailhandel in bloemen, planten, kunstmeststoffen, huisdieren en voer voor huisdieren',
    fr: 'Commerce de détail de fleurs, plantes, engrais, animaux de compagnie et aliments pour ces animaux',
    en: 'Retail sale of flowers, plants, fertilisers, pets and pet food',
    de: 'Einzelhandel mit Blumen, Pflanzen, Düngemitteln, Tierfutter und Haustieren',
  },
  {
    code: '47761',
    nl: 'Detailhandel in bloemen, planten, zaden en kunstmeststoffen',
    fr: "Commerce de détail de fleurs, de plantes, de graines et d'engrais",
    en: 'Retail sale of flowers, plants, seeds and fertilisers',
    de: 'Einzelhandel mit Blumen, Pflanzen, Sämereien und Düngemitteln',
  },
  {
    code: '47762',
    nl: 'Detailhandel in huisdieren, voer voor huisdieren en benodigdheden daarvoor',
    fr: "Commerce de détail d'animaux de compagnie, d'aliments et d'accessoires pour ces animaux",
    en: 'Retail sale of pets, pet food and pet accessories',
    de: 'Einzelhandel mit Haustieren, Haustierzubehör und Futter',
  },
  {
    code: '4777',
    nl: 'Detailhandel in uurwerken en sieraden',
    fr: 'Commerce de détail d’articles d’horlogerie et de bijouterie',
    en: 'Retail sale of watches and jewellery',
    de: 'Einzelhandel mit Uhren und Schmuck',
  },
  {
    code: '4778',
    nl: 'Detailhandel in andere nieuwe goederen',
    fr: 'Commerce de détail d’autres biens neufs',
    en: 'Retail sale of other new goods',
    de: 'Einzelhandel mit sonstigen Neuwaren',
  },
  {
    code: '47781',
    nl: 'Detailhandel in vaste, vloeibare en gasvormige brandstoffen, m.u.v. motorbrandstoffen',
    fr: "Commerce de détail de combustibles solides, liquides et gazeux, à l'exclusion des carburants",
    en: 'Retail sale of solid, liquid and gaseous fuels, excluding motor fuels',
    de: 'Einzelhandel mit festen, flüssigen und gasförmigen Brennstoffen, mit Ausnahme von Fahrzeugkraftstoffen',
  },
  {
    code: '47782',
    nl: 'Detailhandel in fotografische en optische artikelen en in precisieinstrumenten, m.u.v. corrigerende brillen, lenzen en zonnebrillen',
    fr: "Commerce de détail de matériel photographique, d'optique et de précision, à l’exception des lunettes de correction, des lentilles et des lunettes de soleil",
    en: 'Retail sale of photographic, optical and precision equipment, except corrective glasses, lenses and sunglasses',
    de: 'Einzelhandel mit Foto-, Optikartikel und Präzisionsinstrumente, mit Ausnahme von Korrektionsbrillen, Brillengläsern und Sonnenbrillen',
  },
  {
    code: '47783',
    nl: 'Detailhandel in drogisterijartikelen en onderhoudsproducten',
    fr: "Commerce de détail d'articles de droguerie et de produits d'entretien",
    en: 'Retail sale of drugstore products and cleaning materials',
    de: 'Einzelhandel mit Drogerieartikeln und Pflegemitteln',
  },
  {
    code: '47784',
    nl: 'Detailhandel in souvenirs en religieuze artikelen',
    fr: "Commerce de détail de souvenirs et d'articles religieux",
    en: 'Retail sale of souvenirs and religious articles',
    de: 'Einzelhandel mit Andenken und Devotionalien',
  },
  {
    code: '47789',
    nl: 'Overige detailhandel in nieuwe artikelen n.e.g.',
    fr: 'Autre commerce de détail de biens neufs n.c.a.',
    en: 'Retail sale of other new goods n.e.c.',
    de: 'Sonstiger Einzelhandel von neuen Artikeln a.n.g.',
  },
  {
    code: '4779',
    nl: 'Detailhandel in tweedehandsgoederen',
    fr: 'Commerce de détail de biens d’occasion',
    en: 'Retail sale of second-hand goods',
    de: 'Einzelhandel mit Antiquitäten und Gebrauchtwaren',
  },
  {
    code: '47791',
    nl: 'Detailhandel in antiquiteiten',
    fr: "Commerce de détail d'antiquités",
    en: 'Retail sale of antiques',
    de: 'Einzelhandel mit Antiquitäten',
  },
  {
    code: '47792',
    nl: 'Detailhandel in tweedehandskleding',
    fr: "Commerce de détail de vêtements d'occasion",
    en: 'Retail sale of second-hand clothing',
    de: 'Einzelhandel mit Gebrauchtwaren',
  },
  {
    code: '47793',
    nl: 'Detailhandel in andere tweedehandsgoederen, m.u.v. tweedehandskleding',
    fr: "Commerce de détail de biens d'occasion, à l’exception des vêtements d'occasion",
    en: 'Retail sale of second-hand goods in stores, except second-hand clothing',
    de: 'Einzelhandel mit Gebrauchtwaren in Geschäften, mit Ausnahme von Gebrauchtkleidung',
  },
  {
    code: '4781',
    nl: 'Detailhandel in motorvoertuigen',
    fr: 'Commerce de détail de véhicules automobiles',
    en: 'Retail sale of motor vehicles',
    de: 'Einzelhandel mit Kraftwagen',
  },
  {
    code: '47811',
    nl: "Detailhandel in auto's en lichte bestelwagens (<= 3,5 ton)",
    fr: 'Commerce de détail de voitures et de véhicules automobiles légers (<= 3,5 tonnes)',
    en: 'Retail sale of cars and light motor vehicles (<= 3,5 tons)',
    de: 'Einzelhandel mit Kraftfahrzeugen mit einem Gesamtgewicht von 3,5 t oder weniger',
  },
  {
    code: '47812',
    nl: 'Detailhandel in andere motorvoertuigen (> 3,5 ton)',
    fr: "Commerce de détail d'autres véhicules automobiles (> 3,5 tonnes)",
    en: 'Retail sale of other motor vehicles (> 3.5 tonnes)',
    de: 'Einzelhandel mit sonstigen Kraftfahrzeugen mit einem Gesamtgewicht von mehr als 3,5 t',
  },
  {
    code: '47813',
    nl: 'Detailhandel in aanhangwagens, opleggers en caravans',
    fr: 'Commerce de détail de remorques, de semi-remorques et de caravanes',
    en: 'Retail sale of trailers, semi-trailers and caravans',
    de: 'Einzelhandel mit Anhängern, Sattelschleppern und Wohnwagen',
  },
  {
    code: '4782',
    nl: 'Detailhandel in onderdelen en accessoires van motorvoertuigen',
    fr: 'Commerce de détail de pièces et accessoires de véhicules automobiles',
    en: 'Retail sale of motor vehicle parts and accessories',
    de: 'Einzelhandel mit Kraftwagenteilen und -zubehör',
  },
  {
    code: '4783',
    nl: 'Detailhandel in motorrijwielen, delen en toebehoren van motorrijwielen',
    fr: 'Commerce de détail de motocycles et de pièces et accessoires de motocycles',
    en: 'Retail sale of motorcycles, motorcycle parts and accessories',
    de: 'Einzelhandel mit Krafträdern, Kraftradteilen und -zubehör',
  },
  {
    code: '4791',
    nl: 'Bemiddelingsactiviteiten in verband met de niet-gespecialiseerde detailhandel',
    fr: 'Activités de service d’intermédiation pour le commerce de détail non spécialisé',
    en: 'Intermediation service activities for non-specialised retail sale',
    de: 'Vermittlungstätigkeiten für den Einzelhandel ohne ausgeprägten Schwerpunkt',
  },
  {
    code: '4792',
    nl: 'Bemiddelingsactiviteiten voor de gespecialiseerde detailhandel',
    fr: 'Activités de service d’intermédiation pour le commerce de détail spécialisé',
    en: 'Intermediation service activities for specialised retail sale',
    de: 'Vermittlungstätigkeiten für den Einzelhandel mit ausgeprägtem Schwerpunkt',
  },
  {
    code: '4911',
    nl: 'Personenvervoer per trein',
    fr: 'Transport ferroviaire lourd de voyageurs',
    en: 'Passenger heavy rail transport',
    de: 'Personenbeförderung im Eisenbahnverkehr',
  },
  {
    code: '4912',
    nl: 'Personenvervoer per spoor anders dan per trein',
    fr: 'Autre transport ferroviaire de voyageurs',
    en: 'Other passenger rail transport',
    de: 'Sonstige Personenbeförderung im Schienenverkehr',
  },
  {
    code: '4920',
    nl: 'Goederenvervoer per spoor',
    fr: 'Transport ferroviaire de fret',
    en: 'Freight rail transport',
    de: 'Güterbeförderung im Schienenverkehr',
  },
  {
    code: '4931',
    nl: 'Personenvervoer over de weg volgens dienstregeling',
    fr: 'Transport régulier de voyageurs par route',
    en: 'Scheduled passenger transport by road',
    de: 'Personenbeförderung im Linienverkehr auf der Straße',
  },
  {
    code: '4932',
    nl: 'Personenvervoer over de weg zonder dienstregeling',
    fr: 'Transport non régulier de voyageurs par route',
    en: 'Non-scheduled passenger transport by road',
    de: 'Personenbeförderung im Gelegenheitsverkehr auf der Straße',
  },
  {
    code: '4933',
    nl: 'Diensten voor personenvervoer op aanvraag per voertuig met chauffeur',
    fr: 'Activités de service de transport de voyageurs sur demande par véhicule avec chauffeur',
    en: 'On-demand passenger transport service activities by vehicle with driver',
    de: 'Personenbeförderung mit Fahrzeug mit Fahrer auf Abruf',
  },
  {
    code: '4934',
    nl: 'Personenvervoer met kabelbanen en skiliften',
    fr: 'Transport de voyageurs par téléphériques et remontées mécaniques',
    en: 'Passenger transport by cableways and ski lifts',
    de: 'Personenbeförderung mit Seilbahnen und Skiliften',
  },
  {
    code: '4939',
    nl: 'Overig personenvervoer te land, n.e.g.',
    fr: 'Autre transport terrestre de voyageurs n.c.a.',
    en: 'Other passenger land transport n.e.c.',
    de: 'Sonstige Personenbeförderung im Landverkehr a. n. g.',
  },
  {
    code: '4941',
    nl: 'Goederenvervoer over de weg',
    fr: 'Transport routier de fret',
    en: 'Freight transport by road',
    de: 'Güterbeförderung im Straßenverkehr',
  },
  {
    code: '4942',
    nl: 'Verhuisactiviteiten',
    fr: 'Activités de déménagement',
    en: 'Removal services',
    de: 'Umzugstransporte',
  },
  {
    code: '4950',
    nl: 'Vervoer via pijpleidingen',
    fr: 'Transport par conduites',
    en: 'Transport via pipeline',
    de: 'Transport in Rohrfernleitungen',
  },
  {
    code: '5010',
    nl: 'Personenvervoer over zee- en kustwateren',
    fr: 'Transports maritimes et côtiers de passagers',
    en: 'Sea and coastal passenger water transport',
    de: 'Personenbeförderung in der Hochsee- und Küstenschifffahrt',
  },
  {
    code: '5020',
    nl: 'Goederenvervoer over zee- en kustwateren',
    fr: 'Transports maritimes et côtiers de fret',
    en: 'Sea and coastal freight water transport',
    de: 'Güterbeförderung in der Hochsee- und Küstenschifffahrt',
  },
  {
    code: '5030',
    nl: 'Personenvervoer over binnenwateren',
    fr: 'Transports fluviaux de passagers',
    en: 'Inland passenger water transport',
    de: 'Personenbeförderung in der Binnenschifffahrt',
  },
  {
    code: '5040',
    nl: 'Goederenvervoer over binnenwateren',
    fr: 'Transports fluviaux de fret',
    en: 'Inland freight water transport',
    de: 'Güterbeförderung in der Binnenschifffahrt',
  },
  {
    code: '5110',
    nl: 'Personenvervoer door de lucht',
    fr: 'Transports aériens de passagers',
    en: 'Passenger air transport',
    de: 'Personenbeförderung in der Luftfahrt',
  },
  {
    code: '5121',
    nl: 'Goederenvervoer door de lucht',
    fr: 'Transports aériens de fret',
    en: 'Freight air transport',
    de: 'Güterbeförderung in der Luftfahrt',
  },
  {
    code: '5122',
    nl: 'Ruimtevaart',
    fr: 'Transports spatiaux',
    en: 'Space transport',
    de: 'Raumtransport',
  },
  {
    code: '5210',
    nl: 'Opslag',
    fr: 'Entreposage et stockage',
    en: 'Warehousing and storage',
    de: 'Lagerei',
  },
  {
    code: '5221',
    nl: 'Diensten in verband met vervoer te land',
    fr: 'Services auxiliaires des transports terrestres',
    en: 'Service activities incidental to land transportation',
    de: 'Erbringung von sonstigen Dienstleistungen für den Landverkehr',
  },
  {
    code: '5222',
    nl: 'Diensten in verband met vervoer over water',
    fr: 'Services auxiliaires des transports par eau',
    en: 'Service activities incidental to water transportation',
    de: 'Erbringung von sonstigen Dienstleistungen für die Schifffahrt',
  },
  {
    code: '5223',
    nl: 'Diensten in verband met de luchtvaart',
    fr: 'Services auxiliaires des transports aériens',
    en: 'Service activities incidental to air transportation',
    de: 'Erbringung von sonstigen Dienstleistungen für die Luftfahrt',
  },
  {
    code: '5224',
    nl: 'Vrachtbehandeling',
    fr: 'Manutention du fret',
    en: 'Cargo handling',
    de: 'Frachtumschlag',
  },
  {
    code: '52241',
    nl: 'Vrachtbehandeling in zeehavens',
    fr: 'Manutention du fret portuaire',
    en: 'Cargo handling in ports',
    de: 'Frachtumschlag in Seehäfen',
  },
  {
    code: '52249',
    nl: 'Overige vrachtbehandeling, exclusief in zeehavens',
    fr: 'Autre manutention du fret sauf portuaire',
    en: 'Other cargo handling except in ports',
    de: 'Sonstiger Güterumschlag, in anderen Einrichtungen als Seehäfen',
  },
  {
    code: '5225',
    nl: 'Logistieke diensten',
    fr: 'Activités de service logistique',
    en: 'Logistics service activities',
    de: 'Erbringung von Logistikdienstleistungen',
  },
  {
    code: '5226',
    nl: 'Andere vervoerondersteunende activiteiten',
    fr: 'Autres activités de soutien pour les transports',
    en: 'Other support activities for transportation',
    de: 'Erbringung von sonstigen Dienstleistungen für den Verkehr',
  },
  {
    code: '5231',
    nl: 'Bemiddelingsactiviteiten in verband met goederenvervoer',
    fr: 'Activités de service d’intermédiation pour le transport de fret',
    en: 'Intermediation service activities for freight transportation',
    de: 'Vermittlungstätigkeiten für die Güterbeförderung',
  },
  {
    code: '5232',
    nl: 'Bemiddelingsactiviteiten in verband met personenvervoer',
    fr: 'Activités de service d’intermédiation pour le transport de passagers',
    en: 'Intermediation service activities for passenger transportation',
    de: 'Vermittlungstätigkeiten für die Personenbeförderung',
  },
  {
    code: '5310',
    nl: 'Postdiensten in het kader van de universele dienstverplichting',
    fr: 'Activités de poste dans le cadre d’une obligation de service universel',
    en: 'Postal activities under universal service obligation',
    de: 'Postdienste von Universaldienstleistungsanbietern',
  },
  {
    code: '5320',
    nl: 'Overige posterijen en koeriers',
    fr: 'Autres activités de poste et de courrier',
    en: 'Other postal and courier activities',
    de: 'Sonstige Post-, Kurier- und Expressdienste',
  },
  {
    code: '5330',
    nl: 'Bemiddelingsactiviteiten in verband met post- en koeriersdiensten',
    fr: 'Activités de service d’intermédiation pour des activités de poste et de courrier',
    en: 'Intermediation service activities for postal and courier activities',
    de: 'Vermittlungstätigkeiten für Post-, Kurier- und Expressdienstleistungen',
  },
  {
    code: '5510',
    nl: 'Hotels en dergelijke accommodatie',
    fr: 'Hôtels et hébergement similaire',
    en: 'Hotels and similar accommodation',
    de: 'Hotels, Gasthöfe und Pensionen',
  },
  {
    code: '5520',
    nl: 'Vakantieverblijven en andere accommodatie voor kort verblijf',
    fr: 'Hébergement touristique et autre hébergement de courte durée',
    en: 'Holiday and other short-stay accommodation',
    de: 'Ferienunterkünfte und ähnliche Beherbergungsstätten',
  },
  {
    code: '55201',
    nl: 'Jeugdherbergen en jeugdverblijfcentra',
    fr: 'Auberges pour jeunes',
    en: 'Youth hostels',
    de: 'Jugendherbergen und -unterkünfte',
  },
  {
    code: '55202',
    nl: 'Vakantieparken',
    fr: 'Centres et villages de vacances',
    en: 'Holiday resorts and villages',
    de: 'Ferienzentren und Feriendörfer',
  },
  {
    code: '55203',
    nl: 'Gites, vakantiewoningen en -appartementen',
    fr: 'Gîtes de vacances, appartements et meublés de vacances',
    en: 'Homes and apartments for holiday',
    de: 'Ferienunterkünfte und -wohnungen',
  },
  {
    code: '55204',
    nl: 'Gastenkamers',
    fr: "Chambres d'hôtes",
    en: 'Guest rooms',
    de: 'Fremdenzimmer',
  },
  {
    code: '55209',
    nl: 'Vakantieverblijven en andere accommodatie voor kort verblijf, n.e.g.',
    fr: 'Hébergement touristique et autre hébergement de courte durée n.c.a.',
    en: 'Holiday and other short-stay accommodation n.e.c.',
    de: 'Ferienunterkünfte für Kurzaufenthalte a.n.g.',
  },
  {
    code: '5530',
    nl: 'Kampeer- en caravanterreinen',
    fr: 'Terrains de camping et parcs pour caravanes ou véhicules de loisirs',
    en: 'Camping grounds and recreational vehicle parks',
    de: 'Campingplätze',
  },
  {
    code: '5540',
    nl: 'Bemiddelingsactiviteiten in verband met accommodatie',
    fr: 'Activités de service d’intermédiation pour l’hébergement',
    en: 'Intermediation service activities for accommodation',
    de: 'Vermittlungstätigkeiten für Beherbergungsdienstleistungen',
  },
  {
    code: '5590',
    nl: 'Overige accommodatie',
    fr: 'Autres hébergements',
    en: 'Other accommodation',
    de: 'Sonstige Beherbergungsstätten',
  },
  {
    code: '5611',
    nl: 'Activiteiten van restaurants',
    fr: 'Activités de restaurant',
    en: 'Restaurant activities',
    de: 'Restaurants, Gaststätten, Imbissstuben, Cafés, Eissalons u. Ä.',
  },
  {
    code: '56111',
    nl: 'Activiteiten van eetgelegenheden met volledige bediening',
    fr: 'Restauration à service complet',
    en: 'Activities of full-service restaurants',
    de: 'Restaurants mit Vollbedienung',
  },
  {
    code: '56112',
    nl: 'Activiteiten van eetgelegenheden met beperkte bediening, m.u.v. mobiele eetgelegenheden',
    fr: "Restauration à service restreint, à l'exclusion de restauration mobile",
    en: 'Activities of limited-service restaurants, except mobile food service activities',
    de: 'Restaurants mit beschränkter Bedienung, mit Ausnahme von mobiler Gastronomie',
  },
  {
    code: '5612',
    nl: 'Activiteiten van mobiele eetgelegenheden',
    fr: 'Activités de service de restauration mobile',
    en: 'Mobile food service activities',
    de: 'Mobile Gastronomie',
  },
  {
    code: '5621',
    nl: 'Catering van evenementen',
    fr: 'Activités de traiteur événementiel',
    en: 'Event catering activities',
    de: 'Event-Caterer',
  },
  {
    code: '5622',
    nl: 'Cateringdiensten op contractbasis en overige diensten in verband met maaltijden',
    fr: 'Activités de service contractuel de restauration et autres activités de service de restauration',
    en: 'Contract catering service activities and other food service activities',
    de: 'Sonstige Caterer und Erbringung sonstiger Verpflegungsdienstleistungen',
  },
  {
    code: '5630',
    nl: 'Activiteiten van drinkgelegenheden',
    fr: 'Activités de débit de boissons',
    en: 'Beverage serving activities',
    de: 'Ausschank von Getränken',
  },
  {
    code: '56301',
    nl: 'Cafés en bars',
    fr: 'Cafés et bars',
    en: 'Cafés and bars',
    de: 'Schankwirtschaften',
  },
  {
    code: '56302',
    nl: 'Discotheken, dancings en dergelijke',
    fr: 'Discothèques, dancings et similaires',
    en: 'Nightclubs, dance halls and the like',
    de: 'Diskotheken, Tanzlokale u.ä.',
  },
  {
    code: '56309',
    nl: 'Andere drinkgelegenheden',
    fr: 'Autres débits de boissons',
    en: 'Other beverage serving activities',
    de: 'Sonstige Getränkeausschänke',
  },
  {
    code: '5640',
    nl: 'Bemiddelingsactiviteiten in verband met eet- en drinkgelegenheden',
    fr: 'Activités de service d’intermédiation pour des activités de service de restauration',
    en: 'Intermediation service activities for food and beverage services activities',
    de: 'Vermittlungstätigkeiten für gastronomische Dienstleistungen',
  },
  {
    code: '5811',
    nl: 'Uitgeven van boeken',
    fr: 'Édition de livres',
    en: 'Publishing of books',
    de: 'Verlegen von Büchern',
  },
  {
    code: '5812',
    nl: 'Uitgeven van kranten',
    fr: 'Édition de journaux',
    en: 'Publishing of newspapers',
    de: 'Verlegen von Zeitungen',
  },
  {
    code: '5813',
    nl: 'Uitgeven van tijdschriften',
    fr: 'Édition de revues et de périodiques',
    en: 'Publishing of journals and periodicals',
    de: 'Verlegen von Zeitschriften',
  },
  {
    code: '5819',
    nl: 'Overige activiteiten van uitgeverijen, met uitzondering van het uitgeven van software',
    fr: 'Autres activités d’édition, à l’exception de l’édition de logiciels',
    en: 'Other publishing activities, except software publishing',
    de: 'Sonstiges Verlagswesen, ohne Software',
  },
  {
    code: '5821',
    nl: 'Uitgeven van computerspellen',
    fr: 'Édition de jeux vidéo',
    en: 'Publishing of video games',
    de: 'Verlegen van Computerspiele',
  },
  {
    code: '5829',
    nl: 'Uitgeven van overige software',
    fr: 'Édition d’autres logiciels',
    en: 'Other software publishing',
    de: 'Verlegen van sonstiger Software',
  },
  {
    code: '5911',
    nl: 'Productie van films en video- en televisieprogramma’s',
    fr: 'Production de films cinématographiques, de vidéos et de programmes de télévision',
    en: 'Motion picture, video and television programme production activities',
    de: 'Herstellung von Filmen, Videofilmen und Fernsehprogrammen',
  },
  {
    code: '59111',
    nl: 'Productie van bioscoopfilms',
    fr: 'Production de films cinématographiques',
    en: 'Motion picture production activities',
    de: 'Produktion von Kinofilmen',
  },
  {
    code: '59112',
    nl: 'Productie van televisiefilms',
    fr: 'Production de films pour la télévision',
    en: 'Television film production activities',
    de: 'Produktion von Fernsehfilmen',
  },
  {
    code: '59113',
    nl: 'Productie van video en film, m.u.v. bioscoop- en televisiefilms',
    fr: 'Production de vidéos et de films, à l’exception des films cinématographiques et des films pour la télévision',
    en: 'Video and film production activities, except motion picture and television films',
    de: 'Filmproduktion, mit Ausnahme von Kino- und Fernsehfilmen',
  },
  {
    code: '59114',
    nl: "Productie van televisieprogramma's",
    fr: 'Production de programmes pour la télévision',
    en: 'Television programme production activities',
    de: 'Produktion von Fernsehprogrammen',
  },
  {
    code: '5912',
    nl: 'Activiteiten in verband met films en video- en televisieprogramma’s na de productie',
    fr: 'Post-production de films cinématographiques, de vidéos et de programmes de télévision',
    en: 'Motion picture, video and television programme post-production activities',
    de: 'Nachbearbeitung und sonstige Filmtechnik',
  },
  {
    code: '5913',
    nl: 'Activiteiten op het gebied van de distributie van films en video’s',
    fr: 'Distribution de films cinématographiques et de vidéos',
    en: 'Motion picture and video distribution activities',
    de: 'Filmverleih und -vertrieb, nicht an private Haushalte',
  },
  {
    code: '5914',
    nl: 'Vertoning van films',
    fr: 'Projection de films cinématographiques',
    en: 'Motion picture projection activities',
    de: 'Kinos',
  },
  {
    code: '5920',
    nl: 'Maken van geluidsopnamen en uitgeverijen van muziekopnamen',
    fr: 'Enregistrement sonore et édition musicale',
    en: 'Sound recording and music publishing activities',
    de: 'Tonstudios; Herstellung von Hörfunkbeiträgen; Verlegen von bespielten Tonträgern und Musikalien',
  },
  {
    code: '59201',
    nl: 'Maken van geluidsopnamen',
    fr: "Production d'enregistrements sonores",
    en: 'Sound recording activities',
    de: 'Produktion von Tonaufnahmen',
  },
  {
    code: '59202',
    nl: "Geluidsopnamestudio's",
    fr: "Studios d'enregistrements sonores",
    en: 'Sound recording studios',
    de: 'Tonaufnahmestudios',
  },
  {
    code: '59203',
    nl: 'Uitgeverijen van muziekopnamen',
    fr: 'Edition musicale',
    en: 'Music publishing activities',
    de: 'Herausgabe von Tonaufnahmen',
  },
  {
    code: '59209',
    nl: 'Overige diensten in verband met het maken van geluidsopnamen',
    fr: "Autres services d'enregistrements sonores",
    en: 'Other sound recording services',
    de: 'Sonstige mit der Anfertigung von Tonaufnahmen zusammenhängende Dienstleistungen',
  },
  {
    code: '6010',
    nl: 'Uitzenden van radioprogramma’s en distributie van audio',
    fr: 'Radiodiffusion et activités de distribution de contenu audio',
    en: 'Radio broadcasting and audio distribution activities',
    de: 'Hörfunkveranstalter und Verbreitung von Audioinhalten',
  },
  {
    code: '6020',
    nl: 'Samenstellen en uitzenden van televisieprogramma’s en distributie van video’s',
    fr: 'Programmation et diffusion télévisuelle et activités de distribution de contenu vidéo',
    en: 'Television programming, broadcasting and video distribution activities',
    de: 'Fernsehveranstalter und Verbreitung von Videoinhalten',
  },
  {
    code: '6031',
    nl: 'Activiteiten van persagentschappen',
    fr: 'Activités d’agence de presse',
    en: 'News agency activities',
    de: 'Nachrichtenagenturen',
  },
  {
    code: '6039',
    nl: 'Andere activiteiten op het gebied van de verspreiding van inhoud',
    fr: 'Autres activités de distribution de contenu',
    en: 'Other content distribution activities',
    de: 'Sonstige Verbreitung von Medieninhalten',
  },
  {
    code: '6110',
    nl: 'Draadgebonden en draadloze telecommunicatie en telecommunicatie via satelliet',
    fr: 'Activités de télécommunications filaires, sans fil et satellitaires',
    en: 'Wired, wireless, and satellite telecommunication activities',
    de: 'Leitungsgebundene, drahtlose und satellitengestützte Telekommunikation',
  },
  {
    code: '6120',
    nl: 'Wederverkoop van telecommunicatie en bemiddelingsactiviteiten in verband met telecommunicatie',
    fr: 'Activités de revente de télécommunications et activités de service d’intermédiation pour les télécommunications',
    en: 'Telecommunication reselling activities and intermediation service activities for telecommunication',
    de: 'Wiederverkaufs- und Vermittlungstätigkeiten für die Telekommunikation',
  },
  {
    code: '6190',
    nl: 'Overige activiteiten op het gebied van telecommunicatie',
    fr: 'Autres activités de télécommunications',
    en: 'Other telecommunication activities',
    de: 'Sonstige Telekommunikation',
  },
  {
    code: '6210',
    nl: 'Ontwerpen van computerprogramma’s',
    fr: 'Activités de programmation informatique',
    en: 'Computer programming activities',
    de: 'Programmierungstätigkeiten',
  },
  {
    code: '6220',
    nl: 'Activiteiten op het gebied van computerconsultancy en beheer van computerfaciliteiten',
    fr: 'Activités de conseil en informatique et de gestion d’installations informatiques',
    en: 'Computer consultancy and computer facilities management activities',
    de: 'Erbringung von Dienstleistungen der IT-Beratung sowie des Betriebs von Datenverarbeitungseinrichtungen',
  },
  {
    code: '6290',
    nl: 'Overige diensten op het gebied van informatietechnologie en computer',
    fr: 'Autres activités de service informatique',
    en: 'Other information technology and computer service activities',
    de: 'Erbringung von sonstigen Dienstleistungen der Informationstechnologie',
  },
  {
    code: '6310',
    nl: 'Computerinfrastructuur, gegevensverwerking, hosting en aanverwante activiteiten',
    fr: 'Infrastructure informatique, traitement de données, hébergement et activités connexes',
    en: 'Computing infrastructure, data processing, hosting and related activities',
    de: 'Datenverarbeitung, Hosting und damit verbundene Tätigkeiten',
  },
  {
    code: '6391',
    nl: 'Activiteiten van webportalen',
    fr: 'Activités de portail de recherche sur le web',
    en: 'Web search portal activities',
    de: 'Web-Suchportale',
  },
  {
    code: '6392',
    nl: 'Overige dienstverlenende activiteiten op het gebied van informatie',
    fr: "Autres activités de service d'information",
    en: 'Other information service activities',
    de: 'Erbringung von sonstigen Informationsdienstleistungen',
  },
  {
    code: '6411',
    nl: 'Activiteiten van centrale banken',
    fr: 'Activités de banque centrale',
    en: 'Central banking',
    de: 'Zentralbanken',
  },
  {
    code: '6419',
    nl: 'Overige activiteiten van geldscheppende financiële instellingen',
    fr: 'Autre intermédiation monétaire',
    en: 'Other monetary intermediation',
    de: 'Kreditinstitute, ohne Spezialkreditinstitute',
  },
  {
    code: '6421',
    nl: 'Activiteiten van holdings',
    fr: 'Activités de société holding',
    en: 'Activities of holding companies',
    de: 'Beteiligungsgesellschaften',
  },
  {
    code: '6422',
    nl: 'Activiteiten van financieringskanalen',
    fr: 'Activités de conduit de financement',
    en: 'Activities of financing conduits',
    de: 'Finanzierungs-Conduits',
  },
  {
    code: '6431',
    nl: 'Activiteiten van geldmarkt- en niet-geldmarktbeleggingsfondsen',
    fr: 'Activités de fonds d’investissement sur le marché monétaire ou non monétaire',
    en: 'Activities of money market and non-money market investments funds',
    de: 'Investmentfonds',
  },
  {
    code: '6432',
    nl: 'Activiteiten van trust-, vastgoed- en agentuurrekeningen',
    fr: 'Activités de fiducie, comptes de patrimoine et d’agence',
    en: 'Activities of trust, estate and agency accounts',
    de: 'Treuhandfonds, Nachlass- und Treuhandkonten',
  },
  {
    code: '6491',
    nl: 'Financiële lease',
    fr: 'Crédit-bail',
    en: 'Financial leasing',
    de: 'Institutionen für Finanzierungsleasing',
  },
  {
    code: '6492',
    nl: 'Overige kredietverstrekking',
    fr: 'Autre distribution de crédit',
    en: 'Other credit granting',
    de: 'Spezialkreditinstitute',
  },
  {
    code: '64921',
    nl: 'Verstrekken van verbruikskrediet',
    fr: 'Octroi de crédit à la consommation',
    en: 'Granting of consumer credits',
    de: 'Vergabe von Verbraucherkrediten',
  },
  {
    code: '64922',
    nl: 'Verstrekken van hypothecair krediet',
    fr: 'Octroi de crédit hypothécaire',
    en: 'Granting of mortgage loans',
    de: 'Vergabe von Hypothekendarlehen',
  },
  {
    code: '64923',
    nl: 'Factoring',
    fr: "Activités d'affacturage (Factoring)",
    en: 'Factoring activities',
    de: 'Factoring',
  },
  {
    code: '64924',
    nl: 'Titrisatie van leningen',
    fr: 'Titrisation de prêts',
    en: 'Securitisation of loans',
    de: 'Verbriefung von Krediten',
  },
  {
    code: '64929',
    nl: 'Overige kredietvertsrekking, n.e.g.',
    fr: 'Autre distribution de crédit n.c.a.',
    en: 'Other credit granting n.e.c.',
    de: 'Sonstige Kreditvergabe a.n.g.',
  },
  {
    code: '6499',
    nl: 'Overige financiële dienstverlening, exclusief verzekeringen en pensioenfondsen, n.e.g.',
    fr: 'Autres activités des services financiers, hors assurance et fonds de pension, n.c.a.',
    en: 'Other financial service activities, except insurance and pension funding n.e.c.',
    de: 'Sonstige Finanzdienstleistungen a. n. g.',
  },
  {
    code: '64991',
    nl: 'Activiteiten van beursvennootschappen',
    fr: 'Activités des sociétés de bourses',
    en: 'Activities of stock exchange companies',
    de: 'Tätigkeiten von Börsengesellschaften',
  },
  {
    code: '64999',
    nl: 'Overige financiële dienstverlening, n.e.g.',
    fr: 'Autres activités des services financiers, n.c.a.',
    en: 'Other financial service activities n.e.c.',
    de: 'Sonstige Finanzdienstleistungen a. n. g.',
  },
  {
    code: '6511',
    nl: 'Levensverzekeringen',
    fr: 'Assurance vie',
    en: 'Life insurance',
    de: 'Lebensversicherungen',
  },
  {
    code: '65111',
    nl: 'Rechtstreekse verzekeringsverrichtingen leven',
    fr: "Opérations directes d'assurance vie",
    en: 'Direct life insurance transactions',
    de: 'direkte Lebensversicherungsgeschäfte',
  },
  {
    code: '65112',
    nl: 'Activiteiten van gemengde verzekeringsondernemingen, overwegend leven',
    fr: "Activités des entreprises d'assurances multibranches à prédominance vie",
    en: 'Activities of multi-line, predominantly life insurance companies',
    de: 'Tätigkeiten von Versicherungsunternehmen in verschiedenen Versicherungszweigen mit Schwerpunkt in der Lebensversicherung',
  },
  {
    code: '6512',
    nl: 'Niet-levensverzekeringen',
    fr: 'Assurances non-vie',
    en: 'Non-life insurance',
    de: 'Nichtlebensversicherungen',
  },
  {
    code: '65121',
    nl: 'Rechtstreekse verzekeringsverrichtingen niet-leven',
    fr: "Opérations directes d'assurance non-vie",
    en: 'Direct non-life insurance transactions',
    de: 'Sonstige Versicherungen (ohne Rückversicherung)',
  },
  {
    code: '65122',
    nl: 'Activiteiten van gemengde verzekeringsondernemingen, overwegend niet-leven',
    fr: "Activités des entreprises d'assurances multibranches à prédominance non-vie",
    en: 'Activities of multi-line, predominantly non-life insurance companies',
    de: 'Tätigkeiten von Versicherungsunternehmen in verschiedenen Versicherungszweigen mit Schwerpunkt in der Nichtlebensversicherung',
  },
  {
    code: '6520',
    nl: 'Herverzekering',
    fr: 'Réassurance',
    en: 'Reinsurance',
    de: 'Rückversicherungen',
  },
  {
    code: '6530',
    nl: 'Activiteiten van pensioenfondsen',
    fr: 'Fonds de pension',
    en: 'Pension funding',
    de: 'Pensionskassen und Pensionsfonds',
  },
  {
    code: '6611',
    nl: 'Beheer van financiële markten',
    fr: 'Administration de marchés financiers',
    en: 'Administration of financial markets',
    de: 'Effekten- und Warenbörsen',
  },
  {
    code: '6612',
    nl: 'Bemiddeling in effecten- en goederencontracten',
    fr: 'Courtage de valeurs mobilières et de matières premières',
    en: 'Security and commodity contracts brokerage',
    de: 'Effekten- und Warenhandel',
  },
  {
    code: '66121',
    nl: 'Crowdfunding',
    fr: 'Financement participatif (crowdfunding)',
    en: 'Crowdfunding',
    de: 'Crowdfunding',
  },
  {
    code: '66129',
    nl: 'Overige bemiddeling in effecten- en goederencontracten, m.u.v. crowdfunding',
    fr: 'Autre courtage de valeurs mobilières et de matières premières, à l’exception du financement participatif (crowdfunding)',
    en: 'Other security and commodity contracts brokerage, except crowdfunding',
    de: 'Sonstiger Effekten- und Warenhandel, mit Ausnahme von Crowdfunding',
  },
  {
    code: '6619',
    nl: 'Overige ondersteunende activiteiten in verband met financiële diensten, exclusief verzekeringen en pensioenfondsen',
    fr: 'Autres activités auxiliaires de services financiers, hors assurance et fonds de pension',
    en: 'Other activities auxiliary to financial services, except insurance and pension funding',
    de: 'Sonstige mit Finanzdienstleistungen verbundene Tätigkeiten',
  },
  {
    code: '66191',
    nl: 'Agenten en makelaars in bankdiensten',
    fr: 'Activités des agents et courtiers en services bancaires',
    en: 'Activities of banking service agents and brokers',
    de: 'Makler und Vermittler im Bereich Bankdienstleistungen',
  },
  {
    code: '66199',
    nl: 'Overige ondersteunende activiteiten in verband met financiële diensten, n.e.g., exclusief verzekeringen en pensioenfondsen',
    fr: 'Autres activités auxiliaires de services financiers n.c.a., hors assurance et caisses de retraite',
    en: 'Other activities auxiliary to financial services n.e.c., except insurance and pension funding',
    de: 'Sonstige mit Finanzdienstleistungen verbundene Tätigkeiten a.n.g., mit Ausnahme von Versicherungen und Pensionskassen',
  },
  {
    code: '6621',
    nl: 'Activiteiten van risicoanalisten en schadetaxateurs',
    fr: 'Évaluation des risques et dommages',
    en: 'Risk and damage evaluation',
    de: 'Risiko- und Schadensbewertung',
  },
  {
    code: '6622',
    nl: 'Activiteiten van verzekeringsagenten en -makelaars',
    fr: 'Activités des agents et courtiers d’assurances',
    en: 'Activities of insurance agents and brokers',
    de: 'Tätigkeiten der Versicherungsvermittlung',
  },
  {
    code: '6629',
    nl: 'Ondersteunende activiteiten in verband met verzekeringen en pensioenfondsen, n.e.g.',
    fr: 'Activités auxiliaires d’assurance et de fonds de pension n.c.a.',
    en: 'Activities auxiliary to insurance and pension funding n.e.c.',
    de: 'Mit Versicherungsdienstleistungen und Pensionskassen verbundene Tätigkeiten a. n. g.',
  },
  {
    code: '6630',
    nl: 'Vermogensbeheer',
    fr: 'Activités de gestion de fonds',
    en: 'Fund management activities',
    de: 'Fondsmanagement',
  },
  {
    code: '6811',
    nl: 'Handel in eigen onroerend goed',
    fr: 'Achat et vente de biens propres',
    en: 'Buying and selling of own real estate',
    de: 'Kauf und Verkauf von eigenen Grundstücken, Gebäuden und Wohnungen',
  },
  {
    code: '6812',
    nl: 'Ontwikkeling van bouwprojecten',
    fr: 'Promotion immobilière',
    en: 'Development of building projects',
    de: 'Erschließung von Grundstücken; Bauträger',
  },
  {
    code: '68121',
    nl: 'Ontwikkeling van residentiële bouwprojecten',
    fr: 'Promotion immobilière résidentielle',
    en: 'Development of residential building projects',
    de: 'Entwicklung von Wohnbauprojekten',
  },
  {
    code: '68122',
    nl: 'Ontwikkeling van niet-residentiële bouwprojecten',
    fr: 'Promotion immobilière non résidentielle',
    en: 'Development of non-residential building projects',
    de: 'Entwicklung von Nichtwohngebäuden',
  },
  {
    code: '6820',
    nl: 'Verhuur en exploitatie van eigen of geleased onroerend goed',
    fr: 'Location et exploitation de biens immobiliers propres ou loués',
    en: 'Rental and operating of own or leased real estate',
    de: 'Vermietung, Verpachtung von eigenen oder geleasten Grundstücken, Gebäuden und Wohnungen',
  },
  {
    code: '68201',
    nl: 'Verhuur en exploitatie van eigen of geleased residentieel onroerend goed, exclusief sociale woningen',
    fr: 'Location et exploitation de biens immobiliers résidentiels propres ou loués, sauf logements sociaux',
    en: 'Rental and operating of own or leased residential real estate, except social housing',
    de: 'Vermietung, Verpachtung von eigenen oder geleasten Wohnimmobilien mit Ausnahme von Sozialwohnungen',
  },
  {
    code: '68202',
    nl: 'Verhuur en exploitatie van sociale woningen',
    fr: 'Location et exploitation de logements sociaux',
    en: 'Rental and operating of social housing',
    de: 'Vermietung und Verpachtung von Sozialwohnungen',
  },
  {
    code: '68203',
    nl: 'Verhuur en exploitatie van eigen of geleased niet-residentieel onroerend goed, exclusief terreinen',
    fr: 'Location et exploitation de biens immobiliers non résidentiels propres ou loués, sauf terrains',
    en: 'Rental and operating of own or leased non-residential real estate, except land',
    de: 'Vermietung, Verpachtung von eigenen oder geleasten Nichtwohnimmobilien mit Ausnahme von Grundstücken',
  },
  {
    code: '68204',
    nl: 'Verhuur en exploitatie van terreinen',
    fr: 'Location et exploitation de terrains',
    en: 'Rental and operating of land',
    de: 'Vermietung und Verpachtung von Grundstücken',
  },
  {
    code: '6831',
    nl: 'Bemiddeling in verband met exploitatie van en handel in onroerend goed',
    fr: 'Activités de service d’intermédiation pour les activités immobilières',
    en: 'Intermediation service activities for real estate activities',
    de: 'Vermittlung von Grundstücken, Gebäuden und Wohnungen für Dritte',
  },
  {
    code: '6832',
    nl: 'Overige bemiddeling in en beheer van onroerend goed voor een vast bedrag of op contractbasis',
    fr: 'Autres activités immobilières pour compte de tiers',
    en: 'Other real estate activities on a fee or contract basis',
    de: 'Verwaltung von Grundstücken, Gebäuden und Wohnungen für Dritte',
  },
  {
    code: '68321',
    nl: 'Activiteiten van syndici van onroerend goed',
    fr: 'Activités des syndics de biens immobiliers',
    en: 'Activities of managing agents of real estate',
    de: 'Tätigkeiten von Syndizi von Immobilien',
  },
  {
    code: '68322',
    nl: 'Schatten en evalueren van onroerend goed voor een vast bedrag of op contractbasis',
    fr: 'Estimation et évaluation de biens immobiliers pour compte de tiers',
    en: 'Valuation and appraisal of real estate on a fee or contract basis',
    de: 'Schätzung und Bewertung von Immobilien für Dritte',
  },
  {
    code: '68329',
    nl: 'Overige bemiddeling in en beheer van onroerend goed voor een vast bedrag of op contractbasis, n.e.g.',
    fr: 'Autres activités immobilières pour compte de tiers n.c.a.',
    en: 'Other real estate activities on a fee or contract basis n.e.c.',
    de: 'Verwaltung von Grundstücken, Gebäuden und Wohnungen für Dritte a.n.g.',
  },
  {
    code: '6910',
    nl: 'Rechtskundige dienstverlening',
    fr: 'Activités juridiques',
    en: 'Legal activities',
    de: 'Rechtsberatung',
  },
  {
    code: '69101',
    nl: 'Activiteiten van advocaten',
    fr: 'Activités des avocats',
    en: 'Activities of lawyers',
    de: 'Tätigkeiten von Rechtsanwälten',
  },
  {
    code: '69102',
    nl: 'Activiteiten van notarissen',
    fr: 'Activités des notaires',
    en: 'Activities of notaries',
    de: 'Tätigkeiten von Notaren',
  },
  {
    code: '69103',
    nl: 'Activiteiten van deurwaarders',
    fr: 'Activités des huissiers de justice',
    en: 'Activities of bailiffs',
    de: 'Tätigkeiten von Gerichtsvollziehern',
  },
  {
    code: '69109',
    nl: 'Overige rechtskundige dienstverlening',
    fr: 'Autres activités juridiques',
    en: 'Other legal activities',
    de: 'Sonstige Rechtsberatung',
  },
  {
    code: '6920',
    nl: 'Activiteiten van accountants, boekhouders, auditoren en belastingconsulenten',
    fr: 'Activités de comptabilité, de tenue de comptes et d’audit; conseil fiscal',
    en: 'Accounting, bookkeeping and auditing activities; tax consultancy',
    de: 'Wirtschaftsprüfung und Steuerberatung; Buchführung',
  },
  {
    code: '69201',
    nl: 'Activiteiten van (gecertificeerde) (fiscaal) accountants',
    fr: 'Activités des experts-comptables (fiscalistes) (certifiés)',
    en: 'Activities of certified accountants (tax experts)',
    de: 'Tätigkeiten von (zertifizierten) Buchprüfern(-Fiskalisten)',
  },
  {
    code: '69202',
    nl: 'Activiteiten van gecertificeerde belastingadviseurs',
    fr: 'Activités des conseillers fiscaux certifiés',
    en: 'Activities of certified tax advisers',
    de: 'Tätigkeiten von zertifizierten Steuerberatern',
  },
  {
    code: '69203',
    nl: 'Activiteiten van bedrijfsrevisoren',
    fr: "Activités des réviseurs d'entreprises",
    en: 'Activities of auditors',
    de: 'Tätigkeiten von Betriebsrevisoren',
  },
  {
    code: '69209',
    nl: 'Overige fiscale dienstverlening',
    fr: 'Autres activités fiscales',
    en: 'Other tax services',
    de: 'Sonstige Steuerberatungsdienste',
  },
  {
    code: '7010',
    nl: 'Activiteiten van hoofdkantoren',
    fr: 'Activités des sièges sociaux',
    en: 'Activities of head offices',
    de: 'Verwaltung und Führung von Unternehmen und Betrieben',
  },
  {
    code: '7020',
    nl: 'Activiteiten van adviesbureaus op het gebied van bedrijfsvoering en overig managementadvies',
    fr: 'Activités de conseil pour les affaires et autre conseil de gestion',
    en: 'Business and other management consultancy activities',
    de: 'Unternehmensberatung',
  },
  {
    code: '7111',
    nl: 'Activiteiten van architecten',
    fr: 'Activités d’architecture',
    en: 'Architectural activities',
    de: 'Tätigkeiten von Architekturbüros',
  },
  {
    code: '71111',
    nl: 'Activiteiten van bouwarchitecten',
    fr: "Activités d'architecture de construction",
    en: 'Activities of building architects',
    de: 'Tätigkeiten im Bereich Architektur und Bau',
  },
  {
    code: '71112',
    nl: 'Activiteiten van interieurarchitecten',
    fr: "Activités d'architecture d'intérieur",
    en: 'Activities of interior architects',
    de: 'Tätigkeiten im Bereich Innenarchitektur',
  },
  {
    code: '71113',
    nl: 'Activiteiten van stedebouwkundige en tuin- en landschapsarchitecten',
    fr: "Activités d'architecture d'urbanisme, de paysage et de jardin",
    en: 'Activities of urban, landscape and garden architects',
    de: 'Tätigkeiten in den Bereichen Stadtplanung, Garten- und Landschaftsarchitektur usw.',
  },
  {
    code: '71119',
    nl: 'Overige activiteiten op het gebied van architectuur, n.e.g.',
    fr: "Autres activités dans le domaine d'architecture, n.e.c.",
    en: 'Other architectural activities n.e.c.',
    de: 'Sonstige Tätigkeiten im Bereich Architektur a.n.g.',
  },
  {
    code: '7112',
    nl: 'Activiteiten van ingenieurs en aanverwante technische adviseurs',
    fr: 'Activités d’ingénierie et de conseil technique connexe',
    en: 'Engineering activities and related technical consultancy',
    de: 'Tätigkeiten von Ingenieurbüros',
  },
  {
    code: '71121',
    nl: 'Activiteiten van ingenieurs en aanverwante technische adviseurs, exclusief landmeters-experts',
    fr: "Activités d'ingénierie et de conseils techniques, sauf activités des géomètres-experts",
    en: 'Engineering activities and technical consultancy, except activities of land surveyors',
    de: 'Ingenieurstätigkeiten, technische Beratung, mit Ausnahme von Vermessungstätigkeiten',
  },
  {
    code: '71122',
    nl: 'Activiteiten van landmeters-experts',
    fr: 'Activités des géomètres-experts',
    en: 'Activities of land surveyors',
    de: 'Vermessungstätigkeiten',
  },
  {
    code: '7120',
    nl: 'Technische testen en toetsen',
    fr: 'Activités de contrôle et analyses techniques',
    en: 'Technical testing and analysis',
    de: 'Technische, physikalische und chemische Untersuchung',
  },
  {
    code: '71201',
    nl: 'Technische controle van motorvoertuigen',
    fr: 'Contrôle technique des véhicules automobiles',
    en: 'Motor vehicle inspection',
    de: 'Technische Kontrolle von Kraftfahrzeugen',
  },
  {
    code: '71209',
    nl: 'Overige technische testen en toetsen',
    fr: 'Autres activités de contrôle et analyses techniques',
    en: 'Other technical testing and analysis activities',
    de: 'Sonstige technische Kontrollen und Analysen',
  },
  {
    code: '7210',
    nl: 'Speur- en ontwikkelingswerk op natuurwetenschappelijk gebied',
    fr: 'Recherche et développement en sciences physiques et naturelles',
    en: 'Research and experimental development on natural sciences and engineering',
    de: 'Forschung und Entwicklung im Bereich Natur-, Ingenieur-, Agrarwissenschaften und Medizin',
  },
  {
    code: '72101',
    nl: 'Speur- en ontwikkelingswerk op biotechnologisch gebied',
    fr: 'Recherche-développement en biotechnologie',
    en: 'Research and experimental development on biotechnology',
    de: 'Forschung und Entwicklung im Bereich Biotechnologie',
  },
  {
    code: '72109',
    nl: 'Overig speur- en ontwikkelingswerk op natuurwetenschappelijk gebied',
    fr: 'Recherche-développement en autres sciences physiques et naturelles',
    en: 'Research and experimental development on other natural sciences and engineering',
    de: 'Sonstige Forschung und Entwicklung im Bereich Natur-, Ingenieur-, Agrarwissenschaften und Medizin',
  },
  {
    code: '7220',
    nl: 'Speur- en ontwikkelingswerk op het gebied van de maatschappij- en geesteswetenschappen',
    fr: 'Recherche et développement en sciences humaines et sociales',
    en: 'Research and experimental development on social sciences and humanities',
    de: 'Forschung und Entwicklung im Bereich Rechts-, Wirtschafts- und Sozialwissenschaften sowie im Bereich Sprach-, Kultur- und Kunstwissenschaften',
  },
  {
    code: '7311',
    nl: 'Activiteiten van reclamebureaus',
    fr: 'Activités d’agence de publicité',
    en: 'Activities of advertising agencies',
    de: 'Tätigkeiten von Werbeagenturen',
  },
  {
    code: '7312',
    nl: 'Mediarepresentatie',
    fr: 'Régie publicitaire de médias',
    en: 'Media representation',
    de: 'Vermarktung und Vermittlung von Werbezeiten und Werbeflächen',
  },
  {
    code: '7320',
    nl: 'Markt- en opinieonderzoek',
    fr: 'Études de marché et sondages',
    en: 'Market research and public opinion polling',
    de: 'Markt- und Meinungsforschung',
  },
  {
    code: '7330',
    nl: 'Activiteiten van adviesbureaus op het gebied van public relations en communicatie',
    fr: 'Activités de conseil en relations publiques et communication',
    en: 'Public relations and communication activities',
    de: 'Public-Relations-Beratung',
  },
  {
    code: '7411',
    nl: 'Ontwerpen van industriële producten en mode',
    fr: 'Activités de design pour la création de mode ou les produits industriels',
    en: 'Industrial product and fashion design activities',
    de: 'Industrie-, Produkt- und Modedesign',
  },
  {
    code: '74111',
    nl: 'Ontwerpen van textielpatronen, kleding, juwelen, meubels en decoratieartikelen',
    fr: "Création de modèles pour articles textiles, d'articles d’habillement, de bijoux, de meubles et d'objets de décoration intérieure",
    en: 'Fashion design of textiles, wearing apparel, jewellery, furniture and interior decoration goods',
    de: 'Ateliers für Textil-, Schmuck-, Möbel- u.ä. Design',
  },
  {
    code: '74112',
    nl: 'Activiteiten van industriële designers',
    fr: 'Activités de design industriel',
    en: 'Industrial product design activities',
    de: 'Tätigkeiten im Bereich Industriedesign',
  },
  {
    code: '7412',
    nl: 'Grafisch ontwerp en visuele communicatie',
    fr: 'Activités de design graphique et de communication visuelle',
    en: 'Graphic design and visual communication activities',
    de: 'Grafik- und Kommunikationsdesign',
  },
  {
    code: '7413',
    nl: 'Interieurontwerp',
    fr: 'Activités de design d’intérieur',
    en: 'Interior design activities',
    de: 'Innenraumdesign und Raumgestaltung',
  },
  {
    code: '7414',
    nl: 'Overige gespecialiseerde ontwerpactiviteiten',
    fr: 'Autres activités spécialisées de design',
    en: 'Other specialised design activities',
    de: 'Sonstige spezialisierte Designtätigkeiten',
  },
  {
    code: '7420',
    nl: 'Activiteiten op het gebied van fotografie',
    fr: 'Activités photographiques',
    en: 'Photographic activities',
    de: 'Fotografie und Fotolabors',
  },
  {
    code: '74201',
    nl: 'Activiteiten van fotografen, met uitzondering van persfotografen',
    fr: 'Production photographique, sauf activités des photographes de presse',
    en: 'Photograph production, except activities of press photographers',
    de: 'Tätigkeiten von Fotographen mit Ausnahme von Pressefotographen',
  },
  {
    code: '74202',
    nl: 'Activiteiten van persfotografen',
    fr: 'Activités des photographes de presse',
    en: 'Activities of press photographers',
    de: 'Tätigkeiten von Pressefotographen',
  },
  {
    code: '74209',
    nl: 'Overige fotografische activiteiten',
    fr: 'Autres activités photographiques',
    en: 'Other photographic activities',
    de: 'Sonstige Tätigkeiten im Bereich Fotographie',
  },
  {
    code: '7430',
    nl: 'Activiteiten van vertalers en tolken',
    fr: 'Activités de traduction et d’interprétation',
    en: 'Translation and interpretation activities',
    de: 'Übersetzen und Dolmetschen',
  },
  {
    code: '74301',
    nl: 'Activiteiten van vertalers',
    fr: 'Activités de traduction',
    en: 'Translation activities',
    de: 'Übersetzen',
  },
  {
    code: '74302',
    nl: 'Activiteiten van tolken',
    fr: "Activités d'interprétation",
    en: 'Interpretation activities',
    de: 'Dolmetschen',
  },
  {
    code: '7491',
    nl: 'Bemiddeling in en het in de handel brengen van octrooien',
    fr: "Activités d'intermédiation et commercialisation de brevets",
    en: 'Patent brokering and marketing service activities',
    de: 'Erbringung von Vermittlungs- und Vermarktungsdienstleistungen für Patente',
  },
  {
    code: '7499',
    nl: 'Alle overige wetenschappelijke en technische activiteiten  en overige specialistische zakelijke dienstverlening, n.e.g.',
    fr: 'Toutes les autres activités des professions libérales et autres activités scientifiques et techniques, n.c.a.',
    en: 'All other professional, scientific and technical activities n.e.c.',
    de: 'Alle anderen wissenschaftlichen und technischen Tätigkeiten a. n. g.',
  },
  {
    code: '74991',
    nl: 'Activiteiten van managers van artiesten, sportlui en overige bekende personaliteiten',
    fr: "Activités des agents et représentants d'artistes, de sportifs et d'autres, personnalités publiques",
    en: 'Activities of agents and representatives for artists, sportsmen and other personalities',
    de: 'Agenten- und Managertätigkeiten für Künstler, Sportler und andere prominenten Persönlichkeiten',
  },
  {
    code: '74999',
    nl: 'Overige activiteiten van vrije beroepen en andere wetenschappelijke en technische activiteiten, n.e.g.',
    fr: 'Autres activités des professions libérales et autres activités scientifiques et techniques, n.c.a.',
    en: 'Other liberal professions and professional, scientific and technical activities n.e.c.',
    de: 'Sonstige wissenschaftliche und technische Tätigkeiten a. n. g.',
  },
  {
    code: '7500',
    nl: 'Veterinaire diensten',
    fr: 'Activités vétérinaires',
    en: 'Veterinary activities',
    de: 'Veterinärwesen',
  },
  {
    code: '7711',
    nl: 'Verhuur en lease van personenauto’s en andere lichte motorvoertuigen',
    fr: 'Location et location-bail de voitures et véhicules automobiles légers',
    en: 'Rental and leasing of cars and light motor vehicles',
    de: 'Vermietung von Kraftwagen mit einem Gesamtgewicht von 3,5 t oder weniger',
  },
  {
    code: '7712',
    nl: 'Verhuur en lease van vrachtwagens',
    fr: 'Location et location-bail de camions',
    en: 'Rental and leasing of trucks',
    de: 'Vermietung von Kraftwagen mit einem Gesamtgewicht von mehr als 3,5 t',
  },
  {
    code: '7721',
    nl: 'Verhuur en lease van sport- en recreatieartikelen',
    fr: 'Location et location-bail d’articles de loisirs et de sport',
    en: 'Rental and leasing of recreational and sports goods',
    de: 'Vermietung von Sport- und Freizeitgeräten',
  },
  {
    code: '7722',
    nl: 'Verhuur en lease van andere huishoudelijke of persoonlijke artikelen',
    fr: 'Location et location-bail d’autres biens personnels et domestiques',
    en: 'Rental and leasing of other personal and household goods',
    de: 'Vermietung von sonstigen Gebrauchsgütern',
  },
  {
    code: '77221',
    nl: 'Verhuur en lease van machines, apparatuur en handgereedschap voor doe-het-zelvers',
    fr: "Location et location-bail de machines-outils, de matériel et d'outils à main pour le bricolage",
    en: 'Rental and leasing of DIY machine tools, equipment and hand tools',
    de: 'Vermietung und Leasing von Werkzeugmaschinen, Geräten und Handwerkzeugen für Heimwerker',
  },
  {
    code: '77222',
    nl: 'Verhuur en lease van televisietoestellen en andere audio- en videoapparatuur',
    fr: "Location et location-bail de téléviseurs et d'autres appareils audiovisuels",
    en: 'Rental and leasing of televisions and other audiovisual equipment',
    de: 'Vermietung und Leasing von Fernsehern und anderen audiovisuellen Geräten',
  },
  {
    code: '77223',
    nl: 'Verhuur en lease van vaat- en glaswerk, keuken- en tafelgerei, elektrische huishoudapparaten en andere huishoudelijke benodigdheden',
    fr: 'Location et location-bail de vaisselle, couverts, verrerie, articles pour la cuisine, appareils électriques et électroménagers',
    en: 'Rental and leasing of glass, kitchen and tableware, electrical appliances and house wares',
    de: 'Vermietung und Leasing von Geschirr, Glaswaren, Küchen- und Tischbesteck, elektrischen Haushaltsgeräten und sontigen Haushaltsutensilien',
  },
  {
    code: '77224',
    nl: 'Verhuur en lease van textiel, kleding, sieraden en schoeisel',
    fr: "Location et location-bail de textiles, d'habillement, de bijoux et de chaussures",
    en: 'Rental and leasing of textiles, wearing apparel, jewellery and footwear',
    de: 'Vermietung und Leasing von Textilien, Kleidung, Schmuck und Schuhen',
  },
  {
    code: '77225',
    nl: 'Verhuur en lease van medisch en paramedisch materieel',
    fr: 'Location et location-bail de matériel médical et paramédical',
    en: 'Rental and leasing of medical and paramedical equipment',
    de: 'Vermietung und Leasing von medizinischem und paramedizinischem Material',
  },
  {
    code: '77226',
    nl: 'Verhuur en lease van bloemen en planten',
    fr: 'Location et location-bail de fleurs et de plantes',
    en: 'Rental and leasing of flowers and plants',
    de: 'Vermietung und Leasing von Blumen und Pflanzen',
  },
  {
    code: '77229',
    nl: 'Verhuur en lease van andere huishoudelijke of persoonlijke artikelen, n.e.g.',
    fr: "Location et location-bail d'autres biens personnels et domestiques n.c.a.",
    en: 'Rental and leasing of other personal and household goods n.e.c.',
    de: 'Vermietung und Leasing von sonstigen persönlichen Gütern und Haushaltsgütern a.n.g.',
  },
  {
    code: '7731',
    nl: 'Verhuur en lease van landbouwmachines en -werktuigen',
    fr: 'Location et location-bail de matériel agricole',
    en: 'Rental and leasing of agricultural machinery and equipment',
    de: 'Vermietung von landwirtschaftlichen Maschinen und Geräten',
  },
  {
    code: '7732',
    nl: 'Verhuur en lease van machines en installaties voor de bouwnijverheid en de weg- en waterbouw',
    fr: 'Location et location-bail de machines et équipements pour la construction et le génie civil',
    en: 'Rental and leasing of construction and civil engineering machinery and equipment',
    de: 'Vermietung von Baumaschinen und -geräten',
  },
  {
    code: '7733',
    nl: 'Verhuur en lease van kantoormachines, inclusief computers',
    fr: 'Location et location-bail de machines et équipements de bureau et d’ordinateurs',
    en: 'Rental and leasing of office machinery, equipment and computers',
    de: 'Vermietung von Büromaschinen, Datenverarbeitungsgeräten und -einrichtungen',
  },
  {
    code: '7734',
    nl: 'Verhuur en lease van transportmiddelen voor vervoer over water',
    fr: 'Location et location-bail de matériels de transport par eau',
    en: 'Rental and leasing of water transport equipment',
    de: 'Vermietung von Wasserfahrzeugen',
  },
  {
    code: '7735',
    nl: 'Verhuur en lease van luchtvaartuigen',
    fr: 'Location et location-bail de matériels de transport aérien',
    en: 'Rental and leasing of air transport equipment',
    de: 'Vermietung von Luftfahrzeugen',
  },
  {
    code: '7739',
    nl: 'Verhuur en lease van andere machines en werktuigen en andere materiële goederen, n.e.g.',
    fr: 'Location et location-bail d’autres machines, équipements et biens n.c.a.',
    en: 'Rental and leasing of other machinery, equipment and tangible goods n.e.c.',
    de: 'Vermietung von sonstigen Maschinen, Geräten und beweglichen Sachen a.n. g.',
  },
  {
    code: '77391',
    nl: 'Verhuur en lease van speel-, amusement-, en verkoopautomaten',
    fr: 'Location et location-bail de machines à sous, de machines de jeux et de machines automatiques de vente de produits',
    en: 'Rental and leasing of gambling machines, gaming machines and vending machines',
    de: 'Vermietung und Leasing von Spiel-, Unterhaltungs- und Verkaufsautomaten',
  },
  {
    code: '77392',
    nl: 'Verhuur en lease van tenten',
    fr: 'Location et location-bail de tentes',
    en: 'Rental and leasing of tents',
    de: 'Vermietung und Leasing von Zelten',
  },
  {
    code: '77393',
    nl: 'Verhuur en lease van caravans',
    fr: 'Location et location-bail de caravanes',
    en: 'Rental and leasing of caravans',
    de: 'Vermietung und Leasing von Wohnwagen',
  },
  {
    code: '77394',
    nl: 'Verhuur en lease van woon- en bureelcontainers en dergelijke accommodatie',
    fr: 'Location et location-bail de conteneurs à usage de bâtiment',
    en: 'Rental and leasing of accommodation or office containers',
    de: 'Vermietung und Leasing von Wohn- und Bürocontainern und dengleichen',
  },
  {
    code: '77399',
    nl: 'Verhuur en lease van andere machines en werktuigen en andere materiële goederen',
    fr: "Location et location-bail d'autres machines, équipements et biens matériels",
    en: 'Rental and leasing of other miscellaneous machinery, equipment and tangible goods',
    de: 'Vermietung und Leasing von sonstigen Maschinen, Werkzeugen und materiellen Gütern',
  },
  {
    code: '7740',
    nl: 'Lease van intellectuele eigendom en vergelijkbare producten, met uitzondering van werken onder auteursrecht',
    fr: 'Location-bail de propriété intellectuelle et de produits similaires, à l’exception des œuvres soumises à copyright',
    en: 'Leasing of intellectual property and similar products, except copyrighted works',
    de: 'Leasing von nichtfinanziellen immateriellen Vermögensgütern, ohne Copyrights',
  },
  {
    code: '7751',
    nl: 'Bemiddeling in verband met verhuur en leasing van auto’s, campers en aanhangwagens',
    fr: 'Activités de service d’intermédiation pour la location et la location-bail de voitures, camping-cars et caravanes',
    en: 'Intermediation service activities for rental and leasing of cars, motorhomes and trailers',
    de: 'Vermittlungstätigkeiten für die Vermietung und das Leasing von Autos, Wohnmobilen und Anhängern',
  },
  {
    code: '7752',
    nl: 'Bemiddeling in verband met verhuur en leasing van andere materiële goederen en niet-financiële immateriële activa',
    fr: 'Activités de service d’intermédiation pour la location et la location-bail d’autres biens corporels et d’immobilisations incorporelles non financières',
    en: 'Intermediation service activities for rental and leasing of other tangible goods and non-financial intangible assets',
    de: 'Vermittlungstätigkeiten für die Vermietung und das Leasing von sonstigen beweglichen Sachen und nichtfinanziellen immateriellen Vermögensgütern',
  },
  {
    code: '7810',
    nl: 'Arbeidsbemiddeling',
    fr: 'Activités des agences de placement de main-d’œuvre',
    en: 'Activities of employment placement agencies',
    de: 'Vermittlung von Arbeitskräften',
  },
  {
    code: '7820',
    nl: 'Activiteiten van uitzendbureaus en andere diensten in verband met personeelsvoorziening',
    fr: 'Activités d’agence de travail temporaire et autre mise à disposition de ressources humaines',
    en: 'Temporary employment agency activities and other human resource provisions',
    de: 'Überlassung von Arbeitskräften und sonstige Personaldienstleistungen',
  },
  {
    code: '7911',
    nl: 'Activiteiten van reisbureaus',
    fr: 'Activités d’agence de voyage',
    en: 'Travel agency activities',
    de: 'Reisebüros',
  },
  {
    code: '7912',
    nl: 'Activiteiten van reisorganisatoren',
    fr: 'Activités de voyagiste',
    en: 'Tour operator activities',
    de: 'Reiseveranstalter',
  },
  {
    code: '7990',
    nl: 'Activiteiten van reserveringsbureaus en aanverwante activiteiten',
    fr: 'Autres activités de service de réservation et activités connexes',
    en: 'Other reservation service and related activities',
    de: 'Erbringung sonstiger Reservierungsdienstleistungen',
  },
  {
    code: '79901',
    nl: 'Activiteiten van toeristische informatiediensten',
    fr: "Services d'information touristique",
    en: 'Tourist information services',
    de: 'Touristische Informationsdienste',
  },
  {
    code: '79909',
    nl: 'Overige reserveringsactiviteiten',
    fr: 'Autres services de réservation',
    en: 'Other reservation service',
    de: 'Erbringung sonstiger Reservierungsdienstleistungen',
  },
  {
    code: '8001',
    nl: 'Opsporings- en particuliere beveiligingsdiensten',
    fr: 'Activités d’investigation et de sécurité privée',
    en: 'Investigation and private security activities',
    de: 'Private Wach- und Sicherheitsdienste sowie Detekteien',
  },
  {
    code: '8009',
    nl: 'Beveiligingsactiviteiten, n.e.g.',
    fr: 'Activités de sécurité n.c.a.',
    en: 'Security activities n.e.c.',
    de: 'Sicherheitsdienste a. n. g.',
  },
  {
    code: '8110',
    nl: 'Diverse ondersteunende activiteiten ten behoeve van voorzieningen',
    fr: 'Activités de soutien combinées pour les installations',
    en: 'Combined facilities support activities',
    de: 'Hausmeisterdienste',
  },
  {
    code: '8121',
    nl: 'Algemene reiniging van gebouwen',
    fr: 'Nettoyage courant des bâtiments',
    en: 'General cleaning of buildings',
    de: 'Allgemeine Gebäudereinigung',
  },
  {
    code: '8122',
    nl: 'Overige reiniging van gebouwen; industriële reiniging',
    fr: 'Autres activités de nettoyage des bâtiments et nettoyage industriel',
    en: 'Other building and industrial cleaning activities',
    de: 'Spezielle Reinigung von Gebäuden und Reinigung von Maschinen',
  },
  {
    code: '8123',
    nl: 'Andere reinigingsactiviteiten',
    fr: 'Autres activités de nettoyage',
    en: 'Other cleaning activities',
    de: 'Sonstige Reinigung',
  },
  {
    code: '8130',
    nl: 'Landschapsverzorging',
    fr: 'Activités de service d’aménagement paysager',
    en: 'Landscape service activities',
    de: 'Garten- und Landschaftsbau sowie Erbringung von sonstigen gärtnerischen Dienstleistungen',
  },
  {
    code: '8210',
    nl: 'Administratieve en ondersteunende activiteiten ten behoeve van kantoren',
    fr: 'Activités de service de bureau et de soutien administratif',
    en: 'Office administrative and support activities',
    de: 'Sekretariats- und Schreibdienste, Copy-Shops',
  },
  {
    code: '8220',
    nl: 'Activiteiten van callcenters',
    fr: 'Activités de centre d’appels',
    en: 'Activities of call centres',
    de: 'Call Centers',
  },
  {
    code: '8230',
    nl: 'Organisatie van congressen en beurzen',
    fr: 'Organisation de salons professionnels et congrès',
    en: 'Organisation of conventions and trade shows',
    de: 'Messe-, Kongress- und Business-Event-Veranstalter',
  },
  {
    code: '8240',
    nl: 'Bemiddelingsactiviteiten in verband met zakelijke dienstverlening, n.e.g.',
    fr: 'Activités de service d’intermédiation pour des services de soutien aux entreprises n.c.a.',
    en: 'Intermediation service activities for business support service activities n.e.c.',
    de: 'Vermittlungstätigkeiten für die Erbringung von wirtschaftlichen Dienstleistungen für Unternehmen und Privatpersonen a. n. g.',
  },
  {
    code: '8291',
    nl: 'Activiteiten van incasso- en kredietbureaus',
    fr: 'Activités d’agence de recouvrement et de bureau de crédit',
    en: 'Activities of collection agencies and credit bureaus',
    de: 'Inkassobüros und Auskunfteien',
  },
  {
    code: '8292',
    nl: 'Activiteiten van verpakkingsbedrijven',
    fr: 'Activités de conditionnement',
    en: 'Packaging activities',
    de: 'Abfüllen und Verpacken',
  },
  {
    code: '8299',
    nl: 'Overige zakelijke dienstverlening, n.e.g.',
    fr: 'Autres activités de service de soutien aux entreprises n.c.a.',
    en: 'Other business support service activities n.e.c.',
    de: 'Erbringung sonstiger wirtschaftlicher Dienstleistungen für Unternehmen und Privatpersonen a. n. g.',
  },
  {
    code: '8411',
    nl: 'Algemeen overheidsbestuur',
    fr: 'Activités d’administration publique générale',
    en: 'General public administration activities',
    de: 'Allgemeine öffentliche Verwaltung',
  },
  {
    code: '84111',
    nl: 'Federale overheid',
    fr: 'Administration publique fédérale',
    en: 'Federal public administration',
    de: 'Föderale öffentliche Verwaltung',
  },
  {
    code: '84112',
    nl: 'Overheden van gemeenschappen en gewesten',
    fr: 'Administration publique communautaire et régionale',
    en: 'Community and regional public administration',
    de: 'Gemeinschafts- und Regionalbehörden',
  },
  {
    code: '84113',
    nl: 'Provinciale overheid',
    fr: 'Administration publique provinciale',
    en: 'Provincial public administration',
    de: 'Provinzbehörden',
  },
  {
    code: '84114',
    nl: 'Gemeentelijke overheid, met uitzondering van het O.C.M.W',
    fr: "Administration publique communale, sauf Centres Publics d'Action Sociale (C.P.A.S.)",
    en: 'Municipal public administration, except social service departments',
    de: 'Gemeindeverwaltung, mit Ausnahme der öffentlichen Sozialhilfezentren (ÖSHZ)',
  },
  {
    code: '84115',
    nl: 'Openbare Centra voor Maatschappelijk Welzijn (O.C.M.W.)',
    fr: "Centres Publics d'Action Sociale (C.P.A.S.)",
    en: 'Social service departments',
    de: 'Öffentliche Sozialhilfezentren (ÖSHZ)',
  },
  {
    code: '84119',
    nl: 'Overig algemeen overheidsbestuur',
    fr: 'Autre administration publique générale',
    en: 'Other general public administration activities',
    de: 'Sonstige allgemeine öffentliche Verwaltung',
  },
  {
    code: '8412',
    nl: 'Openbaar bestuur op het gebied gezondheidszorg, onderwijs, culturele diensten en andere sociale diensten',
    fr: 'Administration des soins de santé, de l’enseignement, des services culturels et des autres services sociaux',
    en: 'Regulation of health care, education, cultural services and other social services',
    de: 'Öffentliche Verwaltung auf den Gebieten Gesundheitswesen, Bildung, Kultur und Sozialwesen',
  },
  {
    code: '8413',
    nl: 'Openbaar bestuur op het gebied van het bedrijfsleven; stimuleren van het bedrijfsleven',
    fr: 'Administration de et contribution à l’amélioration de l’efficacité des activités économiques',
    en: 'Regulation of and contribution to more efficient operation of businesses',
    de: 'Wirtschaftsförderung, -ordnung und -aufsicht',
  },
  {
    code: '8421',
    nl: 'Buitenlandse zaken',
    fr: 'Affaires étrangères',
    en: 'Foreign affairs',
    de: 'Auswärtige Angelegenheiten',
  },
  {
    code: '8422',
    nl: 'Defensie',
    fr: 'Défense',
    en: 'Defence activities',
    de: 'Verteidigung',
  },
  {
    code: '8423',
    nl: 'Justitie',
    fr: 'Justice',
    en: 'Justice and judicial activities',
    de: 'Rechtspflege/Justiz',
  },
  {
    code: '84231',
    nl: 'Rechtbanken',
    fr: 'Tribunaux',
    en: 'Courts',
    de: 'Gerichtsbehörden',
  },
  {
    code: '84232',
    nl: 'Strafinrichtingen',
    fr: 'Etablissements pénitentiaires',
    en: 'Penal institutions',
    de: 'Etablissements pénitentiaires',
  },
  {
    code: '84239',
    nl: 'Overige activiteiten met betrekking tot justitie',
    fr: 'Autres activités relatives à la justice',
    en: 'Other activities related to justice',
    de: 'Sonstige mit dem Rechtsschutz verbundene Tätigkeiten',
  },
  {
    code: '8424',
    nl: 'Openbare orde en veiligheid',
    fr: 'Activités d’ordre public et de sécurité civile',
    en: 'Public order and safety activities',
    de: 'Öffentliche Sicherheit und Ordnung',
  },
  {
    code: '84241',
    nl: 'Federale Politie',
    fr: 'Police fédérale',
    en: 'Federal police',
    de: 'Föderale Polizeï',
  },
  {
    code: '84242',
    nl: 'Lokale Politie',
    fr: 'Police locale',
    en: 'Local police',
    de: 'Lokale Polizeï',
  },
  {
    code: '84249',
    nl: 'Overige openbare orde en civiele veiligheid',
    fr: "Autres activités d'ordre public et de sécurité civile",
    en: 'Other public order and safety activities',
    de: 'Sonstige Tätigkeiten im Bereich der öffentlichen Ordnung und zivilen Sicherheit',
  },
  {
    code: '8425',
    nl: 'Brandweer',
    fr: 'Activités de service d’incendie et de secours',
    en: 'Fire service activities',
    de: 'Feuerwehren',
  },
  {
    code: '8430',
    nl: 'Verplichte sociale verzekeringen',
    fr: 'Sécurité sociale obligatoire',
    en: 'Compulsory social security activities',
    de: 'Sozialversicherung',
  },
  {
    code: '84301',
    nl: 'Verplichte sociale verzekeringen, met uitzondering van ziekenfondsen',
    fr: "Sécurité sociale obligatoire, à l'exclusion des mutuelles",
    en: 'Compulsory social security activities, except activities of mutual insurance companies',
    de: 'Sozialversicherung, ohne Krankenkassen',
  },
  {
    code: '84302',
    nl: 'Ziekenfondsen en zorgkassen',
    fr: "Mutuelles et caisses d'assurance soins",
    en: 'Mutual insurance companies and health insurance companies',
    de: 'Krankenkassen',
  },
  {
    code: '84309',
    nl: 'Overige instellingen van de sociale zekerheid',
    fr: 'Autres organismes de sécurité sociale',
    en: 'Other social security institutions',
    de: 'Andere Sozialversicherungsträger',
  },
  {
    code: '8510',
    nl: 'Kleuteronderwijs',
    fr: 'Enseignement maternel',
    en: 'Pre-primary education',
    de: 'Kindergärten und Vorschulen',
  },
  {
    code: '85101',
    nl: 'Gewoon kleuteronderwijs ingericht door de Gemeenschappen',
    fr: 'Enseignement maternel ordinaire communautaire',
    en: 'Community ordinary pre-primary education',
    de: 'Herkömmlicher von den Gemeinschaften eingerichteter Vorschulunterricht',
  },
  {
    code: '85102',
    nl: 'Provinciaal gesubsidieerd gewoon kleuteronderwijs',
    fr: 'Enseignement maternel ordinaire provincial subventionné',
    en: 'Subsidised provincial ordinary pre-primary education',
    de: 'Herkömmlicher von den Provinzen subventionierter Vorschulunterricht',
  },
  {
    code: '85103',
    nl: 'Gemeentelijk gesubsidieerd gewoon kleuteronderwijs',
    fr: 'Enseignement maternel ordinaire communal subventionné',
    en: 'Subsidised municipal ordinary pre-primary education',
    de: 'Herkömmlicher von den Gemeinden subventionierter Vorschulunterricht',
  },
  {
    code: '85104',
    nl: 'Vrij gesubsidieerd gewoon kleuteronderwijs',
    fr: 'Enseignement maternel ordinaire libre subventionné',
    en: 'Subsidised private ordinary pre-primary education',
    de: 'Herkömmlicher subventionierter freier Vorschulunterricht',
  },
  {
    code: '85105',
    nl: 'Buitengewoon officieel kleuteronderwijs',
    fr: 'Enseignement maternel spécialisé organisé par les pouvoirs publics',
    en: 'Special needs pre-primary education organised by the public authorities',
    de: 'Spezialisierter von den öffentlichen Instanzen organisierter Vorschulunterricht',
  },
  {
    code: '85106',
    nl: 'Vrij gesubsidieerd buitengewoon kleuteronderwijs',
    fr: 'Enseignement maternel spécialisé libre subventionné',
    en: 'Subsidised private special needs pre-primary education',
    de: 'Spezialisierter freier subventionierter Vorschulunterricht',
  },
  {
    code: '85109',
    nl: 'Gewoon kleuteronderwijs, n.e.g.',
    fr: 'Enseignement maternel n.c.a.',
    en: 'Pre-primary education n.e.c.',
    de: 'Vorschulunterricht a.n.g.',
  },
  {
    code: '8520',
    nl: 'Lager onderwijs',
    fr: 'Enseignement primaire',
    en: 'Primary education',
    de: 'Grundschulen/Volksschulen',
  },
  {
    code: '85201',
    nl: 'Gewoon lager onderwijs ingericht door de Gemeenschappen',
    fr: 'Enseignement primaire ordinaire communautaire',
    en: 'Community ordinary primary education',
    de: 'Herkömmlicher von den Gemeinschaften eingerichteter Grundschulunterricht',
  },
  {
    code: '85202',
    nl: 'Provinciaal gesubsidieerd gewoon lager onderwijs',
    fr: 'Enseignement primaire ordinaire provincial subventionné',
    en: 'Subsidised provincial ordinary primary education',
    de: 'Herkömmlicher von den Provinzen subventionierter Grundschulunterricht',
  },
  {
    code: '85203',
    nl: 'Gemeentelijk gesubsidieerd gewoon lager onderwijs',
    fr: 'Enseignement primaire ordinaire communal subventionné',
    en: 'Subsidised municipal ordinary primary education',
    de: 'Herkömmlicher von den Gemeinden subventionierter Grundschulunterricht',
  },
  {
    code: '85204',
    nl: 'Vrij gesubsidieerd gewoon lager onderwijs',
    fr: 'Enseignement primaire ordinaire libre subventionné',
    en: 'Subsidised private ordinary primary education',
    de: 'Herkömmlicher freier subventionierter Grundschulunterricht',
  },
  {
    code: '85205',
    nl: 'Buitengewoon officieel lager onderwijs',
    fr: 'Enseignement primaire spécialisé organisé par les pouvoirs publics',
    en: 'Special needs primary education organised by the public authorities',
    de: 'Spezialisierter von den öffentlichen Instanzen organisierter Grundschulunterricht',
  },
  {
    code: '85206',
    nl: 'Vrij gesubsidieerd buitengewoon lager onderwijs',
    fr: 'Enseignement primaire spécialisé libre subventionné',
    en: 'Subsidised private special needs primary education',
    de: 'Spezialisierter freier subventionierter Vorschulunterricht',
  },
  {
    code: '85207',
    nl: "Alfabetiseringsprogramma's ten behoeve van volwassenen",
    fr: 'Alphabétisation des adultes',
    en: 'Adult literacy programmes',
    de: 'Erwachsenenalphabetisierung',
  },
  {
    code: '85209',
    nl: 'Gewoon lager onderwijs, n.e.g',
    fr: 'Enseignement primaire ordinaire n.c.a.',
    en: 'Ordinary primary education n.e.c.',
    de: 'Herkömmlicher Grundschulunterricht a.n.g.',
  },
  {
    code: '8531',
    nl: 'Algemeen secundair onderwijs',
    fr: 'Enseignement secondaire général',
    en: 'General secondary education',
    de: 'Allgemeinbildende weiterführende Schulen',
  },
  {
    code: '85311',
    nl: 'Gewoon algemeen secundair onderwijs ingericht door de Gemeenschappen',
    fr: 'Enseignement secondaire général ordinaire communautaire',
    en: 'Community ordinary general secondary education',
    de: 'Herkömmlicher von den Gemeinschaften eingerichteter allgemeinbildender Sekundarunterricht',
  },
  {
    code: '85312',
    nl: 'Provinciaal gesubsidieerd gewoon algemeen secundair onderwijs',
    fr: 'Enseignement secondaire général ordinaire provincial subventionné',
    en: 'Subsidised provincial ordinary general secondary education',
    de: 'Herkömmlicher von den Provinzen subventionierter allgemeinbildender Sekundarunterricht',
  },
  {
    code: '85313',
    nl: 'Gemeentelijk gesubsidieerd gewoon algemeen secundair onderwijs',
    fr: 'Enseignement secondaire général ordinaire communal subventionné',
    en: 'Subsidised municipal ordinary general secondary education',
    de: 'Herkömmlicher von den Gemeinden subventionierter allgemeinbildender Sekundarunterricht',
  },
  {
    code: '85314',
    nl: 'Vrij gesubsidieerd gewoon algemeen secundair onderwijs',
    fr: 'Enseignement secondaire général ordinaire libre subventionné',
    en: 'Subsidised private ordinary general secondary education',
    de: 'Herkömmlicher freier subventionierter allgemeinbildender Sekundarunterricht',
  },
  {
    code: '85319',
    nl: 'Gewoon algemeen secundair onderwijs, n.e.g.',
    fr: 'Enseignement secondaire ordinaire général n.c.a.',
    en: 'Ordinary general secondary education n.e.c.',
    de: 'Herkömmlicher allgemeinbildender Sekundarunterricht a.n.g.',
  },
  {
    code: '8532',
    nl: 'Technisch, beroeps- en buitengewoon secundair onderwijs',
    fr: 'Enseignement secondaire technique, professionnel et spécialisé',
    en: 'Vocational secondary education',
    de: 'Berufsbildende weiterführende Schulen',
  },
  {
    code: '85321',
    nl: 'Gewoon technisch en beroepssecundair onderwijs ingericht door de Gemeenschappen',
    fr: 'Enseignement secondaire technique et professionnel ordinaire communautaire',
    en: 'Community ordinary technical and vocational secondary education',
    de: 'Herkömmlicher von den Gemeinschaften eingerichteter technischer und berufsbildender Sekundarunterricht',
  },
  {
    code: '85322',
    nl: 'Provinciaal gesubsidieerd gewoon technisch en beroepssecundair onderwijs',
    fr: 'Enseignement secondaire technique et professionnel ordinaire provincial subventionné',
    en: 'Subsidised provincial ordinary technical and vocational secondary education',
    de: 'Herkömmlicher von den Provinzen subventionierter technischer und berufsbildender Sekundarunterricht',
  },
  {
    code: '85323',
    nl: 'Gemeentelijk gesubsidieerd gewoon technisch en beroepssecundair onderwijs',
    fr: 'Enseignement secondaire technique et professionnel ordinaire communal subventionné',
    en: 'Subsidised municipal ordinary technical and vocational secondary education',
    de: 'Herkömmlicher von den Gemeinden subventionierter technischer und berufsbildender Sekundarunterricht',
  },
  {
    code: '85324',
    nl: 'Vrij gesubsidieerd gewoon technisch en beroepssecundair onderwijs',
    fr: 'Enseignement secondaire technique et professionnel ordinaire libre subventionné',
    en: 'Subsidised private ordinary technical and vocational secondary education',
    de: 'Herkömmlicher freier subventionierter technischer und berufsbildender Sekundarunterricht',
  },
  {
    code: '85325',
    nl: 'Buitengewoon officieel secundair onderwijs',
    fr: 'Enseignement secondaire spécialisé organisé par les pouvoirs publics',
    en: 'Special needs secondary education organised by the public authorities',
    de: 'Spezialisierter von den öffentlichen Instanzen organisierter Sekundarunterricht',
  },
  {
    code: '85326',
    nl: 'Vrij gesubsidieerd buitengewoon secundair onderwijs',
    fr: 'Enseignement secondaire spécialisé libre subventionné',
    en: 'Subsidised private special needs secondary education',
    de: 'Spezialisierter freier subventionierter Sekundarunterricht',
  },
  {
    code: '85329',
    nl: 'Technisch, beroeps- en buitengewoon secundair onderwijs, n.e.g.',
    fr: 'Enseignement secondaire technique, professionnel et spécialisé n.c.a.',
    en: 'Technical, vocational and special needs secondary education n.e.c.',
    de: 'Technischer, berufsbildender und spezialisierter Sekundarunterricht a.n.g.',
  },
  {
    code: '8533',
    nl: 'Postsecundair niet-hoger onderwijs',
    fr: 'Enseignement post-secondaire non supérieur',
    en: 'Post-secondary non-tertiary education',
    de: 'Postsekundärer, nicht tertiärer Unterricht',
  },
  {
    code: '8540',
    nl: 'Hoger onderwijs',
    fr: 'Enseignement supérieur',
    en: 'Tertiary education',
    de: 'Tertiärer Unterricht',
  },
  {
    code: '85401',
    nl: 'Officieel hoger onderwijs',
    fr: 'Enseignement supérieur organisé par les pouvoirs publics',
    en: 'Higher education organised by the public authorities',
    de: 'Von den öffentlichen Instanzen organisierter Hochschulunterricht',
  },
  {
    code: '85402',
    nl: 'Vrij gesubsidieerd hoger onderwijs',
    fr: 'Enseignement supérieur libre subventionné',
    en: 'Subsidised private higher education',
    de: 'Freie subventionierte Hochschulen',
  },
  {
    code: '85409',
    nl: 'Hoger onderwijs, n.e.g.',
    fr: 'Enseignement supérieur n.c.a.',
    en: 'Higher education n.e.c.',
    de: 'Hochschulunterricht a.n.g.',
  },
  {
    code: '8551',
    nl: 'Sport- en recreatieonderwijs',
    fr: 'Enseignement de disciplines sportives et d’activités de loisirs',
    en: 'Sports and recreation education',
    de: 'Sport- und Freizeitunterricht',
  },
  {
    code: '8552',
    nl: 'Cultureel onderwijs',
    fr: 'Enseignement culturel',
    en: 'Cultural education',
    de: 'Kulturunterricht',
  },
  {
    code: '8553',
    nl: 'Activiteiten van auto- en motorrijscholen, vlieg- en vaaronderricht',
    fr: "Enseignement de la conduite de véhicules à moteurs, d'aéronefs et de bateaux",
    en: 'Driving school activities',
    de: 'Fahr- und Flugschulen',
  },
  {
    code: '85531',
    nl: 'Activiteiten van auto- en motorrijscholen',
    fr: 'Enseignement de la conduite de véhicules à moteurs',
    en: 'Motor vehicle driving lessons',
    de: 'Fahr- und Flugschulen',
  },
  {
    code: '85532',
    nl: 'Vlieg- en vaaronderricht',
    fr: "Enseignement de la conduite d'aéronefs et de bateaux",
    en: 'Aircraft and boat driving lessons',
    de: 'Flug- und Schiffahrtsschulen',
  },
  {
    code: '8559',
    nl: 'Overig onderwijs, n.e.g.',
    fr: 'Autre enseignement n.c.a.',
    en: 'Other education n.e.c.',
    de: 'Sonstiger Unterricht a. n. g.',
  },
  {
    code: '85591',
    nl: 'Onderwijs voor sociale promotie',
    fr: 'Enseignement de promotion sociale',
    en: 'Social advancement education',
    de: 'Sozialförderungsunterricht',
  },
  {
    code: '85592',
    nl: 'Beroepsopleiding',
    fr: 'Formation professionnelle',
    en: 'Vocational training',
    de: 'Berufsbildung',
  },
  {
    code: '85593',
    nl: 'Sociaal-cultureel vormingswerk',
    fr: 'Formation socio-culturelle',
    en: 'Socio-cultural training',
    de: 'Soziokulturelle Bildung',
  },
  {
    code: '85599',
    nl: 'Overige vormen van onderwijs',
    fr: "Autres formes d'enseignement",
    en: 'Other forms of education',
    de: 'Andere Ausbildungsformen',
  },
  {
    code: '8561',
    nl: 'Bemiddeling op het gebied van academische ondersteuning en studiebegeleiding',
    fr: 'Activités de service d’intermédiation dans le domaine de l’appui scolaire et du tutorat',
    en: 'Intermediation service activities for courses and tutors',
    de: 'Vermittlungstätigkeiten für Erziehung und Unterricht',
  },
  {
    code: '8569',
    nl: 'Onderwijsondersteunende activiteiten, n.e.g.',
    fr: 'Activités de soutien à l’enseignement n.c.a.',
    en: 'Educational support activities n.e.c.',
    de: 'Erbringung von Dienstleistungen für Erziehung und Unterricht a. n. g.',
  },
  {
    code: '85691',
    nl: 'Activiteiten van Centra voor Leerlingbegeleiding (C.L.B.)',
    fr: 'Activités des Centres Psycho-Médico-Sociaux (P.M.S.)',
    en: 'Activities of Centres for Pupil Guidance (C.L.B.)',
    de: 'Tätigkeiten der psycho-medizinisch-sozialen Zentren (P.M.S.)',
  },
  {
    code: '85699',
    nl: 'Overige onderwijsondersteunende dienstverlening',
    fr: "Autres services de soutien à l'enseignement",
    en: 'Other educational support services',
    de: 'Sonstige unterrichtsunterstützende Dienstleistungen',
  },
  {
    code: '8610',
    nl: 'Activiteiten van ziekenhuizen',
    fr: 'Activités hospitalières',
    en: 'Hospital activities',
    de: 'Krankenhäuser',
  },
  {
    code: '86101',
    nl: 'Activiteiten van algemene ziekenhuizen, m.u.v. geriatrische en gespecialiseerde ziekenhuizen',
    fr: 'Activités des hôpitaux généraux, sauf hôpitaux gériatriques et spécialisés',
    en: 'Activities of general hospitals, except geriatric and specialised hospitals',
    de: 'Allgemeine Krankenhäuser, mit Ausnahme von geriatrischen und spezialisierten Krankenhäusern',
  },
  {
    code: '86102',
    nl: 'Activiteiten van geriatrische ziekenhuizen',
    fr: 'Activités des hôpitaux gériatriques',
    en: 'Activities of geriatric hospitals',
    de: 'Tätigkeiten von geriatrischen Krankenhäusern',
  },
  {
    code: '86103',
    nl: 'Activiteiten van gespecialiseerde ziekenhuizen',
    fr: 'Activités des hôpitaux spécialisés',
    en: 'Activities of specialised hospitals',
    de: 'Tätigkeiten von spezialisierten Krankenhäusern',
  },
  {
    code: '86104',
    nl: 'Activiteiten van psychiatrische ziekenhuizen',
    fr: 'Activités des hôpitaux psychiatriques',
    en: 'Activities of psychiatric hospitals',
    de: 'Tätigkeiten von psychiatrischen Krankenhäusern',
  },
  {
    code: '86109',
    nl: 'Overige hospitalisatiediensten',
    fr: 'Autres activités hospitalières',
    en: 'Other hospital activities',
    de: 'Sonstige Krankenhaustätigkeiten',
  },
  {
    code: '8621',
    nl: 'Activiteiten van huisartspraktijken',
    fr: 'Activités de médecine générale',
    en: 'General medical practice activities',
    de: 'Arztpraxen für Allgemeinmedizin',
  },
  {
    code: '8622',
    nl: 'Activiteiten van medisch specialisten',
    fr: 'Activités de médecine spécialisée',
    en: 'Medical specialists activities',
    de: 'Facharztpraxen',
  },
  {
    code: '8623',
    nl: 'Activiteiten van tandartspraktijken',
    fr: 'Activités de soins dentaires',
    en: 'Dental practice care activities',
    de: 'Zahnarztpraxen',
  },
  {
    code: '8691',
    nl: 'Activiteiten van medische beeldvorming en medische laboratoria',
    fr: 'Activités d’imagerie médicale et de laboratoire d’analyse médicale',
    en: 'Diagnostic imaging services and medical laboratory activities',
    de: 'Erbringung von Dienstleistungen der diagnostischen Bildgebung sowie von medizinischen Laboratorien',
  },
  {
    code: '8692',
    nl: 'Patiëntenvervoer per ambulance',
    fr: 'Transport de patients par ambulance',
    en: 'Patient transportation by ambulance',
    de: 'Rettungs- und Krankentransportdienste',
  },
  {
    code: '8693',
    nl: 'Activiteiten van psychologen en psychotherapeuten, met uitzondering van artsen',
    fr: 'Activités des psychologues et psychothérapeutes, à l’exception des médecins',
    en: 'Activities of psychologists and psychotherapists, except medical doctors',
    de: 'Erbringung von Dienstleistungen von Psychotherapeutinnen und -therapeuten, klinischen und Gesundheitspsychologinnen und -psychologen, ohne ärztliche Therapien',
  },
  {
    code: '86931',
    nl: 'Activiteiten op het gebied van psychologie',
    fr: 'Activités de psychologie',
    en: 'Activities of psychologists',
    de: 'Erbringung von psychologischen Dienstleistungen',
  },
  {
    code: '86932',
    nl: 'Activiteiten op het gebied van psychotherapie',
    fr: 'Activités de psychothérapie',
    en: 'Activities of psychotherapists',
    de: 'Erbringung von psychotherapeutischen Dienstleistungen',
  },
  {
    code: '86933',
    nl: 'Activiteiten van centra voor geestelijke gezondheidszorg',
    fr: 'Activités des centres de santé mentale',
    en: 'Activities of mental health centres',
    de: 'Tätigkeiten im Bereich der Zentren für geistige Gesundheitspflege',
  },
  {
    code: '86939',
    nl: 'Andere activiteiten op het gebied van de geestelijke gezondheidszorg',
    fr: 'Autres activités de soins de santé mentale',
    en: 'Other mental health care activities',
    de: 'Sonstige Tätigkeiten im Bereich der geistigen Gesundheit',
  },
  {
    code: '8694',
    nl: 'Activiteiten van verpleegkundigen en verloskundigen',
    fr: 'Activités de soins infirmiers et de maïeutique',
    en: 'Nursing and midwifery activities',
    de: 'Krankenpflege, Geburtshilfe und Hebammen',
  },
  {
    code: '8695',
    nl: 'Activiteiten op het gebied van fysiotherapie',
    fr: 'Activités de physiothérapie',
    en: 'Physiotherapy activities',
    de: 'Erbringung von physiotherapeutischen Dienstleistungen',
  },
  {
    code: '86951',
    nl: 'Activiteiten op het gebied van kinesitherapie',
    fr: 'Activités de kinésithérapie',
    en: 'Physical therapy activities',
    de: 'Erbringung von kinesiotherapeutischen Dienstleistungen',
  },
  {
    code: '86952',
    nl: 'Activiteiten op het gebied van ergotherapie',
    fr: "Activités d'ergothérapie",
    en: 'Occupational therapy activities',
    de: 'Erbringung von ergotherapeutischen Dienstleistungen',
  },
  {
    code: '86959',
    nl: 'Andere ambulante revalidatieactiviteiten',
    fr: 'Autres activités de revalidation ambulatoire',
    en: 'Other outpatient rehabilitation activities',
    de: 'Sonstige ambulante Rehabilitationstätigkeiten',
  },
  {
    code: '8696',
    nl: 'Traditionele, aanvullende en alternatieve geneeskunde',
    fr: 'Activités de médecine traditionnelle, complémentaire et alternative',
    en: 'Traditional, complementary and alternative medicine activities',
    de: 'Traditionelle, komplementäre und alternative medizinische Tätigkeiten',
  },
  {
    code: '86961',
    nl: 'Niet-conventionele therapeutische diensten',
    fr: 'Services thérapeutiques non conventionnels',
    en: 'Unconventional therapeutic services',
    de: 'Erbringung von nicht-konventionellen therapeutischen Dienstleistungen',
  },
  {
    code: '86962',
    nl: 'Activiteiten op het gebied van chiropraxie',
    fr: 'Activités de chiropractie',
    en: 'Chiropractic activities',
    de: 'Erbringung von chiropraktischen Dienstleistungen',
  },
  {
    code: '86963',
    nl: 'Activiteiten op het gebied van osteopathie',
    fr: "Activités d'ostéopathie",
    en: 'Osteopathy activities',
    de: 'Erbringung von osteopathischen Dienstleistungen',
  },
  {
    code: '86964',
    nl: 'Activiteiten op het gebied van homeopathie',
    fr: "Activités d'homéopathie",
    en: 'Homeopathy activities',
    de: 'Erbringung von homeopathischen Dienstleistungen',
  },
  {
    code: '86965',
    nl: 'Activiteiten op het gebied van acupunctuur',
    fr: "Activités d'acupuncture",
    en: 'Acupuncture activities',
    de: 'Erbringung von Dienstleistungen im Bereich der Akupunktur',
  },
  {
    code: '8697',
    nl: 'Bemiddelingsactiviteiten in verband met geneeskundige, tandheelkundige en andere diensten in verband met de menselijke gezondheid',
    fr: 'Activités de service d’intermédiation pour les services médicaux, dentaires et autres services pour la santé humaine',
    en: 'Intermediation service activities for medical, dental and other human health services',
    de: 'Vermittlungstätigkeiten für medizinische, zahnärztliche und andere Gesundheitstätigkeiten',
  },
  {
    code: '8699',
    nl: 'Overige menselijke gezondheidszorg, n.e.g.',
    fr: 'Autres activités pour la santé humaine n.c.a.',
    en: 'Other human health activities n.e.c.',
    de: 'Sonstiges Gesundheitswesen a. n. g.',
  },
  {
    code: '86991',
    nl: 'Activiteiten op het gebied van mondzorg, m.u.v. activiteiten van tandartspraktijken',
    fr: "Activités de soins buccaux, à l'exception des activités de soins dentaires",
    en: 'Mouth care activities, except dental care activities',
    de: 'Erbringung von Dienstleistungen im Bereich der Mundpflege, mit Ausnahme von Zahnarztpraxen',
  },
  {
    code: '86992',
    nl: 'Activiteiten van bloedtransfusiecentra, bloedbanken, spermabanken, organenbanken en dergelijke',
    fr: "Activités des centres de collecte de sang, des banques de sang, des banques de sperme, des banques d'organes et des établissements similaires",
    en: 'Activities of blood collection centres, blood banks, sperm banks, transplant organ banks and similar establishments',
    de: 'Bluttransfusionszentren, Blutbanken, Samendepots, Organbanken u. Ä.',
  },
  {
    code: '86993',
    nl: 'Activiteiten op het gebied van oogzorg',
    fr: 'Activités de soins oculaires',
    en: 'Eye care activities',
    de: 'Erbringung von Dienstleistungen im Bereich der Augenpflege',
  },
  {
    code: '86994',
    nl: 'Activiteiten op het gebied van voetzorg en -problematiek',
    fr: 'Activités dans le domaine des soins et de la problématique du pied',
    en: 'Activities in the field of foot care and foot problems',
    de: 'Erbringung von Dienstleistungen im Bereich der Fußpflege und Fußprobleme',
  },
  {
    code: '86995',
    nl: 'Activiteiten op het gebied van voeding',
    fr: 'Activités dans le domaine de l’alimentation',
    en: 'Activities in the field of nutrition',
    de: 'Erbringung von Dienstleistungen im Bereich der Nahrung',
  },
  {
    code: '86996',
    nl: 'Activiteiten op het gebied van logopedie',
    fr: 'Activités de logopédie',
    en: 'Activities in the field of logopedics',
    de: 'Erbringung von logopädischen Dienstleistungen',
  },
  {
    code: '86997',
    nl: 'Activiteiten van shiatsu, thai massage , watsu, tuina qigong',
    fr: 'Activités de shiatsu, massage thaïlandais, watsu, qigong tuina',
    en: 'Shiatsu, Thai massage, watsu, tuina qigong activities',
    de: 'Shiatsu, Thai-Massage, Watsu, Tuina Qigong',
  },
  {
    code: '86999',
    nl: 'Overige activiteiten op het gebied van menselijke gezondheidszorg, n.e.g.',
    fr: 'Autres activités dans le domaine de la santé humaine n.c.a.',
    en: 'Other activities in the field of human health n.e.c.',
    de: 'Sonstige Tätigkeiten im Bereich Gesundheitswesen a.n.g.',
  },
  {
    code: '8710',
    nl: 'Activiteiten van verpleegtehuizen',
    fr: "Activités d'hébergement médicalisé",
    en: 'Residential nursing care activities',
    de: 'Pflegeheime',
  },
  {
    code: '87101',
    nl: 'Rust- en verzorgingstehuizen (R.V.T.)',
    fr: 'Maisons de repos et de soins (M.R.S.)',
    en: 'Nursing homes',
    de: 'Tätigkeiten von Alten- und Pflegeheimen',
  },
  {
    code: '87109',
    nl: 'Overige verpleeginstellingen met huisvesting',
    fr: "Autres activités d'hébergement médicalisé",
    en: 'Other residential nursing care activities',
    de: 'Sonstige stationäre Pflegeeinrichtungen',
  },
  {
    code: '8720',
    nl: 'Residentiële zorg voor personen met een al dan niet gediagnosticeerde psychische aandoening of voor drugs- of alcoholverslaafden',
    fr: "Activités d'hébergement social pour personnes souffrant de maladie mentale ou de toxicomanie",
    en: 'Residential care activities for persons living with or having a diagnosis of a mental illness or substance abuse',
    de: 'Stationäre Einrichtungen zur psychosozialen Betreuung, Suchtbekämpfung',
  },
  {
    code: '87201',
    nl: 'Instellingen met huisvesting voor minderjarigen met een mentale handicap',
    fr: 'Activités de soins résidentiels pour mineurs avec un handicap mental',
    en: 'Residential care activities for minors with mental disabilities',
    de: 'Stationäre Einrichtungen zur Betreuung geistig behinderter Minderjähriger',
  },
  {
    code: '87202',
    nl: 'Instellingen met huisvesting voor volwassenen met een mentale handicap',
    fr: 'Activités de soins résidentiels pour adultes avec un handicap mental',
    en: 'Residential care activities for adults with mental disabilities',
    de: 'Stationäre Einrichtungen zur Betreuung geistig behinderter Erwachsener',
  },
  {
    code: '87203',
    nl: 'Instellingen met huisvesting voor personen met psychiatrische problemen',
    fr: 'Activités de soins résidentiels pour personnes avec un problème psychiatrique',
    en: 'Residential care activities for persons with psychiatric disabilities',
    de: 'Stationäre Einrichtungen zur Betreuung von Personen mit psychiatrischen Problemen',
  },
  {
    code: '87204',
    nl: 'Instellingen met huisvesting voor drugs- en alcoholverslaafden',
    fr: 'Activités de soins résidentiels pour personnes toxicodépendantes et alcolodépendantes',
    en: 'Residential care activities for drug and alcohol dependent persons',
    de: 'Stationäre Einrichtungen zur Betreuung von Drogen- und Alkoholsüchtigen',
  },
  {
    code: '87205',
    nl: 'Activiteiten van beschut wonen voor personen met psychiatrische problemen',
    fr: 'Activités des habitations protégées pour personnes avec un problème psychiatrique',
    en: 'Activities of assisted living for persons with psychiatric disabilities',
    de: 'Tätigkeiten im Bereich des beschützten Wohnens für Personen mit psychiatrischen Problemen',
  },
  {
    code: '87209',
    nl: 'Andere instellingen met huisvesting voor personen met een mentale handicap of psychiatrische problemen en voor drugs- en alcoholverslaafden',
    fr: 'Autres activités de soins résidentiels pour personnes avec un handicap mental, un problème psychiatrique, toxicodépendantes ou alcolodépendantes',
    en: 'Other residential care activities for persons with mental disabilities, persons with psychiatric disabilities, drug and alcohol dependent p',
    de: 'Sonstige stationäre Einrichtungen zur Betreuung von Personen mit einer geistigen Behinderung oder psychiatrischen Problemen und von Drogen- und Alkoholabhängigen',
  },
  {
    code: '8730',
    nl: 'Residentiële zorg voor ouderen of personen met een lichamelijke handicap',
    fr: "Activités d'hébergement social pour personnes âgées ou en situation de handicap physique",
    en: 'Residential care activities for older persons or persons with physical disabilities',
    de: 'Seniorenwohnheime und Wohnheime für Menschen mit Behinderung',
  },
  {
    code: '87301',
    nl: 'Rusthuizen voor ouderen (R.O.B.)',
    fr: 'Activités des maisons de repos pour personnes âgées (M.R.P.A.)',
    en: 'Activities of rest homes for older persons',
    de: 'Tätigkeiten von Altenheimen',
  },
  {
    code: '87302',
    nl: 'Serviceflats voor ouderen',
    fr: 'Activités des résidences services pour personnes âgées',
    en: 'Activities of service flats for older persons',
    de: 'Tätigkeiten von Pflegeresidenzen für ältere Menschen',
  },
  {
    code: '87303',
    nl: 'Instellingen met huisvesting voor minderjarigen met een lichamelijke handicap',
    fr: 'Activités de soins résidentiels pour mineurs avec un handicap moteur',
    en: 'Residential care activities for minors with physical disabilities',
    de: 'Stationäre Einrichtungen zur Betreuung Minderjähriger mit körperlicher Behinderung',
  },
  {
    code: '87304',
    nl: 'Instellingen met huisvesting voor volwassenen met een lichamelijke handicap',
    fr: 'Activités de soins résidentiels pour adultes avec un handicap moteur',
    en: 'Residential care activities for adults with physical disabilities',
    de: 'Stationäre Einrichtungen zur Betreuung Erwachsener mit körperlicher Behinderung',
  },
  {
    code: '87309',
    nl: 'Instellingen met huisvesting voor ouderen en voor personen met een lichamelijke handicap, n.e.g.',
    fr: 'Autres activités de soins résidentiels pour personnes âgées ou avec un handicap moteur',
    en: 'Other residential care activities for older persons or persons with physical disabilities',
    de: 'Stationäre Einrichtungen zur Betreuung älterer Menschen und körperlich Behinderter',
  },
  {
    code: '8791',
    nl: 'Bemiddelingsactiviteiten in verband met residentiële zorg',
    fr: 'Activités de service d’intermédiation pour des activités de soins en établissement résidentiel',
    en: 'Intermediation service activities for residential care activities',
    de: 'Vermittlungstätigkeiten für Heime und stationäre Betreuung',
  },
  {
    code: '8799',
    nl: 'Overige activiteiten op het gebied van verpleging, verzorging en begeleiding met overnachting, n.e.g.',
    fr: "Autres activités d'hébergement social n.c.a.",
    en: 'Other residential care activities n.e.c.',
    de: 'Sonstige Heime, ohne Erholungs- und Ferienheime, a. n. g.',
  },
  {
    code: '87991',
    nl: 'Integrale jeugdhulp met huisvesting',
    fr: "Services d'aide à la jeunesse avec hébergement",
    en: 'Youth care activities with accommodation',
    de: 'Jugendhilfsdienste mit Unterbringung',
  },
  {
    code: '87992',
    nl: 'Algemeen welzijnswerk met huisvesting',
    fr: 'Services sociaux généraux avec hébergement',
    en: 'General social work activities with accommodation',
    de: 'Allgemeine Sozialdienste mit Unterbringung',
  },
  {
    code: '87999',
    nl: 'Overige maatschappelijke dienstverlening met huisvesting, n.e.g.',
    fr: 'Autres activités de soins résidentiels n.c.a.',
    en: 'Other miscellaneous residential care activities n.e.c.',
    de: 'Sonstige Heime (ohne Fremden-, Erholungs- und Ferienheime) a.n.g.',
  },
  {
    code: '8810',
    nl: 'Maatschappelijke dienstverlening zonder huisvesting voor ouderen of personen met een handicap',
    fr: 'Activités d’action sociale sans hébergement pour personnes âgées ou en situation de handicap',
    en: 'Social work activities without accommodation for older persons or persons with disabilities',
    de: 'Soziale Betreuung von älteren Menschen und von Menschen mit Behinderung',
  },
  {
    code: '88101',
    nl: 'Activiteiten van bejaardenzorg aan huis, m.u.v. (thuis)verpleging',
    fr: 'Activités de soins à domicile aux personnes âgées, sauf soins infirmiers (à domicile)',
    en: 'Home care activities for older persons, except nursing care (at home)',
    de: 'Tätigkeiten der Betreuung von älteren Menschen, mit Ausnahme von  häuslicher Pflege',
  },
  {
    code: '88102',
    nl: 'Activiteiten van dag- en dienstencentra voor ouderen',
    fr: 'Activités des centres de jour et de services pour personnes âgées',
    en: 'Activities of day and service centres for older persons',
    de: 'Tätigkeiten der Tages- und Betreuungszentren für ältere Menschen',
  },
  {
    code: '88103',
    nl: 'Activiteiten van dagcentra voor minderjarigen met een lichamelijke handicap, met inbegrip van ambulante hulpverlening',
    fr: 'Activités des centres de jour pour mineurs avec un handicap moteur, y compris les services ambulatoires',
    en: 'Activities of day centres for minors with physical disabilities, including outpatient services',
    de: 'Tätigkeiten der Tageszentren für Minderjährige mit körperlicher Behinderung, einschließliche ambulanter Hilfsleistungen',
  },
  {
    code: '88104',
    nl: 'Activiteiten van dagcentra voor volwassenen met een lichamelijke handicap, met inbegrip van ambulante hulpverlening',
    fr: 'Activités des centres de jour pour adultes avec un handicap moteur, y compris les services ambulatoires',
    en: 'Activities of day centres for adults with physical disabilities, including outpatient services',
    de: 'Tätigkeiten der Tageszentren für Erwachsene mit körperlicher Behinderung, einschließliche ambulanter Hilfsleistungen',
  },
  {
    code: '88105',
    nl: 'Activiteiten van dagcentra voor minderjarigen met een mentale handicap, met inbegrip van ambulante hulpverlening',
    fr: 'Activités des centres de jour pour mineurs avec un handicap mental, y compris les services ambulatoires',
    en: 'Activities of day centres for minors with mental disabilities, including outpatient services',
    de: 'Tätigkeiten der Tageszentren für Minderjährige mit geistiger Behinderung, einschließliche ambulanter Hilfsleistungen',
  },
  {
    code: '88106',
    nl: 'Activiteiten van dagcentra voor volwassenen met een mentale handicap, met inbegrip van ambulante hulpverlening',
    fr: 'Activités des centres de jour pour adultes avec un handicap mental, y compris les services ambulatoires',
    en: 'Activities of day centres for adults with mental disabilities, including outpatient services',
    de: 'Tätigkeiten der Tageszentren für Erwachsene mit geistiger Behinderung, einschließliche ambulanter Hilfsleistungen',
  },
  {
    code: '88109',
    nl: 'Overige maatschappelijke dienstverlening zonder huisvesting voor ouderen of personen met een handicap',
    fr: 'Autre action sociale sans hébergement pour personnes âgées ou en situation de handicap',
    en: 'Other social work activities without accommodation for older persons or persons with disabilities',
    de: 'Sonstige soziale Dienstleistungen ohne Unterbringung für ältere Menschen und Behinderte',
  },
  {
    code: '8891',
    nl: 'Activiteiten met betrekking tot kinderopvang',
    fr: 'Activités de garde d’enfants',
    en: 'Child day-care activities',
    de: 'Tagesbetreuung von Kindern',
  },
  {
    code: '88911',
    nl: 'Kinderdagverblijven en crèches',
    fr: "Activités des crèches et des garderies d'enfants",
    en: 'Child day-care and nursery activities',
    de: 'Tätigkeiten von Kinderkrippen und Kindertagesstätten',
  },
  {
    code: '88912',
    nl: 'Kinderopvang door onthaalouders',
    fr: "Activités des gardiennes d'enfants",
    en: 'Activities of child-minders',
    de: 'Tätigkeiten von Tageseltern',
  },
  {
    code: '88919',
    nl: 'Overige activiteiten met betrekking tot kinderopvang',
    fr: 'Autres activités de garde d’enfants',
    en: 'Other child day-care activities',
    de: 'Sonstige Kinderbetreuung',
  },
  {
    code: '8899',
    nl: 'Overige maatschappelijke dienstverlening zonder huisvesting, n.e.g.',
    fr: "Autres activités d'action sociale sans hébergement n.c.a",
    en: 'Other social work activities without accommodation n.e.c.',
    de: 'Sonstiges Sozialwesen a. n. g.',
  },
  {
    code: '88991',
    nl: 'Ambulante hulpverlening aan drugs- en alcoholverslaafden',
    fr: 'Action sociale ambulatoire pour personnes toxicodépendantes et alcolodépendantes',
    en: 'Outpatient social work activities for drug and alcohol dependent persons',
    de: 'Ambulante Hilfe für Drogen- und Akoholabhängige',
  },
  {
    code: '88992',
    nl: 'Integrale jeugdhulp zonder huisvesting',
    fr: "Services d'aide à la jeunesse sans hébergement",
    en: 'Youth care activities without accommodation',
    de: 'Jugendhilfsdienste ohne Unterbringung',
  },
  {
    code: '88993',
    nl: 'Beschutte en sociale werkplaatsen',
    fr: 'Activités des entreprises de travail adapté',
    en: 'Activities of sheltered and social workshops',
    de: 'Tätigkeiten von geschützten und sozialen Werkstätten',
  },
  {
    code: '88994',
    nl: 'Algemeen welzijnswerk zonder huisvesting',
    fr: 'Services sociaux généraux sans hébergement',
    en: 'General social work activities without accommodation',
    de: 'Allgemeine Sozialdienste ohne Unterbringung',
  },
  {
    code: '88999',
    nl: 'Andere vormen van maatschappelijke dienstverlening zonder huisvesting, n.e.g.',
    fr: "Autres formes d'action sociale sans hébergement n.c.a.",
    en: 'Other miscellaneous social work activities without accommodation n.e.c.',
    de: 'Sonstige Arten sozialer Dienstleistungen ohne Unterbringung a.n.g.',
  },
  {
    code: '9011',
    nl: 'Literaire creatie en compositie van muziek',
    fr: 'Activités de création littéraire et de composition musicale',
    en: 'Literary creation and musical composition activities',
    de: 'Literarisches Schaffen und Musikkomposition',
  },
  {
    code: '90111',
    nl: 'Literaire creatie',
    fr: 'Activités de création littéraire',
    en: 'Literary creation activities',
    de: 'Literarisches Schaffen',
  },
  {
    code: '90112',
    nl: 'Compositie van muziek',
    fr: 'Activités de composition musicale',
    en: 'Musical composition activities',
    de: 'Musikkomposition',
  },
  {
    code: '9012',
    nl: 'Creatie van beeldende kunsten',
    fr: 'Activités de création en arts visuels',
    en: 'Visual arts creation activities',
    de: 'Bildende Kunst',
  },
  {
    code: '9013',
    nl: 'Andere vormen van creatie van kunst',
    fr: 'Autres activités de création artistique',
    en: 'Other arts creation activities',
    de: 'Sonstige kunstschaffende Tätigkeiten',
  },
  {
    code: '9020',
    nl: 'Verrichten van uitvoerende kunst',
    fr: 'Activités de spectacle',
    en: 'Activities of performing arts',
    de: 'Darstellende Kunst',
  },
  {
    code: '90201',
    nl: 'Beoefening van uitvoerende kunsten door zelfstandig werkende artiesten',
    fr: 'Réalisation de spectacles par des artistes indépendants',
    en: 'Activities of performing arts by self-employed artists',
    de: 'Darbietungen von selbständig arbeitenden Künstlern im Bereich der darstellenden Kunst',
  },
  {
    code: '90202',
    nl: 'Beoefening van uitvoerende kunsten door artistieke ensembles',
    fr: 'Réalisation de spectacles par des ensembles artistiques',
    en: 'Activities of performing arts by artistic troupes',
    de: 'Darbietungen von Künstlergruppen im Bereich der darstellenden Kunst',
  },
  {
    code: '9031',
    nl: 'Exploitatie van kunstfaciliteiten en -locaties',
    fr: 'Gestion de lieux d’exposition artistique et de salles de spectacles',
    en: 'Operation of arts facilities and sites',
    de: 'Betrieb von Einrichtungen für kunstschaffende und darstellende Künste',
  },
  {
    code: '90311',
    nl: 'Exploitatie van schouwburgen, concertzalen en dergelijke',
    fr: 'Gestion de salles de théâtre, de concerts et similaires',
    en: 'Operation of concert and theatre halls and similar facilities',
    de: 'Betrieb von Schauspielhäusern, Konzerthallen u.ä.',
  },
  {
    code: '90312',
    nl: 'Exploitatie van culturele centra en multifunctionele zalen ten behoeve van culturele activiteiten',
    fr: 'Gestion de centres culturels et de salles multifonctionnelles à vocation culturelle',
    en: 'Operation of cultural centres and multi-purpose halls for cultural activities',
    de: 'Betrieb von Kulturzentren und Multifunktionssälen',
  },
  {
    code: '9039',
    nl: 'Andere ondersteunende activiteiten voor scheppende en uitvoerende kunst',
    fr: 'Autres activités de soutien à la création artistique et aux spectacles',
    en: 'Other support activities to arts and performing arts',
    de: 'Erbringung von sonstigen Dienstleistungen für kunstschaffende und darstellende Künste',
  },
  {
    code: '90391',
    nl: 'Promotie en organisatie van scheppende en uitvoerende kunstevenementen',
    fr: 'Promotion et organisation de créations artistiques et de spectacles',
    en: 'Promotion and organisation of artistic creations and live performances',
    de: 'Förderung und Organisation von Veranstaltungen im Bereich der kunstschaffende und darstellende Künste',
  },
  {
    code: '90392',
    nl: 'Ontwerp en bouw van podia en decors',
    fr: 'Conception et réalisation de scènes et de décors',
    en: 'Design and buidling of stage-set and scene',
    de: 'Kulissenentwurf und -bau',
  },
  {
    code: '90393',
    nl: 'Gespecialiseerde beeld-, verlichtings- en geluidstechnieken',
    fr: "Services spécialisés du son, de l'image et de l'éclairage",
    en: 'Specialised services for sound, image and light',
    de: 'Spezialisierte Bild-, Beleuchtungs- und Tontechniken',
  },
  {
    code: '90399',
    nl: 'Andere ondersteunende activiteiten voor scheppende en uitvoerende kunst, n.e.g.',
    fr: 'Autres activités de soutien à la création artistique et aux spectacles, n.c.a.',
    en: 'Other support activities to arts and performing arts, n.e.c.',
    de: 'Erbringung von sonstigen Dienstleistungen für kunstschaffende und darstellende Künste a.n.g.',
  },
  {
    code: '9111',
    nl: 'Activiteiten van bibliotheken',
    fr: 'Activités des bibliothèques',
    en: 'Library activities',
    de: 'Bibliotheken',
  },
  {
    code: '9112',
    nl: 'Activiteiten van archieven',
    fr: 'Activités des centres d’archives',
    en: 'Archive activities',
    de: 'Archive',
  },
  {
    code: '9121',
    nl: 'Activiteiten van musea en collecties',
    fr: 'Activités des musées et collections',
    en: 'Museum and collection activities',
    de: 'Museen und Sammlungen',
  },
  {
    code: '9122',
    nl: 'Activiteiten van historische locaties en monumenten',
    fr: 'Activité des sites et monuments historiques',
    en: 'Historical site and monument activities',
    de: 'Historische Stätten und Denkmäler',
  },
  {
    code: '9130',
    nl: 'Instandhouding, restauratie en andere ondersteunende activiteiten voor cultureel erfgoed',
    fr: 'Conservation, restauration et autres activités de soutien pour la préservation du patrimoine culturel',
    en: 'Conservation, restoration and other support activities for cultural heritage',
    de: 'Konservierung, Restaurierung und sonstige unterstützende Tätigkeiten für das kulturelle Erbe',
  },
  {
    code: '9141',
    nl: 'Activiteiten van botanische tuinen en dierentuinen',
    fr: 'Activités de gestion de jardins botaniques et zoologiques',
    en: 'Botanical and zoological garden activities',
    de: 'Botanische und zoologische Gärten',
  },
  {
    code: '9142',
    nl: 'Beheer en instandhouding van natuurreservaten',
    fr: 'Activités de gestion de réserves naturelles',
    en: 'Nature reserve activities',
    de: 'Naturparks',
  },
  {
    code: '9200',
    nl: 'Activiteiten van loterijen en kansspelen',
    fr: 'Activités de jeux d’argent et de paris',
    en: 'Gambling and betting activities',
    de: 'Spiel-, Wett- und Lotteriewesen',
  },
  {
    code: '9311',
    nl: 'Exploitatie van sportaccommodaties',
    fr: 'Gestion d’installations sportives',
    en: 'Operation of sports facilities',
    de: 'Betrieb von Sportanlagen',
  },
  {
    code: '9312',
    nl: 'Activiteiten van sportclubs',
    fr: 'Activités des clubs de sports',
    en: 'Activities of sports clubs',
    de: 'Sportvereine',
  },
  {
    code: '93121',
    nl: 'Activiteiten van voetbalclubs',
    fr: 'Activités des clubs de football',
    en: 'Activities of football clubs',
    de: 'Tätigkeiten von Fußballclubs',
  },
  {
    code: '93122',
    nl: 'Activiteiten van tennisclubs',
    fr: 'Activités des clubs de tennis',
    en: 'Activities of tennis clubs',
    de: 'Tätigkeiten von Tennisclubs',
  },
  {
    code: '93123',
    nl: 'Activiteiten van overige balsportclubs',
    fr: "Activités des clubs d'autres sports de ballon",
    en: 'Activities of other ball sports clubs',
    de: 'Tätigkeiten von sonstigen Ballsportclubs',
  },
  {
    code: '93124',
    nl: 'Activiteiten van wielerclubs',
    fr: 'Activités des clubs cyclistes',
    en: 'Activities of cycling clubs',
    de: 'Tätigkeiten von Fahrradclubs',
  },
  {
    code: '93125',
    nl: 'Activiteiten van vechtsportclubs',
    fr: 'Activités des clubs de sports de combat',
    en: 'Activities of martial art clubs',
    de: 'Tätigkeiten von Kampfsportclubs',
  },
  {
    code: '93126',
    nl: 'Activiteiten van watersportclubs',
    fr: 'Activités des clubs de sports nautiques',
    en: 'Activities of water sports clubs',
    de: 'Tätigkeiten von Wassersportclubs',
  },
  {
    code: '93127',
    nl: 'Activiteiten van paardensportclubs',
    fr: 'Activités des clubs équestres',
    en: 'Activities of equestrian sports clubs',
    de: 'Tätigkeiten von Pferdesportclubs',
  },
  {
    code: '93128',
    nl: 'Activiteiten van atletiekclubs',
    fr: "Activités des clubs d'athlétisme",
    en: 'Activities of athletic clubs',
    de: 'Tätigkeiten von Leichtathletikclubs',
  },
  {
    code: '93129',
    nl: 'Activiteiten van overige sportclubs',
    fr: "Activités des clubs d'autres sports",
    en: 'Activities of other sports clubs',
    de: 'Tätigkeiten von sonstigen Sportclubs',
  },
  {
    code: '9313',
    nl: 'Activiteiten van fitnesscentra',
    fr: 'Activités des centres de fitness',
    en: 'Activities of fitness centres',
    de: 'Fitnesszentren',
  },
  {
    code: '9319',
    nl: 'Sportactiviteiten, n.e.g.',
    fr: 'Activités sportives n.c.a.',
    en: 'Sports activities n.e.c.',
    de: 'Erbringung von Dienstleistungen des Sports a. n. g.',
  },
  {
    code: '93191',
    nl: 'Activiteiten van sportbonden en -federaties',
    fr: 'Activités des ligues et des fédérations sportives',
    en: 'Activities of sports leagues and federations',
    de: 'Tätigkeiten von Sportvereinigungen und Sportverbänden',
  },
  {
    code: '93192',
    nl: 'Activiteiten van zelfstandig werkende sportbeoefenaars',
    fr: 'Activités des sportifs indépendants',
    en: 'Activities of self-employed sportspeople',
    de: 'Tätigkeiten von selbständigen Sportlern',
  },
  {
    code: '93199',
    nl: 'Overige sportactiviteiten, n.e.g.',
    fr: 'Autres activités sportives n.c.a.',
    en: 'Other sports activities n.e.c.',
    de: 'Sonstige sportliche Tätigkeiten a.n.g.',
  },
  {
    code: '9321',
    nl: 'Activiteiten van pret- en themaparken',
    fr: 'Activités des parcs d’attractions et parcs à thèmes',
    en: 'Activities of amusement parks and theme parks',
    de: 'Vergnügungs- und Themenparks',
  },
  {
    code: '9329',
    nl: 'Ontspanning en recreatie, n.e.g.',
    fr: 'Activités récréatives et de loisirs n.c.a.',
    en: 'Amusement and recreation activities n.e.c.',
    de: 'Erbringung von sonstigen Dienstleistungen der Unterhaltung und der Erholung a. n. g.',
  },
  {
    code: '93291',
    nl: 'Exploitatie van kermisattracties',
    fr: 'Exploitation d’attractions foraines',
    en: 'Operation of fairground amusement equipment',
    de: 'Betrieb von Jahrmarktattraktionen',
  },
  {
    code: '93292',
    nl: 'Exploitatie van snooker- en biljartzalen',
    fr: 'Exploitation de salles de billard et de snooker',
    en: 'Operation of billiard and snooker halls',
    de: 'Betrieb von Snooker- und Billardsälen',
  },
  {
    code: '93293',
    nl: 'Exploitatie van recreatiedomeinen',
    fr: 'Exploitation de domaines récréatifs',
    en: 'Operation of recreational areas',
    de: 'Betrieb von Freizeitdomänen',
  },
  {
    code: '93299',
    nl: 'Overige recreatie- en ontspanningsactiviteiten, n.e.g.',
    fr: 'Autres activités récréatives et de loisirs n.c.a.',
    en: 'Other amusement and recreation activities n.e.c.',
    de: 'Sonstige Freizeitaktivitäten a.n.g.',
  },
  {
    code: '9411',
    nl: 'Activiteiten van bedrijfs- en werkgeversorganisaties',
    fr: "Activités des organisations patronales et d'entreprises",
    en: 'Activities of business and employers membership organisations',
    de: 'Wirtschafts- und Arbeitgeberverbände',
  },
  {
    code: '9412',
    nl: 'Activiteiten van beroepsorganisaties',
    fr: 'Activités des organisations professionnelles',
    en: 'Activities of professional membership organisations',
    de: 'Berufsorganisationen',
  },
  {
    code: '9420',
    nl: 'Activiteiten van vakbonden',
    fr: 'Activités des syndicats de salariés',
    en: 'Activities of trade unions',
    de: 'Arbeitnehmervereinigungen',
  },
  {
    code: '9491',
    nl: 'Activiteiten van religieuze organisaties',
    fr: 'Activités des organisations religieuses',
    en: 'Activities of religious organisations',
    de: 'Kirchliche und sonstige religiöse Vereinigungen',
  },
  {
    code: '9492',
    nl: 'Activiteiten van politieke organisaties',
    fr: 'Activités des organisations politiques',
    en: 'Activities of political organisations',
    de: 'Politische Parteien und Vereinigungen',
  },
  {
    code: '9499',
    nl: 'Activiteiten van overige verenigingen, n.e.g.',
    fr: 'Activités des organisations associatives n.c.a.',
    en: 'Activities of other membership organisations n.e.c.',
    de: 'Sonstige Interessenvertretungen und Vereinigungen a. n. g.',
  },
  {
    code: '94991',
    nl: 'Verenigingen op het vlak van jeugdwerk',
    fr: 'Associations de jeunesse',
    en: 'Activities of  youth associations',
    de: 'Jugendvereinigungen',
  },
  {
    code: '94992',
    nl: 'Verenigingen en bewegingen voor volwassenen',
    fr: 'Associations et mouvements pour adultes',
    en: 'Associations for adults',
    de: 'Vereinigungen und Bewegungen für Erwachsene',
  },
  {
    code: '94993',
    nl: 'Verenigingen op het vlak van ziektepreventie en gezondheidsbevordering',
    fr: 'Associations pour la prévention de la santé',
    en: 'Activities of illness prevention and health promotion associations',
    de: 'Vereinigungen zur Gesundheitssorge und Gesundheitsprävention',
  },
  {
    code: '94994',
    nl: 'Verenigingen op het vlak van milieu en mobiliteit',
    fr: "Associations pour l'environnement et la mobilité",
    en: 'Activities of environmental and mobility associations',
    de: 'Vereinigungen für Umwelt und Mobilität',
  },
  {
    code: '94995',
    nl: 'Verenigingen op het vlak van ontwikkelingssamenwerking',
    fr: 'Associations pour la coopération au développement',
    en: 'Activities of associations for development cooperation',
    de: 'Vereinigungen für Entwicklungszusammenarbeit',
  },
  {
    code: '94999',
    nl: 'Overige verenigingen, n.e.g.',
    fr: 'Autres associations n.c.a.',
    en: 'Activities of other associations n.e.c.',
    de: 'Interessenvertretungen a.n.g.',
  },
  {
    code: '9510',
    nl: 'Reparatie en onderhoud van computers en communicatieapparatuur',
    fr: 'Réparation et entretien d’ordinateurs et d’équipements de communication',
    en: 'Repair and maintenance of computers and communication equipment',
    de: 'Reparatur und Instandhaltung von Datenverarbeitungs- und Telekommunikationsgeräten',
  },
  {
    code: '9521',
    nl: 'Reparatie en onderhoud van consumentenelektronica',
    fr: 'Réparation et entretien de produits électroniques grand public',
    en: 'Repair and maintenance of consumer electronics',
    de: 'Reparatur und Instandhaltung von Geräten der Unterhaltungselektronik',
  },
  {
    code: '9522',
    nl: 'Reparatie en onderhoud van huishoudapparaten en van werktuigen voor gebruik in huis en tuin',
    fr: 'Réparation et entretien d’appareils électroménagers et d’équipements pour la maison et le jardin',
    en: 'Repair and maintenance of household appliances and home and garden equipment',
    de: 'Reparatur und Instandhaltung von elektrischen Haushaltsgeräten und Gartengeräten',
  },
  {
    code: '9523',
    nl: 'Reparatie en onderhoud van schoeisel en lederwaren',
    fr: 'Réparation et entretien de chaussures et d’articles en cuir',
    en: 'Repair and maintenance of footwear and leather goods',
    de: 'Reparatur und Instandhaltung von Schuhen und Lederwaren',
  },
  {
    code: '9524',
    nl: 'Reparatie en onderhoud van meubelen en stoffering',
    fr: 'Réparation et entretien de meubles et d’équipements du foyer',
    en: 'Repair and maintenance of furniture and home furnishings',
    de: 'Reparatur und Instandhaltung von Möbeln und Einrichtungsgegenständen',
  },
  {
    code: '9525',
    nl: 'Reparatie en onderhoud van uurwerken en sieraden',
    fr: 'Réparation et entretien d’articles d’horlogerie et de bijouterie',
    en: 'Repair and maintenance of watches, clocks and jewellery',
    de: 'Reparatur und Instandhaltung von Uhren und Schmuck',
  },
  {
    code: '9529',
    nl: 'Reparatie en onderhoud van consumentenartikelen, n.e.g.',
    fr: 'Réparation et entretien d’autres biens personnels ou domestiques n.c.a.',
    en: 'Repair and maintenance of personal and household goods n.e.c.',
    de: 'Reparatur und Instandhaltung von Gebrauchsgütern a. n. g.',
  },
  {
    code: '9531',
    nl: 'Reparatie en onderhoud van motorvoertuigen',
    fr: 'Réparation et entretien d’automobiles',
    en: 'Repair and maintenance of motor vehicles',
    de: 'Reparatur und Instandhaltung von Kraftwagen',
  },
  {
    code: '95311',
    nl: "Algemeen onderhoud en reparatie van auto's en lichte bestelwagens (<= 3,5 ton)",
    fr: 'Entretien et réparation général de voitures et de véhicules légers (<= 3,5 tonnes)',
    en: 'General repair and maintenance of cars and light motor vehicles (<= 3,5 tons)',
    de: 'Wartung und Reparatur von Kraftfahrzeugen mit einem Gesamtgewicht von 3,5 t oder weniger',
  },
  {
    code: '95312',
    nl: 'Algemeen onderhoud en reparatie van overige motorvoertuigen (> 3,5 ton)',
    fr: "Entretien et réparation général d'autres véhicules automobiles (> 3,5 tonnes)",
    en: 'General maintenance and repair of other motor vehicles (> 3,5 tons)',
    de: 'Allgemeine Instandhaltung und Reparatur von sonstigen Kraftfahrzeugen von mehr als 3,5 t',
  },
  {
    code: '95313',
    nl: 'Reparatie en montage van specifieke auto-onderdelen',
    fr: 'Réparation et montage de parties spécifiques de véhicules automobiles',
    en: 'Repair and assembly of specific parts of motor vehicles',
    de: 'Reparatur und Montage von spezifischen Kraftfahrzeugteilen',
  },
  {
    code: '95314',
    nl: 'Carrosserieherstelling (inclusief spuiten en verven)',
    fr: 'Réparation de carrosseries (y compris la peinture)',
    en: 'Bodywork repair (including painting)',
    de: 'Reparatur von Karosserien (einschließlich spritzen und färben)',
  },
  {
    code: '95315',
    nl: 'Bandenservicebedrijven',
    fr: 'Services spécialisés relatifs au pneu',
    en: 'Specialised services for tyres',
    de: 'Reifenspezifische Dienstleistungen',
  },
  {
    code: '95316',
    nl: 'Wassen en poetsen van motorvoertuigen',
    fr: 'Lavage de véhicules automobiles',
    en: 'Washing of motor vehicles',
    de: 'Waschen und Reinigen von Kraftfahrzeugen',
  },
  {
    code: '95319',
    nl: 'Onderhoud en reparatie van motorvoertuigen, n.e.g.',
    fr: 'Entretien et réparation de véhicules automobiles n.c.a.',
    en: 'Maintenance and repair of motor vehicles n.e.c.',
    de: 'Wartung und Reparatur von Kraftfahrzeugen',
  },
  {
    code: '9532',
    nl: 'Reparatie en onderhoud van motorfietsen',
    fr: 'Réparation et entretien de motocycles',
    en: 'Repair and maintenance of motorcycles',
    de: 'Reparatur und Instandhaltung von Krafträdern',
  },
  {
    code: '9540',
    nl: 'Bemiddelingsactiviteiten in verband met reparatie en onderhoud van computers, consumentenartikelen, motorvoertuigen en motorfietsen',
    fr: 'Activités de service d’intermédiation pour la réparation et l’entretien d’ordinateurs, de biens personnels et domestiques et d’automobiles et motocycles',
    en: 'Intermediation service activities for repair and maintenance of computers, personal and household goods, and motor vehicles and motorcycles',
    de: 'Vermittlungstätigkeiten für die Reparatur und Instandhaltung von Datenverarbeitungsgeräten und Gebrauchsgütern sowie von Kraftwagen und Krafträdern',
  },
  {
    code: '9610',
    nl: 'Wassen en chemisch reinigen van textiel en bontproducten',
    fr: 'Blanchisserie-teinturerie',
    en: 'Washing and cleaning of textile and fur products',
    de: 'Wäscherei und chemische Reinigung',
  },
  {
    code: '96101',
    nl: 'Activiteiten van industriële wasserijen',
    fr: 'Activités des blanchisseries industrielles',
    en: 'Activities of industrial laundries',
    de: 'Tätigkeiten von industriellen Wäschereien',
  },
  {
    code: '96102',
    nl: 'Activiteiten van wasserettes en wassalons ten behoeve van particulieren',
    fr: 'Activités des blanchisseries et des salons-lavoirs pour particuliers',
    en: 'Activities of laundries for private individuals',
    de: 'Tätigkeiten von Waschsalons und Wäschereien für Privatpersonen',
  },
  {
    code: '9621',
    nl: 'Kappers- en barbiersactiviteiten',
    fr: 'Coiffure et activités de barbier',
    en: 'Hairdressing and barber activities',
    de: 'Frisör- und Barbiersalons',
  },
  {
    code: '9622',
    nl: 'Schoonheidsverzorging en andere schoonheidsbehandelingen',
    fr: 'Soins esthétiques et autres activités de traitement esthétique',
    en: 'Beauty care and other beauty treatment activities',
    de: 'Kosmetiksalons und ähnliche Schönheitsbehandlungen',
  },
  {
    code: '9623',
    nl: 'Activiteiten van kuuroorden, sauna’s en stoombaden',
    fr: 'Activités de spa de jour, de sauna et de bain de vapeur',
    en: 'Day spa, sauna and steam bath activities',
    de: 'Day Spas, Saunas, Dampfbäder',
  },
  {
    code: '9630',
    nl: 'Begrafeniswezen en aanverwante activiteiten',
    fr: 'Services funéraires et activités connexes',
    en: 'Funeral and related activities',
    de: 'Bestattungswesen',
  },
  {
    code: '96301',
    nl: 'Uitvaartverzorging',
    fr: 'Soins funéraires',
    en: 'Funeral activities',
    de: 'Totenpflege',
  },
  {
    code: '96302',
    nl: 'Beheer van kerkhoven en activiteiten van crematoria',
    fr: 'Gestion des cimetières et services des crématoriums',
    en: 'Operation of cemeteries and crematorium services',
    de: 'Verwaltung von Friedhöfen und Krematorien',
  },
  {
    code: '9640',
    nl: 'Bemiddelingsactiviteiten op het gebied van persoonlijke dienstverlening',
    fr: 'Activités de service d’intermédiation pour des services aux personnes',
    en: 'Intermediation service activities for personal services',
    de: 'Vermittlungstätigkeiten für überwiegend persönliche Dienstleistungen',
  },
  {
    code: '9691',
    nl: 'Huishoudelijke persoonlijke dienstverlening',
    fr: 'Activités d’offre de services domestiques aux personnes',
    en: 'Provision of domestic personal service activities',
    de: 'Erbringung von haushaltsbezogenen Dienstleistungen',
  },
  {
    code: '9699',
    nl: 'Overige persoonlijke dienstverlening, n.e.g.',
    fr: 'Autres activités de service aux personnes n.c.a.',
    en: 'Other personal service activities n.e.c.',
    de: 'Erbringung von sonstigen überwiegend persönlichen Dienstleistungen a. n. g.',
  },
  {
    code: '96991',
    nl: 'Contactbemiddelingsbureaus en dergelijke',
    fr: 'Services de rencontres',
    en: 'Dating services',
    de: 'Kontaktbörsen und Änliches',
  },
  {
    code: '96992',
    nl: 'Plaatsen van tatoeages en piercings',
    fr: 'Services de tatouage et de piercing',
    en: 'Tattooing and piercing services',
    de: 'Tätowierung und Piercing',
  },
  {
    code: '96993',
    nl: 'Diensten in verband met de verzorging van huisdieren, m.u.v. veterinaire diensten',
    fr: 'Services de soins autres que vétérinaires pour animaux de compagnie',
    en: 'Care services for pet animals, other than veterinary',
    de: 'Dienstleistungen im Bereich der Haustierpflege, mit Ausnahme von Veterinärdiensten',
  },
  {
    code: '96994',
    nl: 'Africhten van huisdieren',
    fr: 'Activités de dressage pour animaux de compagnie',
    en: 'Training of pet animals',
    de: 'Haustierdressur',
  },
  {
    code: '96995',
    nl: 'Pensions voor huisdieren',
    fr: "Hébergement d'animaux de compagnie",
    en: 'Boarding of pet animals',
    de: 'Unterbringung von Haustieren',
  },
  {
    code: '96999',
    nl: 'Overige persoonlijke diensten',
    fr: 'Autres services personnels',
    en: 'Other miscellaneous personal service activities',
    de: 'Sonstige persönliche Dienstleistungen',
  },
  {
    code: '9700',
    nl: 'Activiteiten van huishoudens als werkgever van huishoudelijk personeel',
    fr: 'Activités des ménages en tant qu’employeurs de personnel domestique',
    en: 'Activities of households as employers of domestic personnel',
    de: 'Private Haushalte mit Hauspersonal',
  },
  {
    code: '9810',
    nl: 'Niet-gedifferentieerde productie van goederen door particuliere huishoudens voor eigen gebruik',
    fr: 'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
    en: 'Undifferentiated goods-producing activities of private households for own use',
    de: 'Herstellung von Waren durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
  },
  {
    code: '9820',
    nl: 'Niet-gedifferentieerde productie van diensten door particuliere huishoudens voor eigen gebruik',
    fr: 'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
    en: 'Undifferentiated service-producing activities of private households for own use',
    de: 'Erbringungen von Dienstleistungen durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
  },
  {
    code: '9900',
    nl: 'Activiteiten van extraterritoriale organisaties en instanties',
    fr: 'Activités des organisations et organismes extraterritoriaux',
    en: 'Activities of extraterritorial organisations and bodies',
    de: 'Exterritoriale Organisationen und Körperschaften',
  },
]
